const _ = {
  BR_ACCESS_TOKEN_INVALID: "Invalid login account",
  BR_ACCOUNT_BANNED: "Account banned",
  BR_ACCOUNT_NOT_EXIST: "Account does not exist",
  BR_ACCOUNT_NOT_FOUND: "Account does not exist",
  BR_ACCUMULATED_DATA_LENGTH_LIMIT: "Error: data storage sheet name cannot exceed 30 characters",
  BR_ACTIVATION_CODE_NOT_EXIST: "Activation code does not exist",
  BR_ACTIVATION_CODE_USED: "The Activation Code has already been used",
  BR_ACTIVATION_INVALIDE_FORMAT: "Invalid Activation Code format",
  BR_ACTIVATION_INVALIDE_LENGHTH: "Invalid Activation Code length",
  BR_BINDINGING_FAILURE: "Bind failed. Please try again.",
  BR_CONTAINS_DIRTY_WORDS: "String contains sensitive words",
  BR_CONTAINS_SPECIAL_CHARS: "Chars don't meet requirements",
  BR_DISABLE_LOGIN: "Login not allowed",
  BR_DRECTORY_NOT_PREPARED: "Log creation failed",
  BR_DUPLICATE_LEADERBOARD_NAME: "Leaderboard name already existed, please use another one",
  BR_DUPLICATE_NICKNAME: "Duplicate nickname",
  BR_DUPLICATE_SHEET_NAME: "Sheet name already exsited, please use another one",
  BR_EXTENSION_DULICATED_NAME: "Duplicate plug-in",
  BR_EXTENSION_NOT_FOUND: "Plug-in not found",
  BR_FF_COST_OVERFLOW: "Maximum cost reached",
  BR_FF_EXPORT_INVALID_ENTITY: "Failed to export the scene object",
  BR_FF_EXPORT_NO_SCENE: "No main scene found ",
  BR_FF_EXPORT_NO_WORKFLOW: "No global setting found",
  BR_FF_LEADERBOARD_COUNT_LIMIT: "Leaderboard number limit",
  BR_FF_SHEET_COUNT_LIMIT: "Data Table number limit reached",
  BR_FF_TELEPORTER_UNPAIRED: "Mismatched teleporting object",
  BR_FF_WEB_PROXY_HTTP_FAILED: "Server send back failed",
  BR_FF_WORKSHOP_INVALID_EXPORT_SETTINGS_LENGTH: "The exported file size of the map exceeds 2.5 MB. Please edit and try again later.",
  BR_FF_WORKSHOP_INVALID_MAP_COVER_LENGTH: "The cover file size of the map exceeds 10 MB. Please edit and try again later.",
  BR_FF_WORKSHOP_INVALID_MAX_MEMBER_NUM: "The max player number of the map exceeds 30. Please edit and try again later.",
  BR_FF_WORKSHOP_INVALID_OPEN_ATTRIBUTES_EXT_LENGTH: "The parameter file size of the map exceeds 2 MB. Please edit and try again later.",
  BR_FF_WORKSHOP_INVALID_PROJECT_SETTINGS_LENGTH: "The project file size of the map exceeds 2 MB. Please edit and try again later.",
  BR_FILE_EXISTED: "File already exists",
  BR_FILE_IMPORT_ERROR: "File import unsuccessful",
  BR_FILE_NOT_FOUND: "File not found",
  BR_FILE_OUT_OF_ASSET_FOLDER: "File cannot be saved outside the Assets log",
  BR_FILE_OUT_OF_PROJECT_FOLDER: "File cannot be saved outside the project log",
  BR_GAME_ACCOUNT_ALREADY_BOUND: "Game account already bound",
  BR_GAME_ACCOUNT_NOT_BOUND: "Game account is not bound",
  BR_GAME_ACCOUNT_NOT_FOUND: "Game account does not exist",
  BR_INVALID_ARGUMENTS: "Invalid parameter",
  BR_INVALID_FILE: "File damaged",
  BR_IPC_CLOSED: "IPC server is closed",
  BR_IPC_CONNECTED: "IPC server connected",
  BR_IPC_CREATE_CLIENT_FAILED: "IPC server failed to create the client",
  BR_IPC_IN_PROGRESS: "IPC server is connecting",
  BR_IPC_SAME_ADDR_NOT_ALLOWED: "Duplicate IPC server location",
  BR_LEADERBOARD_NAME_LENGTH_LIMIT: "Error, sheet name no more than 30 characters",
  BR_NICKNAME_ILLEGAL: "Invalid nickname. Please change.",
  BR_NICKNAME_OCCUPIED: "Nickname already taken. Please change.",
  BR_NOT_IMPLEMENTED: "Unimplemented method",
  BR_NOT_IN_FOLDER: "File not in project",
  BR_OK: "No errors",
  BR_PROJECT_CORRUPTED: "This file has been corrupted.",
  BR_PROJECT_EXISTED: "Project already exists",
  BR_PROJECT_FOLDER_NOT_EMPTY: "Project log is not empty",
  BR_PROJECT_INTERNAL_ONLY: "Only for internal use.",
  BR_PROJECT_NOT_FOUND: "Project does not exist",
  BR_PROJECT_NOT_OPENED: "Project did not open",
  BR_SETTINGS_SIZE_INVALID: "Setting file length is illegal",
  BR_SHAREDATA_KEY_NOT_EXIST: "Shared data index does not exist",
  BR_SHEET_NAME_LENGTH_LIMIT: "Error: data storage sheet name cannot exceed 30 characters",
  BR_STR_ENCODE_INVALID: "Invalid string encoding",
  BR_STR_LENGTH_INVALID: "Length error",
  BR_USER_CANCEL: "Cancelled by user",
  ECA_DES: "Customize which UIs to turn on/off",
  ECA_DES_1: "Add any amount of weapon, items, or armor for players",
  ECA_NAME: "Turn UI on/off",
  ECA_NAME_1: "Add object",
  FE_00_LOOT_SIGHT_TYPE: "Loot point magnification type",
  FE_00_LOOT_WEAPON_TYPE: "Loot point weapon type",
  FE_00_MOVEOBJECT_MOTION_TYPE: "Mode of the moving object",
  FE_00_M_WS_AITYPE: "AI entity",
  FE_00_ONCLICK: "when the button is clicked",
  FE_00_RESETABLE_ENTITY: "Resettable entity",
  FE_00_T_WS_MUSICTYPE_DRUM_TITLE: "Drum key type",
  FE_00_T_WS_MUSICTYPE_L1_TITLE: "Synthesizer Key Type A",
  FE_00_T_WS_MUSICTYPE_L2_TITLE: "Synthesizer Key Type B",
  FE_00_T_WS_MUSICTYPE_L3_TITLE: "Synthesizer Key Type C",
  FE_00_T_WS_MUSICTYPE_PIANO_TITLE: "Music key type",
  FE_0_B_BORDER_COLOR: "Border Color",
  FE_0_B_BORDER_TEXTURE: "Border Texture",
  FE_0_B_BUILD_FAILED_CONTENT: "Failed to generate the project",
  FE_0_B_BUILD_SUCCESS_CONTENT: "Successfully built",
  FE_0_B_BUTTON_PUBLISH: "Publish",
  FE_0_B_CUSTOMPROP_COLOR_SELECTED: "Color",
  FE_0_B_CUSTOMPROP_NOTADDED: "No properties added",
  FE_0_B_CUSTOMPROP_OPTION: "Options",
  FE_0_B_CUSTOMPROP_TYPE_SELECTED: "Select a type",
  FE_0_B_ECA_MORE: "More...",
  FE_0_B_ECA_TIP_SAVE_SELECT: "This scenery has not been saved. Unable to select objects.",
  FE_0_B_ECA_TIP_SELECT: "This object cannot be selected.",
  FE_0_B_ENSURE_CLOSE_PUBLISH: "Confirm to exit the publishing process?",
  FE_0_B_ITEM_HIDE: "Hide-and-Seek",
  FE_0_B_PGC_IN: "Designer Exclusive",
  FE_0_B_PGC_INTERNAL: "PGCInternal",
  FE_0_B_POINT_ADD: "Add breakpoint",
  FE_0_B_POINT_CLEAR: "Clear all breakpoints",
  FE_0_B_POINT_DELETE: "Delete breakpoint",
  FE_0_B_POINT_DISABLE: "Disable breakpoint",
  FE_0_B_POINT_DISABLEALL: "Disable all breakpoints",
  FE_0_B_POINT_ENABLE: "Enable breakpoint",
  FE_0_B_POINT_ENABLEALL: "Enable all breakpoints",
  FE_0_B_ROUND_DOING: "Stage In Progress",
  FE_0_B_ROUND_END: "Stage Ends",
  FE_0_B_ROUND_START: "Stage Starts",
  FE_0_B_SURFACE_COLOR: "Surface Color",
  FE_0_B_SURFACE_TEXTURE: "Surface Texture",
  FE_0_B_TIP_CUSTOMPROP_COPIED: "Copied to clipboard",
  FE_0_B_TOOL_BUILD: "Client",
  FE_0_B_UI_ANCHOR_MAX: "AnchorMax",
  FE_0_B_UI_ANCHOR_MIN: "AnchorMin",
  FE_0_B_UI_BACKGROUNDCOLOR: "Background Color",
  FE_0_B_UI_BOTTOM: "Bottom",
  FE_0_B_UI_CENTER: "Center",
  FE_0_B_UI_CUSTOM: "Custom",
  FE_0_B_UI_HEIGHT: "Height",
  FE_0_B_UI_LETF: "Left",
  FE_0_B_UI_MIDDLE: "Middle",
  FE_0_B_UI_PIVOT: "Pivot",
  FE_0_B_UI_RATIO: "Ratio",
  FE_0_B_UI_RIGHT: "Right",
  FE_0_B_UI_STRETCH: "Stretch",
  FE_0_B_UI_TOP: "Top",
  FE_0_B_UI_TRANSFORM: "UITransform",
  FE_0_B_UI_WIDTH: "Width",
  FE_0_B_UI_X: "PosX",
  FE_0_B_UI_Y: "PosY",
  FE_0_B_WORK_EDIT_VARIABLE: "Edit variable",
  FE_0_F_ACTIVATION_ACCOUNT: "Exit Activation",
  FE_0_F_ACTIVATION_ENTERCODE: "Please enter an Activation Code",
  FE_0_F_ACTIVATION_TITLE: "Activate Your Account",
  FE_0_F_ACTIVATION_WARNING: "Confirm to exit activation?",
  FE_0_F_ATTENTION: "Attention",
  FE_0_F_BINDING_BUTTON1: "Bind",
  FE_0_F_BINDING_BUTTON2: "Bind now",
  FE_0_F_BINDING_BUTTON3: "Unbind",
  FE_0_F_BINDING_CHANGE: "Bind another account",
  FE_0_F_BINDING_CONFIRMINFO: "We detected your Free Fire account. Please check if this is the account you would like to bind.",
  FE_0_F_BINDING_NICKNAME: "Nickname: {0}",
  FE_0_F_BINDING_NOTICE: "To use Craftland Studio and access Free Fire projects, you must first bind your Free Fire account.",
  FE_0_F_BINDING_NULL: "No accounts added",
  FE_0_F_BINDING_NULL_NOTICE: "No accounts added",
  FE_0_F_BINDING_SUCCESS: "Bind successful!",
  FE_0_F_BINDING_TIPS: "Binding...",
  FE_0_F_BINDING_TITLE: "Select your login method",
  FE_0_F_BINDING_UNBIND: "Account no longer bound.",
  FE_0_F_BINDING_UNBIND_TIPS: "Unbinding account...",
  FE_0_F_BINDING_WARNING: "You must bind your Free Fire account to use Craftland Studio. Please bind your account first.",
  FE_0_F_BUTTON_CANCEL: "Cancel",
  FE_0_F_BUTTON_CONFIRM: "Confirm",
  FE_0_F_ECA_SCRIPT: "ECA Script",
  FE_0_F_INSTALL_INSERVICE: 'Craftland Studio is running. Click "confirm" to close.',
  FE_0_F_INSTALL_INSTALLING: "Installing. Please wait...",
  FE_0_F_INSTALL_SETUPLOADING: "Please wait while the program is loading...",
  FE_0_F_INSTALL_TITLE: "Install Craftland Studio",
  FE_0_F_INSTALL_VERIFING: "Verifying installer: {0}",
  FE_0_F_ITEM_BARRIER: "Barriers",
  FE_0_F_ITEM_BASIC_STRUCTURE: "Basic Structure",
  FE_0_F_ITEM_BUILDING: "Architecture",
  FE_0_F_ITEM_CAR: "Vehicles",
  FE_0_F_ITEM_COMMON: "Most Used",
  FE_0_F_ITEM_COMMON_NOTI: "No most used objects. Right click to add.",
  FE_0_F_ITEM_CONTAINER: "Container Objects",
  FE_0_F_ITEM_DECORATION: "Decorations",
  FE_0_F_ITEM_FENCE: "Fences and Walls",
  FE_0_F_ITEM_FURNITURE: "Furniture",
  FE_0_F_ITEM_GAMEPLAY: "Gameplay Objects",
  FE_0_F_ITEM_HISTORY: "Recently Used",
  FE_0_F_ITEM_HISTORY_DELETENOTI: "Confirm to clear the Recently Used list?",
  FE_0_F_ITEM_HISTORY_NOTI: "No recently used objects. Right click to add.",
  FE_0_F_ITEM_HUGEHOUSE: "Large House",
  FE_0_F_ITEM_INTERACTIVE: "Interactives",
  FE_0_F_ITEM_LOOT_AMMO: "Ammo",
  FE_0_F_ITEM_LOOT_AR: "Rifle",
  FE_0_F_ITEM_LOOT_ARMOR: "Armor & Backpack",
  FE_0_F_ITEM_LOOT_BAG: "Backpack",
  FE_0_F_ITEM_LOOT_FRESH: "Refresh units",
  FE_0_F_ITEM_LOOT_GROUP: "Item Group {0}",
  FE_0_F_ITEM_LOOT_GROUPFRESH: "Refresh groups",
  FE_0_F_ITEM_LOOT_HELMET: "Helmet",
  FE_0_F_ITEM_LOOT_HG: "Pistol",
  FE_0_F_ITEM_LOOT_MAGEZINE: "Magazine",
  FE_0_F_ITEM_LOOT_MELEE: "Melee",
  FE_0_F_ITEM_LOOT_MUZZLE: "Muzzle",
  FE_0_F_ITEM_LOOT_NOTRANDOM: "Guaranteed",
  FE_0_F_ITEM_LOOT_PARTS: "Attachment",
  FE_0_F_ITEM_LOOT_SG: "Shotgun",
  FE_0_F_ITEM_LOOT_SMG: "SMG",
  FE_0_F_ITEM_LOOT_SNG: "Sniper",
  FE_0_F_ITEM_LOOT_VEST: "Vest",
  FE_0_F_ITEM_LOOT_WEAPON: "Weapon",
  FE_0_F_ITEM_MIDHOUSE: "Medium House",
  FE_0_F_ITEM_MODENEED: "Mode-essentials",
  FE_0_F_ITEM_MUSICKEY: "Musical Objects",
  FE_0_F_ITEM_OTHERS: "Others",
  FE_0_F_ITEM_PAD_NUM: "Total: {0}",
  FE_0_F_ITEM_PIPE: "Pipes",
  FE_0_F_ITEM_PLANT: "Plants",
  FE_0_F_ITEM_PORTAL_PROPERTY: "Link a portal",
  FE_0_F_ITEM_SPAWN_PROPERTY: "Max. players per portal",
  FE_0_F_ITEM_STREETSCAPE: "Street Decorations",
  FE_0_F_ITEM_STRUCTURE: "Structural Objects",
  FE_0_F_ITEM_TRIGGER: "Triggers",
  FE_0_F_ITEM_TYRE_PROPERTY: "Bounce distance",
  FE_0_F_LANGUAGE_CNTRA: "Traditional Chinese",
  FE_0_F_LANGUAGE_EN: "English",
  FE_0_F_LAUNCH_ACCOUNTCHECK: "Verifying account information",
  FE_0_F_LAUNCH_SETTING: "Initiating settings",
  FE_0_F_LAUNCH_UPDATE: "Updating version",
  FE_0_F_LAUNCH_VERSIONCHECK: "Checking version",
  FE_0_F_LOGIN: "Login",
  FE_0_F_LOGIN_CANCEL: "Login failed. The user has canceled the login.",
  FE_0_F_LOGIN_PRIVACY_POLICY: "Privacy Policy",
  FE_0_F_LOGIN_SERVICE: "Terms of Service",
  FE_0_F_LOGIN_TITLE: "Please select your login method",
  FE_0_F_LOGOUT_WRANING: "Confirm to logout?",
  FE_0_F_NAME: "Name",
  FE_0_F_NAME_PROPERTY: "Property",
  FE_0_F_NICKNAME_TIPS1: "Nickname changed successfully",
  FE_0_F_NOT_ADDED: "None added",
  FE_0_F_NO_CONTENT_ADDED: "No content added",
  FE_0_F_PROGRESS: "Progress {0}%",
  FE_0_F_PROJECT_ABOUT: "About",
  FE_0_F_PROJECT_ALL: "All",
  FE_0_F_PROJECT_AMEND_DATE: "Date modified",
  FE_0_F_PROJECT_BIND: "Bind Account",
  FE_0_F_PROJECT_CLOSE: "Confirm to quit?",
  FE_0_F_PROJECT_DECREMENT: "Descending",
  FE_0_F_PROJECT_DELETE_LOCAL: "Delete the local file as well",
  FE_0_F_PROJECT_DELETE_TITLE: "Delete project",
  FE_0_F_PROJECT_DELETE_WARNING: "Confirm to delete project {0}?",
  FE_0_F_PROJECT_ECA: "ECA",
  FE_0_F_PROJECT_FAVORITE: "Favorites",
  FE_0_F_PROJECT_FITEM: "fItem",
  FE_0_F_PROJECT_FOLDER: "Folder",
  FE_0_F_PROJECT_FSCENEPREFAB: "fScenePrefab",
  FE_0_F_PROJECT_IMPORT: "Import",
  FE_0_F_PROJECT_INCREMENT: "Ascending",
  FE_0_F_PROJECT_IN_SEARCH: "Searching",
  FE_0_F_PROJECT_LANSET: "Language",
  FE_0_F_PROJECT_LARGE: "Large",
  FE_0_F_PROJECT_LASTOPEN: "Last accessed: {0}",
  FE_0_F_PROJECT_LIST: "List",
  FE_0_F_PROJECT_LOADING: "Loading project",
  FE_0_F_PROJECT_LOCAL: "Open Local File",
  FE_0_F_PROJECT_LOGOUT: "Logout",
  FE_0_F_PROJECT_MANAGE: "Create a Game",
  FE_0_F_PROJECT_MEDIUM: "Medium",
  FE_0_F_PROJECT_MODE: "Mode",
  FE_0_F_PROJECT_MYPRO: "My Projects",
  FE_0_F_PROJECT_NAME: "Project Name",
  FE_0_F_PROJECT_NEW: "New Project",
  FE_0_F_PROJECT_NEW_ECA: "New ECA",
  FE_0_F_PROJECT_NEW_FOLDER: "New Folder",
  FE_0_F_PROJECT_NEW_UI: "New UI",
  FE_0_F_PROJECT_NEW_WARNING: "Project name cannot be empty.",
  FE_0_F_PROJECT_NULL_NOTICE: "Project name cannot be empty",
  FE_0_F_PROJECT_PATH: "Location",
  FE_0_F_PROJECT_PIC: "Image",
  FE_0_F_PROJECT_PREFAB: "Prefab",
  FE_0_F_PROJECT_RENAME_NOTICE: "Name cannot contain characters such as *, /, \\.",
  FE_0_F_PROJECT_RENAME_WARNING: "Name contains sensitive characters",
  FE_0_F_PROJECT_SCENE: "Scene",
  FE_0_F_PROJECT_SCRIPT: "Script",
  FE_0_F_PROJECT_SIZE: "Size",
  FE_0_F_PROJECT_SMALL: "Small",
  FE_0_F_PROJECT_SORT_BY: "Sort by",
  FE_0_F_PROJECT_TEXT: "Text",
  FE_0_F_PROJECT_TEXTURE: "Texture",
  FE_0_F_PROJECT_TREE_VIEW: "Show Dendogram",
  FE_0_F_PROJECT_UI: "UI File",
  FE_0_F_PROJECT_UPDATE: "Check for Updates",
  FE_0_F_RUNTIME_ADDBOT: "Add a Bot",
  FE_0_F_RUNTIME_CLIENT: "Client",
  FE_0_F_RUNTIME_COMMAND: "Commands",
  FE_0_F_RUNTIME_CONSOLE_COMMAND: "Executing {0} command",
  FE_0_F_RUNTIME_END_BACK: "Return to editor",
  FE_0_F_RUNTIME_END_NOTICE: "The current game progression is abnormal",
  FE_0_F_RUNTIME_END_RESTART: "Restart",
  FE_0_F_RUNTIME_END_TITLE: "Quit operation",
  FE_0_F_RUNTIME_GODMODE: "Invulnerable",
  FE_0_F_RUNTIME_KEYBOARD: "Keyboard",
  FE_0_F_RUNTIME_LOADING: "Loading game",
  FE_0_F_RUNTIME_PAUSE: "Pause",
  FE_0_F_RUNTIME_RECORD: "Logs",
  FE_0_F_RUNTIME_RECOVER: "Recover HP",
  FE_0_F_RUNTIME_RUN: "Run",
  FE_0_F_RUNTIME_STOP: "Stop",
  FE_0_F_RUNTIME_SUICIDE: "Suicide",
  FE_0_F_RUNTIME_TELEPORT: "Teleport to Spawn Point",
  FE_0_F_SCENE: "Scene {0}",
  FE_0_F_SCENE_AUTOFILL: "Auto Fill",
  FE_0_F_SCENE_EDITOR_ISO: "Iso",
  FE_0_F_SCENE_EDITOR_PERSP: "Persp",
  FE_0_F_SCENE_ITEM_COMMON: "Set as Most Used",
  FE_0_F_SCENE_ITEM_COMMON_REMOVE: "Remove from Most Used",
  FE_0_F_SCENE_ITEM_NEW: "Create in the scene",
  FE_0_F_SCENE_LOADING: "Loading scene",
  FE_0_F_SCENE_NEW: "New Scene",
  FE_0_F_SCENE_SAVE: "Save scene",
  FE_0_F_SCENE_SAVE_ALL: "Save all scenes",
  FE_0_F_SCENE_TYPE: "Map Type",
  FE_0_F_SEARCH_NOTI: "Enter a keyword to search",
  FE_0_F_SEARCH_NULL: "No results found",
  FE_0_F_TRANSFORM: "Transform",
  FE_0_F_TRANSFORM_POSITION: "Position",
  FE_0_F_TRANSFORM_ROTATION: "Rotation",
  FE_0_F_TRANSFORM_SCALE: "Scale",
  FE_0_F_UNDO_DELETE: "Continuing will delete the {0} folder. Confirm to delete?",
  FE_0_F_UNINSTALL_CONFIRM: "Confirm to uninstall Craftland Studio?",
  FE_0_F_UNINSTALL_TITLE: "Uninstall Craftland Studio",
  FE_0_F_UPDATE: "Update",
  FE_0_F_UPDATE_FAILURE: "Update failed",
  FE_0_F_UPDATE_RETRY: "Retry",
  FE_0_F_VIEW: "View",
  FE_0_HW_BUTTON_CANCEL: "Cancel",
  FE_0_HW_BUTTON_COPY: "Copy",
  FE_0_HW_BUTTON_NO: "No",
  FE_0_HW_BUTTON_OK: "Confirm",
  FE_0_HW_BUTTON_SAVE: "Save",
  FE_0_HW_BUTTON_UNSAVE: "Don't save",
  FE_0_HW_BUTTON_YES: "Yes",
  FE_0_HW_CAMERA_DISTANCE: "Distance",
  FE_0_HW_CAMERA_FOV: "Field of View",
  FE_0_HW_CAMERA_HORIZONTALANGLE: "Horizontal Angle",
  FE_0_HW_CAMERA_MODE: "Camera Mode",
  FE_0_HW_CAMERA_MODE_1: "Classic FF (Shooting)",
  FE_0_HW_CAMERA_MODE_2: "Third Person",
  FE_0_HW_CAMERA_MODE_3: "First Person (Shooting)",
  FE_0_HW_CAMERA_MODE_4: "High Angle",
  FE_0_HW_CAMERA_OFFSET: "Offset",
  FE_0_HW_CAMERA_TITLE: "Camera Settings",
  FE_0_HW_CAMERA_VERTICALANGLE: "Vertical Angle",
  FE_0_HW_CANNOT_PREVIEW: "Preview is not supported",
  FE_0_HW_CATEGORY_COMMON: "Common",
  FE_0_HW_CATEGORY_DATA: "Data",
  FE_0_HW_CATEGORY_ENTITY: "Entity",
  FE_0_HW_CATEGORY_EVENT: "Event",
  FE_0_HW_CATEGORY_EXTERNALFUNCTION: "Ex. Function",
  FE_0_HW_CATEGORY_FUNCTION: "Function",
  FE_0_HW_CATEGORY_GAME: "Game",
  FE_0_HW_CATEGORY_LOGIC: "Logic",
  FE_0_HW_CATEGORY_SEARCH: "Search",
  FE_0_HW_CATEGORY_VARIBLE: "Variable",
  FE_0_HW_CTRL_BUTTON: "Button",
  FE_0_HW_CTRL_GRAPH: "Image",
  FE_0_HW_CTRL_INPUT: "Textbox",
  FE_0_HW_CTRL_LAYOUT: "Layout",
  FE_0_HW_CTRL_PANEL: "Panel",
  FE_0_HW_CTRL_TEXT: "Text",
  FE_0_HW_CUSTOMPROP_HINT: "Tip: All changes will be applied to instances of the same type.",
  FE_0_HW_CUSTOMPROP_NAME: "Property Name",
  FE_0_HW_CUSTOMPROP_NAMEHINT: "Enter a name",
  FE_0_HW_CUSTOMPROP_SUBTITLE: "Configure {0}'s properties",
  FE_0_HW_CUSTOMPROP_TITLE: "Customize Property",
  FE_0_HW_CUSTOMPROP_TYPE: "Type",
  FE_0_HW_CUSTOMPROP_TYPEHINT: "Enter the initial value of the property",
  FE_0_HW_CUSTOMPROP_VALUE: "Initial Value",
  FE_0_HW_DATA_ALL_COMMENT: "All",
  FE_0_HW_EDITOR_FLOW: "Game",
  FE_0_HW_EDITOR_LOGIC: "Logic",
  FE_0_HW_EDITOR_SCENE: "Scenery",
  FE_0_HW_EDITOR_UI: "UI Editor",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_END: "End",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_FLOW: "Procedure Settings",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PHASE: "Stages",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PLAYER: "Player Settings",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PREPARE: "Preparation",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_ROUND: "Rounds",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_START: "Start",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_TEAM: "Team Settings",
  FE_0_HW_GAME_EDITOR_FLOWSETTING: "Procedure Settings",
  FE_0_HW_GAME_EDITOR_FLOW_END: "End",
  FE_0_HW_GAME_EDITOR_FLOW_PHASE: "Stages",
  FE_0_HW_GAME_EDITOR_FLOW_PREPARE: "Preparation",
  FE_0_HW_GAME_EDITOR_FLOW_ROUND: "Rounds",
  FE_0_HW_GAME_EDITOR_FLOW_START: "Start",
  FE_0_HW_GAME_EDITOR_INSPECT_ACTIVESKILL: "Active Skills",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGEINFLICTED: "Damage Multiplier",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGETAKEN: "Damage Taken Multiplier",
  FE_0_HW_GAME_EDITOR_INSPECT_DEFAULTEPPERCENT: "Initial EP Proportion",
  FE_0_HW_GAME_EDITOR_INSPECT_ECA: "Logic Editor",
  FE_0_HW_GAME_EDITOR_INSPECT_EPQUICKRESTORE: "Quick EP Conversion",
  FE_0_HW_GAME_EDITOR_INSPECT_ID: "ID",
  FE_0_HW_GAME_EDITOR_INSPECT_JUMPHEIGHT: "Jump Height",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXEP: "Maximum EP",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXHP: "Maximum HP",
  FE_0_HW_GAME_EDITOR_INSPECT_MOVESPEED: "Movement Speed",
  FE_0_HW_GAME_EDITOR_INSPECT_NAME: "Name",
  FE_0_HW_GAME_EDITOR_INSPECT_PASSIVESKILL: "Passive Skills",
  FE_0_HW_GAME_EDITOR_INSPECT_PLAYERNUMPERTEAM: "Players per team",
  FE_0_HW_GAME_EDITOR_INSPECT_ROUNDCOUNT: "Number of Rounds",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET10: "Time Turner (Chrono)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET11: "Riptide Rhythm (Skyler)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET12: "Xtreme Encounter (Xayne)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET13: "Healing Heartbeat (Dimitri)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET4: "Camouflage (Wukong)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET5: "Thrill of Battle (A124)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET6: "Drop the Beat (Alok)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET7: "Painted Refuge (Steffie)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET8: "Tracing Steps (Clu)",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET9: "Master of All (K)",
  FE_0_HW_GAME_EDITOR_INSPECT_TEAMNUM: "Number of teams",
  FE_0_HW_GAME_EDITOR_INSPECT_TIME: "Duration",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_BASIC: "Basic Settings",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_SKILL: "Skills Settings",
  FE_0_HW_GAME_EDITOR_INSPECT_UNLIMITEDAMMO: "Limited Ammo",
  FE_0_HW_GAME_EDITOR_PLAYERSETTING: "Player Settings",
  FE_0_HW_GAME_EDITOR_TEAMSETTING: "Team Settings",
  FE_0_HW_GENERAL_TEMPLATE: "Templates",
  FE_0_HW_GRAPH_ANYTYPE: "Any type",
  FE_0_HW_GRAPH_AS_TYPE: "As",
  FE_0_HW_GRAPH_BREAK: "Break",
  FE_0_HW_GRAPH_CALLRETURN: "Return",
  FE_0_HW_GRAPH_CONTINUE: "Continue",
  FE_0_HW_GRAPH_CREATELIST: "Define array",
  FE_0_HW_GRAPH_ELSE: "Else",
  FE_0_HW_GRAPH_ELSEIF: "Else if",
  FE_0_HW_GRAPH_EXTERNALCALL: "External Call",
  FE_0_HW_GRAPH_EXTERNAL_GET: "Get External",
  FE_0_HW_GRAPH_EXTERNAL_GET_2: "From",
  FE_0_HW_GRAPH_EXTERNAL_SET: "Set External",
  FE_0_HW_GRAPH_EXTERNAL_SET_3: "With",
  FE_0_HW_GRAPH_FLOAT: "Float",
  FE_0_HW_GRAPH_FOREACH: "Foreach",
  FE_0_HW_GRAPH_FOREACH_2: "In",
  FE_0_HW_GRAPH_FOR_INDEX: "For Index",
  FE_0_HW_GRAPH_FOR_INDEX_1: "From",
  FE_0_HW_GRAPH_FOR_INDEX_2: "To",
  FE_0_HW_GRAPH_FOR_INDEX_3: "Step",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_ACT: "Action",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_RETURN: "Return",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_VAL: "Function",
  FE_0_HW_GRAPH_FUNCTION_MUTATOR_PARA: "Parameter",
  FE_0_HW_GRAPH_GET_CUSTOM_INSP: "Obtain entity property",
  FE_0_HW_GRAPH_GLOBAL_GET: "Get Global",
  FE_0_HW_GRAPH_GLOBAL_SET: "Set Global",
  FE_0_HW_GRAPH_GLOBAL_SET_1: "With",
  FE_0_HW_GRAPH_IF: "If",
  FE_0_HW_GRAPH_INDEX: "Index",
  FE_0_HW_GRAPH_INT: "Int",
  FE_0_HW_GRAPH_LISTAPPEND: "Append List",
  FE_0_HW_GRAPH_LISTAPPEND_1: "With Value",
  FE_0_HW_GRAPH_LISTGET: "Get",
  FE_0_HW_GRAPH_LISTINSERT: "Insert List",
  FE_0_HW_GRAPH_LISTINSERT_1: "With Value",
  FE_0_HW_GRAPH_LISTINSERT_2: "At",
  FE_0_HW_GRAPH_LISTSET: "Set",
  FE_0_HW_GRAPH_LISTTYPELABEL: "List",
  FE_0_HW_GRAPH_NONE: "None selected",
  FE_0_HW_GRAPH_NULL: "Null",
  FE_0_HW_GRAPH_NUMBER: "Number",
  FE_0_HW_GRAPH_OP_AND: "And",
  FE_0_HW_GRAPH_OP_OR: "Or",
  FE_0_HW_GRAPH_PARALLELCALL: "Execute",
  FE_0_HW_GRAPH_PICK_ENTITY: "Select a scene object",
  FE_0_HW_GRAPH_PICK_WIDGET: "Select a UI control",
  FE_0_HW_GRAPH_PROPERTY_GET: "Get",
  FE_0_HW_GRAPH_PROPERTY_GET_1: "From",
  FE_0_HW_GRAPH_PROPERTY_SET: "Set",
  FE_0_HW_GRAPH_PROPERTY_SET_2: "With",
  FE_0_HW_GRAPH_RETURN_SENTENSE: "Return",
  FE_0_HW_GRAPH_SERIALCALL: "Wait",
  FE_0_HW_GRAPH_SET_CUSTOM_INSP: "Set entity property",
  FE_0_HW_GRAPH_TEXT: "Text",
  FE_0_HW_GRAPH_UNKOWN_TYPE: "Unknown type",
  FE_0_HW_INSPECT_ADD_COMPONENT: "Add component",
  FE_0_HW_INSPECT_COPY_PROP: "Copy Property Value",
  FE_0_HW_INSPECT_CUSTOMPROP: "Add Custom Property",
  FE_0_HW_INSPECT_CUSTOM_INSP: "Customize Property Group",
  FE_0_HW_INSPECT_ECA_FILE: "Block file",
  FE_0_HW_INSPECT_NAME: "Name",
  FE_0_HW_INSPECT_ONCLICK: "Click event",
  FE_0_HW_INSPECT_PASTE_PROP: "Paste Property Value",
  FE_0_HW_INSPECT_POSITION: "Position",
  FE_0_HW_INSPECT_RESET_PROP: "Reset",
  FE_0_HW_INSPECT_ROTATION: "Rotate",
  FE_0_HW_INSPECT_SCALE: "Scale",
  FE_0_HW_INSPECT_TITLE_ANCHOR: "Anchor",
  FE_0_HW_INSPECT_TITLE_BUTTON: "Button",
  FE_0_HW_INSPECT_TITLE_BUTTON_ONCLICKS: "Event Callback",
  FE_0_HW_INSPECT_TITLE_IMAGE: "Image",
  FE_0_HW_INSPECT_TITLE_INPUT: "Textbox",
  FE_0_HW_INSPECT_TITLE_LAYOUT: "Layout",
  FE_0_HW_INSPECT_TITLE_TEXT: "Text",
  FE_0_HW_INSPECT_TITLE_TRANSFORM: "Transform",
  FE_0_HW_INSPECT_TYPE: "Type",
  FE_0_HW_INSPECT_VALUE: "Initial Value",
  FE_0_HW_LABEL_FILE_NAME: "File Name",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_DESC: "Description",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_NAME: "Template Name",
  FE_0_HW_LABEL_GRAPH_VARIABLE_NAME: "Variable Name",
  FE_0_HW_LABEL_GRAPH_VARIABLE_TYPE: "Variable Type",
  FE_0_HW_LABEL_NO_ECA: "None added",
  FE_0_HW_LABEL_TRASHCAN: "Recycle Bin",
  FE_0_HW_LAYOUT_CONSOLE: "Console",
  FE_0_HW_LAYOUT_CONTROL: "Controls",
  FE_0_HW_LAYOUT_GAME: "Game",
  FE_0_HW_LAYOUT_HIERARCHY: "Hierarchy",
  FE_0_HW_LAYOUT_INSPECTOR: "Inspector",
  FE_0_HW_LAYOUT_MODEL: "Object",
  FE_0_HW_LAYOUT_OVERVIEW: "Overview",
  FE_0_HW_LAYOUT_PROJECT: "Project",
  FE_0_HW_LAYOUT_TEMPLATE: "Templates",
  FE_0_HW_MENU_ABOUT: "About",
  FE_0_HW_MENU_ACCOUNT: "Account",
  FE_0_HW_MENU_ADDCHILD: "Add Child Phase",
  FE_0_HW_MENU_ADDPHASE: "Add Phase",
  FE_0_HW_MENU_ADDROUND: "Add Round",
  FE_0_HW_MENU_ALIGN_ECA: "Align Blocks",
  FE_0_HW_MENU_API: "API",
  FE_0_HW_MENU_ASSET: "Resources",
  FE_0_HW_MENU_ASSETSTORE: "Asset Store",
  FE_0_HW_MENU_CANVAS_BG: "Background",
  FE_0_HW_MENU_CANVAS_DARK: "Dark",
  FE_0_HW_MENU_CANVAS_LIGHT: "Light",
  FE_0_HW_MENU_CLEAR_BLOCK: "Clear Block",
  FE_0_HW_MENU_COLLAPSE_ECA: "Collapse Block",
  FE_0_HW_MENU_COMMENT_ECA: "Comment",
  FE_0_HW_MENU_CONTACT: "Contact Us",
  FE_0_HW_MENU_COPY: "Copy",
  FE_0_HW_MENU_CREATE: "New",
  FE_0_HW_MENU_CUT: "Cut",
  FE_0_HW_MENU_DEBUG: "Developer Tools",
  FE_0_HW_MENU_DEFAULT: "Default",
  FE_0_HW_MENU_DEFAULT_ZOOM: "Reset Zoom",
  FE_0_HW_MENU_DELETE: "Delete",
  FE_0_HW_MENU_DELETELAYOUT: "Delete Layout",
  FE_0_HW_MENU_DUPLICATE: "Duplicate",
  FE_0_HW_MENU_EDIT: "Edit",
  FE_0_HW_MENU_EDITOR: "Editor",
  FE_0_HW_MENU_EXIT: "Exit",
  FE_0_HW_MENU_FILE: "File",
  FE_0_HW_MENU_FIT_WINDOW: "Fit",
  FE_0_HW_MENU_GRID_LINE: "Grid",
  FE_0_HW_MENU_HELP: "Help",
  FE_0_HW_MENU_LANGUAGE: "Language",
  FE_0_HW_MENU_LANG_EN: "English",
  FE_0_HW_MENU_LANG_SC: "Simplified Chinese",
  FE_0_HW_MENU_LANG_TC: "Traditional Chinese",
  FE_0_HW_MENU_LAYOUT: "Layout",
  FE_0_HW_MENU_LOCK: "Lock",
  FE_0_HW_MENU_MANUAL: "Manual",
  FE_0_HW_MENU_NEWPROJECT: "New Project",
  FE_0_HW_MENU_OPEN: "Open",
  FE_0_HW_MENU_OPENLOG: "Open Log",
  FE_0_HW_MENU_OPENPROJECT: "Open Project",
  FE_0_HW_MENU_PASTE: "Paste",
  FE_0_HW_MENU_PUBLISHPROJECT: "Publish Project",
  FE_0_HW_MENU_REDO: "Redo",
  FE_0_HW_MENU_RENAME: "Rename",
  FE_0_HW_MENU_SAVELAYOUT: "Save Layout",
  FE_0_HW_MENU_SAVEPROJECT: "Save Project",
  FE_0_HW_MENU_SAVE_BLOCK_AS_TEMP: "Add to Templates",
  FE_0_HW_MENU_SAVE_WORKSPACE: "Save",
  FE_0_HW_MENU_SETING_COMMON: "Set as Most Used",
  FE_0_HW_MENU_SETTINGS: "Settings",
  FE_0_HW_MENU_SKIN: "Theme",
  FE_0_HW_MENU_SMART_LINE: "Line Guide",
  FE_0_HW_MENU_UNCOLLAPSE_ECA: "Expand Block",
  FE_0_HW_MENU_UNDO: "Undo",
  FE_0_HW_MENU_UNLOCK: "Unlock",
  FE_0_HW_MENU_WIDE: "Landscape",
  FE_0_HW_MENU_WINDOW: "Window",
  FE_0_HW_MENU_ZOOMIN: "Zoom In",
  FE_0_HW_MENU_ZOOMOUT: "Zoom Out",
  FE_0_HW_POPUP_DELETE_FILE: "Confirm to delete file {0}?",
  FE_0_HW_POPUP_NOT_SAVE: "The information filled will not be saved if you go back. Go back anyway?",
  FE_0_HW_POPUP_NO_ATTENTION: "Don't remind me again",
  FE_0_HW_POPUP_SAVE_FILE: "You have an unsaved file. Save now?",
  FE_0_HW_POPUP_SENTENCE: "Map code copied. Invite your friends to play!",
  FE_0_HW_POPUP_TITLE_COMMENT: "Comments",
  FE_0_HW_POPUP_TITLE_ITEM: "Object Selection",
  FE_0_HW_POPUP_TITLE_MAP_SHARE: "Share map code",
  FE_0_HW_POPUP_TITLE_ON_PUB: "Publish Game",
  FE_0_HW_POPUP_TITLE_PROP: "Item Selection",
  FE_0_HW_POPUP_TITLE_PUB_SUCCESS: "Publish successful",
  FE_0_HW_POPUP_TITLE_TIP: "Tip",
  FE_0_HW_PROJECT_COMMENT_ORDER: "Comments",
  FE_0_HW_PROJECT_DATA: "Data Center",
  FE_0_HW_PROJECT_DEFAULT_ORDER: "Default Sort",
  FE_0_HW_PROJECT_GAME_DATA: "Game Data",
  FE_0_HW_PROJECT_GAME_MODE: "Game Mode",
  FE_0_HW_PROJECT_GAME_PUBLISH: "Published on",
  FE_0_HW_PROJECT_LIKE_ORDER: "Likes",
  FE_0_HW_PROJECT_PERSONAL_PAGE: "Profile",
  FE_0_HW_PROJECT_SUB_ORDER: "Favorites",
  FE_0_HW_PUBLISH_CREATOR: "Creator",
  FE_0_HW_PUBLISH_DESCRIPTION: "Description",
  FE_0_HW_PUBLISH_GAME_NAME: "Name",
  FE_0_HW_PUBLISH_MODE: "Mode",
  FE_0_HW_PUBLISH_PLAYER: "Players",
  FE_0_HW_PUBLISH_SCREENSHOT: "Screenshot",
  FE_0_HW_SEARCH_NO_RESOURCE: "Resource not found",
  FE_0_HW_SEARCH_NO_TARGET: "Target not found",
  FE_0_HW_SEARCH_PLACEHOLDER: "Search",
  FE_0_HW_TEMPLATE_NAME_1: "Base Template",
  FE_0_HW_TEMPLATE_NAME_2: "Wipe Out",
  FE_0_HW_TEMPLATE_NAME_3: "Points Grab",
  FE_0_HW_TEMPLATE_NAME_4: "Parkour",
  FE_0_HW_TEMPLATE_NAME_5: "Endurance",
  FE_0_HW_TEXT_ADD_GRAPH_TEMPLATE: "Add Block Template",
  FE_0_HW_TEXT_CUSTOM_GRAPH_TEMPLATE: "Custom Templates",
  FE_0_HW_TEXT_DEL_GRAPH_TEMPLATE: "Delete Block Template",
  FE_0_HW_TEXT_EDIT_GRAPH_TEMPLATE: "Edit Block Template",
  FE_0_HW_TEXT_OFFICIAL_GRAPH_TEMPLATE: "Official Templates",
  FE_0_HW_TIP_CHANGE_OWNERTYPE: "Confirm to change the current entity type?",
  FE_0_HW_TIP_CHOOSE_SLOT: "Please select a slot for the game.",
  FE_0_HW_TIP_COPIED: "Copied",
  FE_0_HW_TIP_COPY_CODE: "Copy the Game Code below to share your game with friends.",
  FE_0_HW_TIP_CUSTOMPROP_SAMENAME: "A property of the same type already has this name",
  FE_0_HW_TIP_CUSTOM_INSP_SAME_NAME: "A property of the same type has used this name",
  FE_0_HW_TIP_CUSTOM_INSP_STRING_LEN: "The string cannot exceed 20 characters",
  FE_0_HW_TIP_GRAPH_DELETE: "Confirm to delete Template {0}?",
  FE_0_HW_TIP_GRAPH_INPUT_DESC: "Enter a block explanation",
  FE_0_HW_TIP_GRAPH_INPUT_NAME: "Enter a template name",
  FE_0_HW_TIP_GRAPH_TEMPLATE_DESC_LEN: "Description cannot exceed {0} characters",
  FE_0_HW_TIP_GRAPH_TEMPLATE_NAME_LEN: "Template name cannot exceed {0} characters",
  FE_0_HW_TIP_INPUT: "Please enter",
  FE_0_HW_TIP_NAME_EMPTY: "File name cannot be empty",
  FE_0_HW_TIP_NOEXTERNAL: "When you do not have any externally defined variable or function, there will not be any content displayed here.",
  FE_0_HW_TIP_NO_GAME_PUBLISH: "No published game projects",
  FE_0_HW_TIP_PREPARE_PUBLISH: "Preparing publishing procedure...",
  FE_0_HW_TIP_PUBLISH_COVER: "This operation will replace the published game. Continue?",
  FE_0_HW_TIP_PUBLISH_SUCCESS: "Your game has been published!",
  FE_0_HW_TIP_SAVE_SUCCESS: "Save successful",
  FE_0_HW_TIP_TO_CLEAR_TRASHCAN: "Confirm to empty recycle bin?",
  FE_0_HW_TIP_TO_SAVE: "There are unsaved edits in your deck. Save now?",
  FE_0_HW_TIP_UNLOCK_SLOT: "Please unlock this slot in Free Fire Craftland.",
  FE_0_HW_TIP_VALUE_NOT_MATCH: "The initial value entered does not match the required type",
  FE_0_HW_TIP_WAIT_PUBLISH: "Publishing... Please wait a moment.",
  FE_0_HW_TITLE_PREVIEW: "Preview",
  FE_0_HW_TITLE_SAVE_WORK: "Save Deck",
  FE_0_HW_TITLE_SOURCE_MANAGE: "Resource Selection Preview",
  FE_0_HW_TITLE_TIP: "Tip",
  FE_0_HW_TOOL_ADSORP_BOTTOM: "Snap Bottom",
  FE_0_HW_TOOL_ADSORP_LEFT: "Snap Left",
  FE_0_HW_TOOL_ADSORP_RIGHT: "Snap Right",
  FE_0_HW_TOOL_ADSORP_TOP: "Snap Top",
  FE_0_HW_TOOL_ALIGN_BOTTOM: "Align Bottom",
  FE_0_HW_TOOL_ALIGN_LEFT: "Align Left",
  FE_0_HW_TOOL_ALIGN_RIGHT: "Align Right",
  FE_0_HW_TOOL_ALIGN_TOP: "Align Top",
  FE_0_HW_TOOL_CENTER: "Center",
  FE_0_HW_TOOL_CENTER_HOR: "Center Horizontally",
  FE_0_HW_TOOL_CENTER_VER: "Center Vertically",
  FE_0_HW_TOOL_CLIENT: "Client",
  FE_0_HW_TOOL_DISTRI_HOR: "Distribute Horizontally",
  FE_0_HW_TOOL_DISTRI_VER: "Distribute Vertically",
  FE_0_HW_TOOL_GLOBAL: "Global",
  FE_0_HW_TOOL_GRID: "Grid",
  FE_0_HW_TOOL_GROUP: "Group",
  FE_0_HW_TOOL_HAND: "Select",
  FE_0_HW_TOOL_LOCAL: "Local",
  FE_0_HW_TOOL_MOVE: "Move",
  FE_0_HW_TOOL_PIVOT: "Pivot",
  FE_0_HW_TOOL_REDO: "Redo",
  FE_0_HW_TOOL_ROTATE: "Rotate",
  FE_0_HW_TOOL_SAVE: "Save",
  FE_0_HW_TOOL_SCALE: "Scale",
  FE_0_HW_TOOL_SURF: "Surface",
  FE_0_HW_TOOL_TRANS: "Transform",
  FE_0_HW_TOOL_UNDO: "Undo",
  FE_0_HW_TOOL_UNGROUP: "Ungroup",
  FE_0_HW_TOOL_VERTEX: "Vertex",
  FE_0_HW_UI_EDITOR_INSPECT_ACTIVE: "Visible",
  FE_0_HW_UI_EDITOR_INSPECT_BACKGROUND: "Background",
  FE_0_HW_UI_EDITOR_INSPECT_CELLSIZE: "Cell Size",
  FE_0_HW_UI_EDITOR_INSPECT_COLOR: "Color",
  FE_0_HW_UI_EDITOR_INSPECT_CONSTRAINT: "Constraint",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_COLUMN: "Column Limit",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_ROW: "Row Limit",
  FE_0_HW_UI_EDITOR_INSPECT_DISABLE: "Disabled",
  FE_0_HW_UI_EDITOR_INSPECT_DOWN: "Down",
  FE_0_HW_UI_EDITOR_INSPECT_FILL_DIRECTION: "Fill Direction",
  FE_0_HW_UI_EDITOR_INSPECT_FLEX: "Flexible",
  FE_0_HW_UI_EDITOR_INSPECT_FONT: "Font",
  FE_0_HW_UI_EDITOR_INSPECT_FONTALIGN: "Text Align",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSIZE: "Size",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSTYLE: "Font",
  FE_0_HW_UI_EDITOR_INSPECT_GRID: "Grid Layout",
  FE_0_HW_UI_EDITOR_INSPECT_HIGHLIGHT: "Highlight",
  FE_0_HW_UI_EDITOR_INSPECT_HOR: "Horizontal",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT: "Left",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_DOWN: "Lower Left",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_UP: "Upper Left",
  FE_0_HW_UI_EDITOR_INSPECT_LINESPACE: "Line Space",
  FE_0_HW_UI_EDITOR_INSPECT_MAX: "Maximum",
  FE_0_HW_UI_EDITOR_INSPECT_MAXLENGTH: "Maximum Length",
  FE_0_HW_UI_EDITOR_INSPECT_MIN: "Minimum",
  FE_0_HW_UI_EDITOR_INSPECT_MULTI_LINE: "Multiple Lines",
  FE_0_HW_UI_EDITOR_INSPECT_NORMAL: "Default",
  FE_0_HW_UI_EDITOR_INSPECT_OFFSET: "Offset",
  FE_0_HW_UI_EDITOR_INSPECT_PIVOT: "Center",
  FE_0_HW_UI_EDITOR_INSPECT_PLACEHOLDER: "Placeholder",
  FE_0_HW_UI_EDITOR_INSPECT_PRESS: "Pressed",
  FE_0_HW_UI_EDITOR_INSPECT_REVERSE: "Reverse",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT: "Right",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_DOWN: "Lower Right",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_UP: "Upper Right",
  FE_0_HW_UI_EDITOR_INSPECT_SET_NATIVE: "Restore Default Size",
  FE_0_HW_UI_EDITOR_INSPECT_SINGLE_LINE: "Single Line",
  FE_0_HW_UI_EDITOR_INSPECT_SOURCE: "Source",
  FE_0_HW_UI_EDITOR_INSPECT_SPACE: "Space",
  FE_0_HW_UI_EDITOR_INSPECT_START_CORNER: "Initial Direction",
  FE_0_HW_UI_EDITOR_INSPECT_TABLE: "Fill Layout",
  FE_0_HW_UI_EDITOR_INSPECT_TEXTINPUT: "Input Text",
  FE_0_HW_UI_EDITOR_INSPECT_TYPE: "Type",
  FE_0_HW_UI_EDITOR_INSPECT_UNACTIVE: "Invisible",
  FE_0_HW_UI_EDITOR_INSPECT_UP: "Up",
  FE_0_HW_UI_EDITOR_INSPECT_VER: "Vertical",
  FE_0_HW_UI_EDITOR_INSPECT_WORDWRAP: "Linebreak",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_PARAMETERS: "The parameter and parameter type of the initial setting is not the same as the parameter type of the function. Please manually confirm that the function to be invoked is correct.",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_RETURNTYPE: "The return type of the initial setting is not the same as that of the function's. Please manually confirm that the function to be invoked is correct.",
  FE_0_HW_WARNING_LOCALVAR_NODEFINE: "Error. Undefined local variable.",
  FE_0_HW_WARNING_LOCALVAR_OOS: "Error. Local variable exceeded its scope of use.",
  FE_0_HW_WARNING_NODEFINE: "Undefined error {0}",
  FE_0_HW_WARNING_PARAM_NODEFINE: "Undefined variable error {0}",
  FE_0_HW_WARNING_RETURNNOTINFUNCTION: "You can only use the return statement inside the function",
  FE_0_HW_WARNING_TYPEASSIGN: "Incorrect type matched",
  FE_0_HW_WORK_CLEAN: "Empty Recycle Bin",
  FE_0_HW_WORK_CREATE_VARIABLE: "Create Variable",
  FE_0_M_SENCE_EDIT_NAMEERROR: "The name contains sensitive characters. Please adjust it.",
  FE_0_Q_FALSE: "FALSE",
  FE_0_Q_SENCE_DEFAULT: "(Default Scene)",
  FE_0_Q_SENCE_ENUM: "Scene Enum",
  FE_0_Q_SENCE_SETDEFAULT: "Set as default scene",
  FE_0_Q_TOKEN_EXPIRED: "Token has expired, you need to log in again.",
  FE_0_Q_TRUE: "TRUE",
  FE_0_ZZ_CLEAR: "Clear",
  FE_0_ZZ_CREATE_EMPTY: "Create Empty",
  FE_0_ZZ_ECA_NAME_NOT_EMPTY: "Variable name cannot be empty",
  FE_0_ZZ_ECA_READ_ONLY: "Read only",
  FE_0_ZZ_ECA_TO_DEFINE: "Go to Definition",
  FE_0_ZZ_ECA_VALUE_NOT_MATCH: "Initial value and constrained type do not match",
  FE_0_ZZ_GRAPH_NOT_FOUND: "No blocks found",
  FE_0_ZZ_PROJECT_FOLDER_EMPTY: "The project log should be empty.",
  FE_0_ZZ_PROJECT_PIC_SIZE: "Icon size",
  FE_0_ZZ_PROJECT_SERVER_OUT: "Connection timeout.",
  FE_0_ZZ_PROJECT_TYPE: "View",
  FE_0_ZZ_SEARCH_NO_RESULT: "No results found",
  FE_0_ZZ_SHOW_IN_EXPLORER: "Show in resources",
  FE_0_ZZ_SKYENV_AMBIENT: "Ambient Color",
  FE_0_ZZ_SKYENV_CUSTOM: "Custom",
  FE_0_ZZ_SKYENV_DARK: "Darkness",
  FE_0_ZZ_SKYENV_DAY: "Day",
  FE_0_ZZ_SKYENV_EVE: "Dusk",
  FE_0_ZZ_SKYENV_FLARE: "Lens Flare",
  FE_0_ZZ_SKYENV_FOG: "Fog Color",
  FE_0_ZZ_SKYENV_LIGHT_COLOR: "Light Color",
  FE_0_ZZ_SKYENV_LIGHT_INTENSITY: "Light Intensity",
  FE_0_ZZ_SKYENV_NIGHT: "Night",
  FE_0_ZZ_SKYENV_NIGHT_MODE: "Night Mode",
  FE_0_ZZ_SKYENV_SHADOW: "Shadows",
  FE_0_ZZ_SKYENV_SKY: "Skybox",
  FE_0_ZZ_SKYENV_WETNESS: "Terrain Moisture",
  FE_38_B_CAMERA_DEFAULT: "Default Camera",
  FE_38_B_CHECK: "View",
  FE_38_B_CHECK_FAILED: "Failed to pass review",
  FE_38_B_COMPONENTS_CREATECOPY: "Create Copy",
  FE_38_B_COMPONENTS_CUSTOM: "Custom Components",
  FE_38_B_COMPONENTS_CUSTOM_CREATE: "Create Custom Component",
  FE_38_B_COMPONENTS_CUSTOM_DELETE: "Delete Component",
  FE_38_B_COMPONENTS_EDIT: "Configure Component Properties",
  FE_38_B_COMPONENTS_MANAGE: "Component Manager",
  FE_38_B_COMPONENTS_OFFICAL: "Official Components",
  FE_38_B_COMPONENTS_PROPERTIES: "Properties",
  FE_38_B_COMPONENTS_PROPERTIES_DEFAULT: "Default Property",
  FE_38_B_COMPONENTS_PROPERTIES_REQUIRE: "Require Property",
  FE_38_B_COMPONENTS_RESET: "Reset Component",
  FE_38_B_COMPONENTS_TIP_DELETE: "Deleting this component will cancel the Require relationship. Confirm to delete?",
  FE_38_B_COMPONENTS_TIP_REQUIRE: "This component is being required by the components below",
  FE_38_B_DEBUGSETTING_ASSIGN_TEAM: "Assign Teams",
  FE_38_B_DEBUGSETTING_AUTO: "Auto",
  FE_38_B_DEBUGSETTING_AUTO_TEAM: "Auto Assign Teams",
  FE_38_B_DEBUGSETTING_DEBUG_MODE: "Debug Mode",
  FE_38_B_DEBUGSETTING_LANG: "Starting Language",
  FE_38_B_DEBUGSETTING_NAME: "Debug Settings",
  FE_38_B_DEBUGSETTING_REMOTE: "Use Remote Server",
  FE_38_B_DEBUGSETTING_REMOTE_ADDRESS: "Remote Server Address",
  FE_38_B_DEBUGSETTING_SIDE_NUMBER: "Debug Client Amount",
  FE_38_B_DEBUGSETTING_STRICT_MODE: "Strict Mode",
  FE_38_B_DEBUGSETTING_TEAM: "Team {0}",
  FE_38_B_DEBUGSETTING_TEAMUP: "Team Up",
  FE_38_B_DEBUGSETTING_TOOL: "Debugging Tool",
  FE_38_B_ECA_ADD_WATCH: "Add Watch",
  FE_38_B_ECA_CALL_FUNCTION: "Call Function",
  FE_38_B_ECA_CAMERA_ENTITY: "Camera Component",
  FE_38_B_ECA_CLEAR_WATCH: "Clear Watch",
  FE_38_B_ECA_CONDITIONAL_STATEMENT: "Conditional Statement",
  FE_38_B_ECA_DEFINE_BEHAVIOR: "Define Behavior",
  FE_38_B_ECA_DEFINE_FUNCTION: "Define Function",
  FE_38_B_ECA_DEL_WATCH: "Delete Watch",
  FE_38_B_ECA_LIST: "ECA List",
  FE_38_B_ECA_PARALIST: "Parameter List",
  FE_38_B_ECA_SET_VARIABLE: "Set Variable",
  FE_38_B_ECA_SOUND_ENTITY: "Sound Entity Component",
  FE_38_B_ECA_TIPSHUD_ENTITY: "Text HUD Component",
  FE_38_B_GAME_EDITOR_LOCALIZATIONSETTING: "Localization",
  FE_38_B_LOCALIZATION_NEW_CSV: "Create CSV",
  FE_38_B_LOCALIZATION_TIPS1: "There are no linked localization files.",
  FE_38_B_LOCALIZATION_TIPS2: "The encoding format for the localization CSV file must be UTF8.",
  FE_38_B_LOCALIZATION_TIPS3: "Unable to find {0} in the current linked file.",
  FE_38_B_LOOT_RESET: "Resets Every Round",
  FE_38_B_MENU_DELETE: "Delete the window layout {0}.",
  FE_38_B_MENU_TIPS1: "Please insert the layout name.",
  FE_38_B_MENU_TIPS2: "Please change the name.",
  FE_38_B_MENU_TIPS3: "This name has already been used. Switch to another one?",
  FE_38_B_MENU_TIPS4: "Token has expired. Please login again.",
  FE_38_B_MENU_TIPS5: "Tap to view redirection details",
  FE_38_B_MENU_WORDFILTER: "Improper Word Filter",
  FE_38_B_NEW_PROJECT: "New Project",
  FE_38_B_POINT_TIPS_EXCEED: "Breakpoint limit reached (1000 breakpoints)",
  FE_38_B_PROJECTSETTING_COVER: "Cover Image",
  FE_38_B_REVIEW_01: "Sensitive Word Detection",
  FE_38_B_REVIEW_02: "Checking for sensitive words. For details, please head to the console in your project.",
  FE_38_B_REVIEW_03: "Sensitive Word Detection complete. {0} text strings detected. {1} text string(s) contains sensitive words. Please read the error message.",
  FE_38_B_SLOT_DEFAULT: "Default Slots",
  FE_38_B_SLOT_POPULAR: "Popular Slots",
  FE_38_B_SLOT_POPULAR_NONE: "No Popular Slots",
  FE_38_B_TIP_DELETE_FAILED: "Unable to delete this component right now",
  FE_38_B_TIP_DIRTY_SAVE: "Please first save the following components:",
  FE_38_B_TIP_OFFICAL_REQUIRE: "Unable to change the official Require components",
  FE_38_B_TIP_SAVE_FAILED: "Save failed.",
  FE_38_V_CONSOLE_TO_GRAPH: "Double click to jump to the definition",
  FE_38_V_CONSOLE_TO_TARGET: "Double click to go to the target location",
  FE_38_V_ECA_COMPONENT_SELECT: "Select Components",
  FE_38_V_MENU_WORK_AREA: "Deck",
  FE_38_WZY_WS_CLEARPRO_ALL: "Clear all property factors",
  FE_38_ZQ_INSPECTOR_STATIC: "Static Batching",
  FE_38_ZQ_INSPECTOR_STATICTIPS: "Check this box to mark this entity as static in the scenery.",
  FE_38_ZQ_LAUNCH_CHECKING: "Under Review",
  FE_38_ZQ_LAUNCH_FAILED: "Failed to pass review. For details, please head to the console in your project.",
  FE_38_ZQ_LAUNCH_TIPS: 'Check your review status at the "Data Center". If you pass the review, your game will be published automatically.',
  FE_38_ZQ_PROJECTSETTING_COVER: "Set as cover image",
  FE_38_ZQ_PROJECTSETTING_DEFAULTLANG: "Default Language",
  FE_38_ZQ_PROJECTSETTING_DOUBLECHECK: "Confirm to cancel these changes?",
  FE_38_ZQ_PROJECTSETTING_INFO: "Basic Info",
  FE_38_ZQ_PROJECTSETTING_LANG: "Localization List",
  FE_38_ZQ_PROJECTSETTING_LANGTIPS: "When no localized text has been configured to the key, this language will be displayed by default.",
  FE_38_ZQ_PROJECTSETTING_LIMIT: "The image exceeds 200K. Unable to upload. Please select another image.",
  FE_38_ZQ_PROJECTSETTING_LOC: "Localization",
  FE_38_ZQ_PROJECTSETTING_NAME: "Project Settings",
  FE_38_ZQ_PROJECTSETTING_PICTIPS1: "Supported image formats: jpg, jpeg, png, and bmp.",
  FE_38_ZQ_PROJECTSETTING_PICTIPS2: "Recommended dimensions are 420*182 px. Size must be within 200K.",
  FE_38_ZQ_PROJECTSETTING_PICTIPS3: "Your project will be available to the public once it passes the system review.",
  FE_38_ZQ_PROJECTS_IMPORT: "Import",
  FE_38_ZQ_PROJECTS_REFRESH: "Refresh",
  FE_38_ZQ_PROJECTS_TIPS: "You cannot undo a resources deletion.",
  FE_38_ZZ_CAMERA_ADD: "Add Camera To Current Position",
  FE_38_ZZ_CAMERA_BLOCK_MODE: "Blocked Mode",
  FE_38_ZZ_CAMERA_CHOOSE: "Select Camera Mode",
  FE_38_ZZ_CAMERA_CONTROL: "Control the camera using the screen.",
  FE_38_ZZ_CAMERA_CUSTOM: "Custom Camera",
  FE_38_ZZ_CAMERA_FOCUS_OFFSET_DESC: "The direction offset is the coordinates between the center of the player and the camera's direction point.",
  FE_38_ZZ_CAMERA_FOV_DESC: "The field of view is the observable range of the camera.",
  FE_38_ZZ_CAMERA_INVISICAM: "Semi-Transparent",
  FE_38_ZZ_CAMERA_OFFSET_DESC: "The offset is based on the coordinates between the camera and the player's centerpoint.",
  FE_38_ZZ_CAMERA_ORTHOGRAPHIC: "Orthographic",
  FE_38_ZZ_CAMERA_PERSPECTIVE: "Perspective",
  FE_38_ZZ_CAMERA_PREVIEW: "Preview",
  FE_38_ZZ_CAMERA_PROJECTION_MODE: "Projection Mode",
  FE_38_ZZ_CAMERA_SET: "Set Game Camera",
  FE_38_ZZ_CAMERA_STABLE: "Fixed",
  FE_38_ZZ_CAMERA_START: "Preset Camera",
  FE_38_ZZ_CAMERA_START_MODE: "Preset Camera Mode",
  FE_38_ZZ_CAMERA_THIRD: "Third Person (Chase)",
  FE_38_ZZ_CAMERA_TRANSVERSE: "Horizontal Movement",
  FE_38_ZZ_CAMERA_ZOOM: "Zoom",
  FE_38_ZZ_ECA_COMMON: "Public Event",
  FE_38_ZZ_ECA_COMPONENT_SET: "Set Component Type",
  FE_38_ZZ_ECA_COMPONENT_TYPE: "Component Type",
  FE_38_ZZ_ECA_PRIVATE: "Private Event",
  FE_38_ZZ_ECA_USED: "Block already used",
  FE_38_ZZ_EMPTY: "Empty",
  FE_39A_B_LOGIN_BACK: "Back",
  FE_39A_B_LOGIN_JOIN: "Join",
  FE_39A_B_LOGIN_LOADING: "Loading",
  FE_39A_B_LOGIN_SIGNIN: "Log in",
  FE_39A_B_LOGIN_SIGNINWITH: "Log in via {0}",
  FE_39A_B_LOGIN_SIGNUP: "Sign up",
  FE_39A_B_LOGIN_SIGNUPWITH: "Sign up via {0}",
  FE_39A_B_LOGIN_SUCCESS: "Success",
  FE_39A_B_LOGIN_TIPS1: "Log in to Craftland Studio",
  FE_39A_B_LOGIN_TIPS10: "Binding a Free Fire account enables you to publish and visit Free Fire projects.",
  FE_39A_B_LOGIN_TIPS11: "Don't have a Free Fire account?",
  FE_39A_B_LOGIN_TIPS12: "Already have a Free Fire account?",
  FE_39A_B_LOGIN_TIPS2: "Do not have a Craftland Studio account?",
  FE_39A_B_LOGIN_TIPS3: "Already have a Craftland Studio account？",
  FE_39A_B_LOGIN_TIPS4: "This page will be refreshed after successfuly logging in on the pop-up window.",
  FE_39A_B_LOGIN_TIPS5: "Launching Craftland Studio",
  FE_39A_B_LOGIN_TIPS6: "To use Craftland Studio and visit Free Fire projects, please first bind your Free Fire account.",
  FE_39A_B_LOGIN_TIPS7: "Failed to bind, please try again",
  FE_39A_B_LOGIN_TIPS8: "Notification",
  FE_39A_B_LOGIN_TIPS9: "Confirm to bind the Free Fire account below? Once successful, you can obtain info. of Free Fire projects.",
  FE_39A_V_NINE_SLICE: "9-Grid Pattern",
  FE_39A_ZQ_ATLAS_CLEARFAIL: "Failed to clear",
  FE_39A_ZQ_ATLAS_CLEARSUC: "Cleared",
  FE_39A_ZQ_ATLAS_MEMORY: "UI Picture Cache",
  FE_39A_ZQ_FILE_FILEID: "File ID",
  FE_39A_ZQ_FILE_PATH: "Path",
  FE_39A_ZQ_MESH_SUBMESHCOUNT: "Submesh Count",
  FE_39A_ZQ_PERFORMANCE: "Performance",
  FE_39_B_ADD: "Add",
  FE_39_B_BAN_DRAG: "Dragging prohibited",
  FE_39_B_CHOOSE_ENTITY: "Select entity to send",
  FE_39_B_CHOOSE_TYPE: "Select parameter type",
  FE_39_B_COPY: "Copy",
  FE_39_B_CREATE_SIGNAL_PARAMETER: "Create signal parameter",
  FE_39_B_CUSTOM_EVENT: "Custom event",
  FE_39_B_DATA_OPERATE: "Data operation",
  FE_39_B_DELETE_SIGNAL_PARAMETER: "Delete signal parameter{0}",
  FE_39_B_ENUM: "Enum",
  FE_39_B_ENUM_DETAIL: "Enum details",
  FE_39_B_GUNSKIN_PROP: "Gun skin attribute",
  FE_39_B_GUNSKIN_SKILL: "Gun skin skill",
  FE_39_B_LOCALIZATION_TIPS1: "Localized text length does not meet requirement",
  FE_39_B_SIGNAL_CONFIG: "Predefined signal parameter config",
  FE_39_B_SIGNAL_NAME: "Signal name",
  FE_39_B_SIGNAL_PARAMETER: "Predefined signal parameter",
  FE_39_B_SIGNAL_RECEIVE: "When receive signal {0}",
  FE_39_B_SIGNAL_SEND: "Send signal{0}",
  FE_39_B_SIGNAL_TIPS1: "Signal name already used",
  FE_39_B_SIGNAL_TIPS2: "Custom signal event failed",
  FE_39_B_TAG_EDIT: "Edit tag",
  FE_39_B_TAG_TIPS1: "Confirm to delete this tag?",
  FE_39_B_TARGET_ENTITY: "Target entity",
  FE_39_M_ACCOUNTID: "Account",
  FE_39_M_ADDTEMPLATE: "Add template",
  FE_39_M_ASC: "Ascending",
  FE_39_M_BLOCKLY: "Block preview",
  FE_39_M_CLEAR: "Clear data",
  FE_39_M_CLEAR1: "All data in the sheet will be cleared and cannot be retrieved. Confirm?",
  FE_39_M_CLEAR2: "All data will be cleared and cannot be retrieved. Confirm?",
  FE_39_M_CLEAR3: "Data will be deleted and cannot be retrieved. Confirm?",
  FE_39_M_COMPONENT: "Component preview",
  FE_39_M_COMPONENTDESC: "Component desc",
  FE_39_M_COMPONENTLIST: "Component list",
  FE_39_M_DATA: "Data storage",
  FE_39_M_DATAMAX: "Data table number limit reached",
  FE_39_M_DATAMODEDESC: "The corresponding components and blocks can be used once the module is enabled. Note that the storage function has strict performance requirements and request frequency limit, please control your data manipulation logic.",
  FE_39_M_DATANAMEREPEAT: "Data Table name already existed",
  FE_39_M_DATANAMESIZE: "Data Table name contains up to 12 characters",
  FE_39_M_DATAOFF: "Data storage function off",
  FE_39_M_DATASTORAGEOFF: "Data storage module OFF",
  FE_39_M_DATASTORAGEON: "Data storage module ON",
  FE_39_M_DESC: "Descending",
  FE_39_M_FUNON: "Function ON",
  FE_39_M_INPUTNAME: "Enter data table name",
  FE_39_M_MANAGE: "Manage archive",
  FE_39_M_OFF: "OFF",
  FE_39_M_ORDIDATA: "Normal Data Table",
  FE_39_M_RANKDATA: "Ranking Data Table",
  FE_39_M_RANKING: "Ranking",
  FE_39_M_RANKSHEETTIPS: "You can establish a leaderboard data table, data will be sorted automatically",
  FE_39_M_SHEETTIPS: "You can establish a normal data table to store any data",
  FE_39_M_STATUS: "Status",
  FE_39_M_TABLENULL: "The current data table is empty",
  FE_39_M_TABLESET: "Data table settings",
  FE_39_SP_ENUM01: "Edit Enum",
  FE_39_SP_ENUM02: "Edit Custom Enum",
  FE_39_SP_ENUM03: "Manage Enum",
  FE_39_SP_ENUM04: "Custom Enum",
  FE_39_SP_ENUM05: "Official Enum",
  FE_39_SP_ENUM06: "Data Type",
  FE_39_SP_ENUM07: "Enum Content",
  FE_39_SP_ENUM08: "Create a copy",
  FE_39_V_ALIGN_STYLE: "Alignment Style",
  FE_39_V_BUTTON_DOUBLE_CLICK: "Double-click button",
  FE_39_V_BUTTON_DOUBLE_CLICK_DESC: "Execute after double-clicking entity",
  FE_39_V_BUTTON_PRESS: "Press button",
  FE_39_V_BUTTON_PRESS_DESC: "Execute after pressing entity",
  FE_39_V_BUTTON_RELEASE: "Release button",
  FE_39_V_BUTTON_RELEASE_DESC: "Execute when entity is lifted",
  FE_39_V_INPUT_TEXT_ACTIVE: "Activate text content",
  FE_39_V_INPUT_TEXT_DEFAULT: "Default text content",
  FE_39_V_PATH_COPY: "Copy control name/path",
  FE_39_V_PROFILER_ASSESS: "Estimated storage space on mobile device",
  FE_39_V_PROFILER_CURRENT: "Current",
  FE_39_V_PROFILER_DOWN: "Download",
  FE_39_V_PROFILER_DRAWCALL: "Draw Calls",
  FE_39_V_PROFILER_LOG: "Performance log",
  FE_39_V_PROFILER_MEMORY: "Memory",
  FE_39_V_PROFILER_NET: "Network Traffic",
  FE_39_V_PROFILER_OTHER: "Others",
  FE_39_V_PROFILER_PEAK: "Peak",
  FE_39_V_PROFILER_PRESSURE: "Publishing Pressure",
  FE_39_V_PROFILER_PRESSURE_ASSESS: "Estimated performance pressure on mobile",
  FE_39_V_PROFILER_PRESSURE_HIGH: "High",
  FE_39_V_PROFILER_PRESSURE_LOW: "Low",
  FE_39_V_PROFILER_PRESSURE_MEDIUM: "Medium",
  FE_39_V_PROFILER_RENDER: "Rendering",
  FE_39_V_PROFILER_TIME_LOAD: "Loading Time",
  FE_39_V_PROFILER_TIME_RUN: "Running Time",
  FE_39_V_PROFILER_TIPS: "Profiler",
  FE_39_V_PROFILER_TRIS: "Tris",
  FE_39_V_PROFILER_UP: "Upload",
  FE_39_V_TERRAIN_BRUSH_RADIUS: "Brush radius",
  FE_39_V_TERRAIN_BRUSH_SET: "Brush settings",
  FE_39_V_TERRAIN_BRUSH_SIZE: "Brush size",
  FE_39_V_TERRAIN_BRUSH_STRENGTH: "Strength",
  FE_39_V_TERRAIN_BUILD: "Create",
  FE_39_V_TERRAIN_BUILD_LIMIT: "Only 1 terrain can be created",
  FE_39_V_TERRAIN_CHANGE: "Change",
  FE_39_V_TERRAIN_DELETE: "Delete",
  FE_39_V_TERRAIN_DRAW: "Paint",
  FE_39_V_TERRAIN_FLAT: "Flat",
  FE_39_V_TERRAIN_FLAT_BOTH: "Both",
  FE_39_V_TERRAIN_FLAT_MODE: "Flatten Mode",
  FE_39_V_TERRAIN_FLAT_TARGET: "Flatten Target",
  FE_39_V_TERRAIN_GENERATE: "Generate",
  FE_39_V_TERRAIN_IMPORT: "Import",
  FE_39_V_TERRAIN_LOWER: "Lower",
  FE_39_V_TERRAIN_NAME: "Terrain",
  FE_39_V_TERRAIN_NEW: "New",
  FE_39_V_TERRAIN_PLANT_BRUSH: "Plant brush",
  FE_39_V_TERRAIN_PLANT_CHOOSE: "Plant selection",
  FE_39_V_TERRAIN_PLANT_DENSITY: "Brush density",
  FE_39_V_TERRAIN_RAISE: "Raise",
  FE_39_V_TERRAIN_RANDOM_ANGLE: "Random angle",
  FE_39_V_TERRAIN_SCULPT: "Sculpt",
  FE_39_V_TERRAIN_SET: "Terrain settings",
  FE_39_V_TERRAIN_SIZE: "Size",
  FE_39_V_TERRAIN_SMOOTH: "Smooth",
  FE_39_V_TERRAIN_TEXTURE: "Texture",
  FE_39_V_TERRAIN_TEXTURE_CHANGE: "Change",
  FE_39_V_TERRAIN_TEXTURE_CHOOSE: "Texture selection",
  FE_39_V_TERRAIN_TEXTURE_COVER_ALL: "Override all",
  FE_39_V_TERRAIN_TEXTURE_DEIETE: "Delete",
  FE_39_V_TERRAIN_TEXTURE_IMPORT: "Import",
  FE_39_V_TERRAIN_TEXTURE_LIMIT: "Only 4 kinds of texture can be imported",
  FE_39_V_TYPO: "Text layout",
  FE_39_XYL_ISTRIGGERHIDE: "Hide trigger",
  FE_39_XYL_MOVESTRAIGHT1: "Linear movement A",
  FE_39_XYL_MOVESTRAIGHT2: "Linear movement B",
  FE_39_XYL_TELEPORTTYPE: "Auto Teleport",
  FE_39_ZQ_COLLIDER_ACTIVE: "Collider activated",
  FE_39_ZQ_COLLIDER_BOX: "Box Collider",
  FE_39_ZQ_COLLIDER_CAPSULE: "Capsule Collider",
  FE_39_ZQ_COLLIDER_COLLIDER: "Collider",
  FE_39_ZQ_COLLIDER_COLLIDERNUM: "Collider {0}",
  FE_39_ZQ_COLLIDER_EDIT: "Edit Collider",
  FE_39_ZQ_COLLIDER_ERROR: "Collider damaged, please check and retry",
  FE_39_ZQ_COLLIDER_MESH: "Mesh Collider",
  FE_39_ZQ_COLLIDER_RADIUS: "Radius",
  FE_39_ZQ_COLLIDER_SPHERE: "Sphere Collider",
  FE_39_ZQ_COLLIDER_TRIGGER: "Is Trigger",
  FE_39_ZQ_COLLIDER_TYPE: "Collider Type",
  FE_39_ZQ_FILETYPE_ALL: "All files",
  FE_39_ZQ_FILETYPE_FBX: "FBX files",
  FE_39_ZQ_FILETYPE_MATERIAL: "Material files",
  FE_39_ZQ_FILETYPE_SOUND: "Audio files",
  FE_39_ZQ_FILE_OUTPUT: "Export",
  FE_39_ZQ_FILE_UNLEGAL: "Invalid file type, please check and retry",
  FE_39_ZQ_IMAGE_ERROR: "Picture damaged",
  FE_39_ZQ_IMAGE_FORMAT: "Format",
  FE_39_ZQ_IMAGE_RESOURCESIZE: "Resource size",
  FE_39_ZQ_IMAGE_ROUTE: "Route",
  FE_39_ZQ_IMAGE_WARNINGRULE: "Picture size invalid. It has to be an integer power of 2 to be displayed correctly.",
  FE_39_ZQ_IMAGE_WARNINGSIZE: "Max. picture size: 2048x2048. Please re-adjust.",
  FE_39_ZQ_INSPECTOR_ACTIVE: "Availability",
  FE_39_ZQ_MATERIAL_BRIGHTNESS: "Brightness",
  FE_39_ZQ_MATERIAL_DIFFUSEINTENSITY: "Diffuse Intensity",
  FE_39_ZQ_MATERIAL_ERROR: "Material damaged, please check and retry",
  FE_39_ZQ_MATERIAL_GLOBALILLUMINATION: "Double Sided Global Illumination",
  FE_39_ZQ_MATERIAL_GPUINSTANCING: "Enable GPU Instancing",
  FE_39_ZQ_MATERIAL_LIGHTINGON: "Lighting On",
  FE_39_ZQ_MATERIAL_LOSTQUOTE: "Quote lost",
  FE_39_ZQ_MATERIAL_LOWQUALITY: "Low Quality",
  FE_39_ZQ_MATERIAL_MAINCOLOR: "Main Color",
  FE_39_ZQ_MATERIAL_MAINMAP: "Main Map",
  FE_39_ZQ_MATERIAL_MATERIAL: "Material",
  FE_39_ZQ_MATERIAL_NORMALMAP: "Normal Map",
  FE_39_ZQ_MATERIAL_OFFSET: "Offset",
  FE_39_ZQ_MATERIAL_RENDERQUEUE: "Render Queue",
  FE_39_ZQ_MATERIAL_SHADER: "Shader",
  FE_39_ZQ_MATERIAL_SHININESS: "Shine",
  FE_39_ZQ_MATERIAL_SPECULARCOLOR: "Specular Color",
  FE_39_ZQ_MATERIAL_SPECULARINTENSITY: "Specular Intensity",
  FE_39_ZQ_MATERIAL_SPECULARMASK: "Specular Mask",
  FE_39_ZQ_MATERIAL_TILING: "Tile",
  FE_39_ZQ_MATH_EQUAL: "Equal",
  FE_39_ZQ_MATH_GREATER: "Greater than",
  FE_39_ZQ_MATH_GREATEREQUAL: "Greater than/Equal",
  FE_39_ZQ_MATH_LESS: "Less than",
  FE_39_ZQ_MATH_LESSEQUAL: "Less than/Equal",
  FE_39_ZQ_MATH_NOTEQUAL: "Unequal",
  FE_39_ZQ_MESH_ERROR: "Mesh damaged, please check and retry",
  FE_39_ZQ_MESH_MESH: "Mesh",
  FE_39_ZQ_PACKAGE_ERROR: "Package damaged, please check and retry",
  FE_39_ZQ_PACKAGE_EXPORTFAIL: "Failed to export",
  FE_39_ZQ_PACKAGE_EXPORTSUCCESS: "Successfully exported",
  FE_39_ZQ_PACKAGE_IMPORTFAIL: "Failed to import",
  FE_39_ZQ_PACKAGE_IMPORTSUCCESS: "Successfully imported",
  FE_39_ZQ_PACKAGE_IMPUTPACKAGE: "Import package",
  FE_39_ZQ_PACKAGE_INCLUDEDEPENDENCY: "Include dependency",
  FE_39_ZQ_PACKAGE_LOSTQUOTE: "Quote {0} lost",
  FE_39_ZQ_PACKAGE_NEWID: "A file with same ID but different name has existed, proceeding may lead to a loss of file quotation",
  FE_39_ZQ_PACKAGE_OUTPUTPACKAGE: "Export as package",
  FE_39_ZQ_PACKAGE_WARNING: "The ID of this file coincides with that of another file in the project. Continuing import will replace all target files.",
  FE_39_ZQ_PART_CONE: "Cone",
  FE_39_ZQ_PART_CUBE: "Cube",
  FE_39_ZQ_PART_CYLINDER: "Cylinder",
  FE_39_ZQ_PART_PART: "Geometry",
  FE_39_ZQ_PART_SPHERE: "Sphere",
  FE_39_ZQ_PART_WEDGE: "Wedge",
  FE_39_ZQ_PREFAB_APPLY: "Apply",
  FE_39_ZQ_PREFAB_APPLYALL: "Apply All",
  FE_39_ZQ_PREFAB_ERROR: "Prefab error, please check and retry",
  FE_39_ZQ_PREFAB_NEWPREFAB: "New prefab",
  FE_39_ZQ_PREFAB_NOOVERRIDE: "No overridden content",
  FE_39_ZQ_PREFAB_OVERRIDE: "Override",
  FE_39_ZQ_PREFAB_PREFAB: "Prefab",
  FE_39_ZQ_PREFAB_RESTORE: "Restore",
  FE_39_ZQ_PREFAB_RESTOREALL: "Restore all",
  FE_39_ZQ_PREFAB_UNPACK: "Unpack",
  FE_39_ZQ_PREFAB_UNPACKALL: "Unpack all",
  FE_39_ZQ_RENDER_RENDER: "Render",
  FE_39_ZQ_SHADER_ALWAYS: "Always",
  FE_39_ZQ_SHADER_COLORMASK: "Color mask",
  FE_39_ZQ_SHADER_CUTOFF: "Crop",
  FE_39_ZQ_SHADER_FADEFACTOR: "Attenuation factor",
  FE_39_ZQ_SHADER_NEVER: "Never",
  FE_39_ZQ_SHADER_TINTCOLOR: "Tint",
  FE_39_ZQ_VISIBLE_CURRENTLAYER: "Current layer",
  FE_39_ZQ_VISIBLE_DEFAULTLAYER: "Default layer",
  FE_39_ZQ_VISIBLE_LAYER: "Layer",
  FE_40A_B_ECA_TIPS1: "Localized keys cannot be connected.",
  FE_40A_B_SETTING_BASIC: "Basic",
  FE_40A_B_SETTING_BUILD: "Build",
  FE_40A_B_SETTING_BUILDAIM: "Build Goal",
  FE_40A_B_SETTING_BUILDSETTING: "Build Settings",
  FE_40A_B_SETTING_CAMERA_INDENTATION: "Zoom Camera",
  FE_40A_B_SETTING_CAMERA_ROTATE: "Rotate Camera",
  FE_40A_B_SETTING_CAMERA_TRANSLATE: "Move Camera",
  FE_40A_B_SETTING_COMMON: "General Operations",
  FE_40A_B_SETTING_COMMONBUILD: "Regular Build",
  FE_40A_B_SETTING_DOWN10PX: "Move 10px down",
  FE_40A_B_SETTING_DOWN1PX: "Move 1px down",
  FE_40A_B_SETTING_EDITORSWITCH: "Switch Editor",
  FE_40A_B_SETTING_FOCUS: "Focus",
  FE_40A_B_SETTING_LEFT10PX: "Move 10px left",
  FE_40A_B_SETTING_LEFT1PX: "Move 1px left",
  FE_40A_B_SETTING_LEFTMOUSE: "Left Mouse Button",
  FE_40A_B_SETTING_LOG: "Print log",
  FE_40A_B_SETTING_MANY: "Multiple Multi-Choice Entity",
  FE_40A_B_SETTING_MIDMOUSE: "Scroll Wheel",
  FE_40A_B_SETTING_MIDMOUSE_HOLD: "Press and hold the scroll wheel",
  FE_40A_B_SETTING_PREFERENCES: "Preference",
  FE_40A_B_SETTING_PROJECT: "Project Operations",
  FE_40A_B_SETTING_RIGHT10PX: "Move 10px right",
  FE_40A_B_SETTING_RIGHT1PX: "Move 1px right",
  FE_40A_B_SETTING_RIGHTMOUSE: "Right Mouse Button",
  FE_40A_B_SETTING_SCENE_ROAMING: "Scene Roaming",
  FE_40A_B_SETTING_SHORTCUTKEYS: "Shortcuts",
  FE_40A_B_SETTING_SINGLE: "Single Multi-Choice Entity",
  FE_40A_B_SETTING_UP10PX: "Move 10px up",
  FE_40A_B_SETTING_UP1PX: "Move 1px up",
  FE_40A_B_SETTING_WEBBUILD: "Pre-release package",
  FE_40A_HJ_DEBUG_NETWORKDELAY: "Delay:",
  FE_40A_HJ_DEBUG_PACKETLOSS: "Packet Loss:",
  FE_40A_V_ECA_CLEAR_HISTORY: "Clear History",
  FE_40A_V_ECA_COPY_SINGLE: "Copy Single Row",
  FE_40A_V_ECA_DELETE_MULTIPLE: "Delete Multiple Rows",
  FE_40A_V_ECA_NO_HISTORY: "No search history",
  FE_40A_XYL_COLORFULCUBE: "Color Brick",
  FE_40A_XYL_REFCUBE: "Mirror Brick",
  FE_40A_XYL_TOYCUBE: "Toy Brick",
  FE_40A_ZQ_BATCH_BATCH_STATIC: "Static",
  FE_40A_ZQ_BATCH_BUTTON_SETTING: "Go to Project Settings",
  FE_40A_ZQ_BATCH_CONSOLE_SCRIPT: "The ECA script file {0} of the current node {1} cannot be applied. Please check whether to maintain the current status.",
  FE_40A_ZQ_BATCH_TIPS_BADINHERIT: "Error in optimizing rendering performance. This entity does not support batching or model merging.",
  FE_40A_ZQ_BATCH_TIPS_COLLIDER: "Static properties enabled. This property will be invalid and switched to the default collision.",
  FE_40A_ZQ_BATCH_TIPS_INHERIT: "Inherit Static Properties",
  FE_40A_ZQ_BATCH_TIPS_INSPECTOR: "Static properties enabled. This property will be invalid.",
  FE_40A_ZQ_BATCH_TIPS_INVALID: "Static batching enabled. The following properties may be invalid.",
  FE_40A_ZQ_BATCH_TIPS_STATICBATCHING: "Enabling static batching will result in logic invalidity of the applied entity.",
  FE_40A_ZQ_BATCH_TIPS_UNAVAILABLE: "Logics of the official objects are still valid.",
  FE_40A_ZQ_SETTINGS_GOTOSETTINGS: "Settings",
  FE_40A_ZQ_SETTINGS_INPUTTIPS: "Input here",
  FE_40_B_DATA_SEARCH_ACCOUNTID: "Search UID",
  FE_40_B_DATA_SEARCH_KEY: "Search Key",
  FE_40_B_DATA_SEARCH_VALUE: "Search Value",
  FE_40_B_DATA_TIPS1: "The current data cannot be edited. Please publish the map and try again.",
  FE_40_B_DATA_TIPS2: "This data type cannot be edited.",
  FE_40_B_DATA_TIPS3: "Searching through a regular data list requires you to designate the UID and key.",
  FE_40_B_DATA_TIPS4: "Save the previous edits?",
  FE_40_B_DATA_TIPS5: "There are unsaved edits.",
  FE_40_B_ECA_MISSING: "Missing ECA script",
  FE_40_B_LOGIN_TIPS1: "You are currently using a guest account. Please log in to your Craftland Studio account first.",
  FE_40_B_RECONNECT_OFF: "Turn off reconnecting upon disconnection",
  FE_40_B_SCRIPT: "Script",
  FE_40_B_SCRIPT_MISSING: "Missing code script",
  FE_40_B_TERRAIN_TIPS1: "Reached the surface limit (4) for the current terrain",
  FE_40_B_VERSION_TIPS1: `Incompatible versions. (Editor version: {0}. Project version: {1}).
Continue anyway?`,
  FE_40_JH_AVALTOKENID: "ID of active token",
  FE_40_JH_DISPLAYLABEL: "Display Tags",
  FE_40_JH_DISPLAYLABELDESC: "Display the tags on the Free Fire games",
  FE_40_JH_DISPLAYLABELMAX: "Maximum number of displayed tags reached.",
  FE_40_JH_GAMETYPEDESC: "Choose a game type for this map",
  FE_40_JH_GAMETYPENAME: "Game Type",
  FE_40_JH_GETTOKENID: "Token ID",
  FE_40_JH_HIDETAGLIMIT: "Maximum number of selected game types reached.",
  FE_40_JH_NUM: "Amount",
  FE_40_JH_TOKENALIVE: "Token(s) to activate in matches",
  FE_40_JH_TOKENGET: "Token(s) to bring to matches",
  FE_40_JH_TOKENSET: "Token Settings",
  FE_40_JH_TOKENSET1: "Whether to enable token functions",
  FE_40_JH_TOKENSET2: "Whether to bring tokens into matches",
  FE_40_JH_TOKENSETERROR: "Token function not enabled.",
  FE_40_JH_TOKENSETNAME: "Token Settings",
  FE_40_M_UPDATELOG: "Update Log",
  FE_40_SD_EMPTYWARNING: "The current parent is not empty. Please check whether to continue using it.",
  FE_40_SD_FIND_IN_SCENE: "Find References In Scenery",
  FE_40_SD_FIND_IN_UI: "Find References In UI",
  FE_40_SD_FIND_IN_WORKFLOW: "Find References In WorkFlow",
  FE_40_SD_NOTE: "Note",
  FE_40_SD_NOT_FIND: "Reference not found",
  FE_40_V_UI_COLUMN_LIMIT: "Column Limit",
  FE_40_V_UI_PANEL_CONSTRAINNOTCLIP: "Constrain But Don't Clip",
  FE_40_V_UI_PANEL_MASK: "Texture Mask",
  FE_40_V_UI_PANEL_SOFTCLIP: "Soft Clip",
  FE_40_V_UI_ROW_LIMIT: "Row Limit",
  FE_40_V_UI_SCROLLBAR: "Scroll Bar",
  FE_40_V_UI_SCROLLBAR_DRAGGING: "When Dragging",
  FE_40_V_UI_SCROLLBAR_SHOW: "Always Display",
  FE_40_V_UI_SCROLLVIEW: "Scroll View",
  FE_40_V_UI_SCROLLVIEW_DIRECTION_UNRESTRAINED: "Unconstrained",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUM: "Momentum",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUMNSPRING: "Momentum And Spring",
  FE_40_XXJ_CLOTHESTYPE: "Outfit Type",
  FE_40_XXJ_ISEXPORT: "Is Export",
  FE_40_XXJ_PARENTERROR: "Failed to configure the parent.",
  FE_40_XXJ_WEASKINSTYPE: "Weapon Skin Type",
  FE_40_XYL_CUSTOMMINIMAP: "Custom Minimap",
  FE_40_XYL_NOCUSTOMMINIMAP: "Custom Minimap not enabled.",
  FE_40_ZQ_COMPONENT_CUSTOMOBJECT: "Custom Object",
  FE_40_ZQ_COMPONENT_CUSTOMRENDER: "Custom Render Component",
  FE_40_ZQ_GAME_EXITCONFIRM: "Confirm to leave this game?",
  FE_40_ZQ_GAME_EXITOPTION: "Allow Quitting Mid-Game",
  FE_40_ZQ_GAME_KICKOUT: "You have been AFK for a long time and were returned to the Lobby.",
  FE_40_ZQ_GAME_KICKOUTTIME: "Time of AFK (unit: min)",
  FE_40_ZQ_GAME_TIPS: "Notification",
  FE_40_ZQ_LD_LDTIPS: `Added Assetbundle to the LD table of content.
After configuring the mapinfos.csv, please click here to refresh, or else you will be required to refresh by reopening the project.`,
  FE_41A_B_RENAME_TIPS1: "The {0} character cannot be used",
  FE_41A_B_RENAME_TIPS2: "Character limit: {0}",
  FE_41A_B_RENAME_TIPS3: "Nickname does not satisfy standards. Edit failed.",
  FE_41A_B_RENAME_TIPS4: "Name cannot be empty. Edit failed.",
  FE_41A_B_RENAME_TIPS5: "Length of the nickname must be between {0} and {1}.",
  FE_41A_M_FEEDBACK: "Your feedback is important to us!",
  FE_41B_HZY_CHECK_TIPS: "Please first select agree",
  FE_41B_HZY_COMPARE_NOTSAME: "Types on the left and right do not match.",
  FE_41B_HZY_CREATE_PARENTLEVEL: "Create Empty Parent",
  FE_41B_HZY_PRIVACY_POLICY: "I have read and agree to the [Terms of Service](http://content.garena.com/legal/tos/tos_en.html) and [Privacy Policy](https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html).",
  FE_41B_HZY_PROJECT_FAVORITE_TIPS: "Favorite this word",
  FE_41B_M_DEFAULTVALUE: "Default Value",
  FE_41B_M_RANGE: "Value Range",
  FE_41_B_CONSOLE_TIPS1: "Double tap to view error message",
  FE_41_B_DATA_ACCUMULATED_SHEET: "Data Table",
  FE_41_B_DATA_CLEAR_AWARD: "Issue reward upon clearing.",
  FE_41_B_DATA_CLEAR_CYCLE: "Clear Cycle",
  FE_41_B_DATA_CLEAR_CYCLE_INTERVAL: "Cycle Interval",
  FE_41_B_DATA_CLEAR_SETTING: "Clear Settings",
  FE_41_B_DATA_CLEAR_SHEET: "Clear Data Table",
  FE_41_B_DATA_CLEAR_TIME: "Clear Time",
  FE_41_B_DATA_CLEAR_TIMING: "Clear Countdown",
  FE_41_B_DATA_CLEAR_TIPS1: "You will not be able to revert this action. Confirm to continue?",
  FE_41_B_DATA_CLEAR_TIPS2: "You will not be able to revert this action. Confirm to continue?",
  FE_41_B_DATA_DAY: "Day",
  FE_41_B_DATA_HOUR: "Hour",
  FE_41_B_DATA_KEY_MANAGE: "Key Management",
  FE_41_B_DATA_NOTOPEN: "Off",
  FE_41_B_DATA_TIMEZONE: "Timezone",
  FE_41_B_DATA_TIPS1: "You have reached the key limit for this data table.",
  FE_41_B_DATA_TIPS2: "Create a data table that accumulates data on the backend to minimize the possibility of data loss.",
  FE_41_B_DATA_TIPS3: "Added to gradient quantity limit.",
  FE_41_B_DATA_TIPS4: "Clear time is later than the current time",
  FE_41_B_DATA_WEEK: "Week",
  FE_41_B_ECA_LISTTANY: "Any List",
  FE_41_B_LABEL_COPY: "Copy Script Name",
  FE_41_B_LABEL_EDIT: "Modify Script Name",
  FE_41_B_LABEL_FUNCTION: "Block Function",
  FE_41_B_LABEL_FUNCTION_PARA: "Parameter of Block Function",
  FE_41_B_LABEL_SCRIPTNAME: "Script Name",
  FE_41_B_LABEL_TIPS1: `Script names can only contain letters, numbers, and underscores, and the first character cannot be a number.
`,
  FE_41_B_LABEL_TIPS2: "This script name has been taken.",
  FE_41_B_LABEL_TIPS3: "The script name cannot be an internal keyword.",
  FE_41_B_LABEL_TIPS4: "Compilation failed.",
  FE_41_B_LABEL_VARIBLE: "Block Variable",
  FE_41_HJ_AC_STATENOTEXIST: "State {0} does not exist in the animation controller",
  FE_41_HZY_FILE_TERRAIN: "Terrain File",
  FE_41_HZY_POINT_CONTEXTLIST: "Context List",
  FE_41_HZY_POINT_ID: "Serial No.",
  FE_41_HZY_POINT_LIST: "Breakpoints List",
  FE_41_HZY_POINT_VALUE: "Value",
  FE_41_HZY_SEARCH_NO_FILE: "No files found",
  FE_41_JH_AI_SELFIMPORTERROR: "Error: Unable to repeatedly import custom nodes from the current project file.",
  FE_41_JH_BT_ACTIONNODE: "Action",
  FE_41_JH_BT_BEEDITOR: "AI Editor",
  FE_41_JH_BT_BTNAME: "Behavior Tree",
  FE_41_JH_BT_COMPOSITE: "Composite",
  FE_41_JH_BT_CONDITIONNODE: "Contion",
  FE_41_JH_BT_CREATENODE: "Create Node",
  FE_41_JH_BT_DECORATORNODE: "Decorator",
  FE_41_JH_BT_EDITNODE: "Edit Node",
  FE_41_JH_BT_NODENAME: "Node Name",
  FE_41_JH_BT_NODENAMETIP: "Node name cannot be empty.",
  FE_41_JH_BT_NODES: "Node",
  FE_41_JH_BT_NODESCRIPT: "Node Script",
  FE_41_JH_BT_NODESX: "Node Variable",
  FE_41_JH_BT_NODETYPE: "Node Type",
  FE_41_JH_BT_NODEVARNUM: "Node Value",
  FE_41_JH_BT_NODEVARTYPE: "Node Variable Type",
  FE_41_JH_BT_ROOTNODE: "Root Node",
  FE_41_JH_HACK_ANTIHACKCONTROL: "Turn on anti-hack feature",
  FE_41_SD_LOGICFRAME_SETTING: "Low Logic Frame Mode (30 > 15)",
  FE_41_V_PROJECT_ANIM: "Animation",
  FE_41_V_PROJECT_CSV: "CSV File",
  FE_41_V_PROJECT_ECATEMP: "ECA Template",
  FE_41_V_PROJECT_UITEMP: "UI Template",
  FE_41_V_PROJECT_XBT: "Behavior Tree File",
  FE_41_V_PROJECT_XBTTEMP: "XBT Template",
  FE_41_V_UI_CONTAINER: "3D Container",
  FE_41_V_UI_CONTAINER_EFFECT: "Special Effect",
  FE_41_V_UI_CONTAINER_MESH: "Model",
  FE_41_V_UI_PANEL_TIPS: "This category will always be on top of the UI hierarchy.",
  FE_41_V_UI_PANEL_TYPE: "Panel Type",
  FE_41_V_UI_PROFILE: "Avatar",
  FE_41_V_UI_PROFILE_NICKNAME: "Nickname",
  FE_41_V_UI_PROFILE_PIN: "Pin",
  FE_41_V_UI_PROFILE_PRANKED_TYPE: "Rank Type",
  FE_41_V_UI_PROFILE_RANKED: "Rank",
  FE_41_V_UI_PROFILE_TYPE_ONE: "Type 1",
  FE_41_V_UI_PROFILE_TYPE_TWO: "Type 2",
  FE_41_V_UI_TEXTURE: "Texture",
  FE_41_V_UI_TEXTURE_CENTER_INVISIBLE: "Invisible to Center",
  FE_41_V_UI_TEXTURE_FILLED: "Filled",
  FE_41_V_UI_TEXTURE_FILL_AMOUNT: "Fill Amount",
  FE_41_V_UI_TEXTURE_FILL_DIR: "Fill Direction",
  FE_41_V_UI_TEXTURE_FILL_HOR: "Horizontal",
  FE_41_V_UI_TEXTURE_FILL_INVERT: "Invert Fill",
  FE_41_V_UI_TEXTURE_FILL_RADIAL: "Radial",
  FE_41_V_UI_TEXTURE_FILL_VER: "Vertical",
  FE_41_V_UI_TEXTURE_FIT: "Fit",
  FE_41_V_UI_TEXTURE_GRADIENT: "Gradient",
  FE_41_V_UI_TEXTURE_GRADIENT_DIR: "Direction",
  FE_41_V_UI_TEXTURE_SIMPLE: "Simple",
  FE_41_V_UI_TEXTURE_TILED: "Tiled",
  FE_41_V_UI_TEXTURE_TILED_TRIM: "Crop",
  FE_41_V_UI_WIDGET_TYPE: "Widget Type",
  FE_41_XYL_IMPORT_NOTICE001: "This feature does not support Craftland Studio map code importing.",
  FE_41_XYL_IMPORT_NOTICE002: "Map code expired. Unable to import.",
  FE_41_XYL_INPUTMAP: "Online Map",
  FE_41_XYL_NAVMESH: "Static NavMesh",
  FE_41_XYL_NAVMESHTIPS: "Objects with this option will only generate a static NavMesh at the start of the match.",
  FE_41_XYL_PREFABGENERATOR: "Template (Prefab)",
  FE_41_ZQ_AC_ANIMCONTROLLER: "Animation Controller",
  FE_41_ZQ_AC_ANIMEDITOR: "Animation",
  FE_41_ZQ_AC_CLIP: "Clip",
  FE_41_ZQ_AC_CLIPNO: "Clip Quantity",
  FE_41_ZQ_AC_LOOP: "Loop",
  FE_41_ZQ_AC_LOOPTIPS: "The previous clip is on loop. The next clip will not play automatically.",
  FE_41_ZQ_AC_NEWCLIP: "New Animation Clip",
  FE_41_ZQ_AC_NEWSTATE: "New State",
  FE_41_ZQ_AC_NOCLIP: "No animation clips mounted.",
  FE_41_ZQ_AC_PLAYSPEED: "Playback Speed",
  FE_41_ZQ_AC_STATE: "State",
  FE_41_ZQ_ANIM_LENGTH: "Length",
  FE_41_ZQ_BUILD_DYNAMIC: "Dynamic Loading",
  FE_41_ZQ_BUILD_DYNAMIC_TIP: "When selected, this resource will start to load only after the player enters the game.",
  FE_41_ZQ_BUILD_FILE: "Manually Select Package Record",
  FE_41_ZQ_BUILD_LAUNCH: "Your game has been submitted for review. The record for this package has been generated. You may track the review progress at the Data Center. Once approved, your game will be automatically published.",
  FE_41_ZQ_BUILD_PACKAGERULE: "Package Rules",
  FE_41_ZQ_BUILD_REPACKAGE: "Original Package Method",
  FE_41_ZQ_OPEN_PACKAGE_HISTORY: "Open Record List",
  FE_41_ZQ_PACKAGE_RECORD: "Package Record",
  FE_42A_HJ_HUD_COMMONHUDSWITCH: "Common HUD",
  FE_42A_HJ_HUD_COUNTDOWN: "Stage Countdown Timer",
  FE_42A_HJ_HUD_COUNTDOWNREMIND: "Countdown Reminder",
  FE_42A_HJ_HUD_FACTIONINFO: "Team Info",
  FE_42A_HJ_HUD_FIVECOUNTDOWN: "5s Countdown",
  FE_42A_HJ_HUD_MATCHINFO: "Match Subtitle",
  FE_42A_HJ_HUD_MATCHINFOSIMPLE: "Brief Match Info",
  FE_42A_HJ_HUD_ROUNDRESULT: "Round End Banner",
  FE_42A_HJ_HUD_ROUNDTRANSITION: "Round Start Banner",
  FE_42A_HJ_HUD_TITLEBANNER: "Title Banner",
  FE_42A_HJ_HUD_TWOTEAMMATCHINFO: "Scoreboard",
  FE_42A_HJ_HUD_TWOTEAMSCORE: "Round Starts",
  FE_42A_HJ_HUD_TWOTEAMSTART: "Team Battle Banner",
  FE_42A_HJ_HUD_TYPE: "Built-in HUD",
  FE_42A_HZY_ECAMOUNT_TIP: "The following component types do not exist on this entity. This can lead to parts of your code not working as expected: {0}.",
  FE_42A_HZY_WS_FUNCTIONCALL_D: `Waiting: Serial invocation.
Execution: Parallel invocation.`,
  FE_42A_HZY_WS_LOCALVAR_D: "Define and initialize a local variable.",
  FE_42A_XYL_LOOTSWITCH: "Enable default loot spawn point on the map",
  FE_42A_ZQ_ASSET_PICCONTROL: "{0} has exceeded 2048x2048. Please adjust and import again.",
  FE_42A_ZQ_ASSET_PICREDUCE: "The original file is too large and has been resized proportionally to fit within 2048px.",
  FE_42A_ZQ_ASSET_SIZECONTROL: "{0} has exceeded the limit. Please adjust and import again.",
  FE_42A_ZQ_ASSET_SOUNDCONTROL: "{0} fmod has exceeded 10,000,000. Please adjust and import again.",
  FE_42A_ZQ_BATCH_OFFLINE: "Offline Batching",
  FE_42A_ZQ_BATCH_OFFLINETIPS: "Performs static batching at export time. This may require players to download additional assets.",
  FE_42A_ZQ_BATCH_RUNNING: "Runtime Batching",
  FE_42A_ZQ_BATCH_RUNNINGTIPS: "Performs static batching at runtime. This will not generate new assets.",
  FE_42A_ZQ_EFRAME_ADD: "Add Event Frame",
  FE_42A_ZQ_EFRAME_COPY: "Copy Event Frame",
  FE_42A_ZQ_EFRAME_DTL: "Delete Event Frame",
  FE_42A_ZQ_EFRAME_PASTE: "Paste Event Frame",
  FE_42A_ZQ_EFRAME_SLT: "Select Event Frame",
  FE_42A_ZQ_MESH_FACECONTROL: "{0} has over 30,000 meshes. Please reduce the amount and import again.",
  FE_42A_ZQ_PCK_ROOT: "Select the root directory",
  FE_42A_ZQ_PCK_ROOTERROR: "Invalid path",
  FE_42A_ZQ_P_OPENING: "Opening...",
  FE_42A_ZQ_P_RUNNING: "Project running",
  FE_42A_ZQ_P_RUNNINGV: "Project running: {0}",
  FE_42A_ZQ_WEB_LAUNCH: "Publish Now",
  FE_42A_ZQ_WEB_LAUNCHERROR: "Failed to publish. Please try again later.",
  FE_42A_ZQ_WEB_LAUNCHSUC: "Uploaded to Creator Website. Please publish via Creator Center.",
  FE_42_B_ECA_NORMAL: "Regular ECA",
  FE_42_B_ECA_STATIC: "Static ECA",
  FE_42_B_SCRIPT_ECARELATED: "ECA Related",
  FE_42_B_SCRIPT_EXPORTPACKAGE: "Export",
  FE_42_B_SCRIPT_QUICKNAME: "Quick Script Naming",
  FE_42_B_SCRIPT_TIPS1: "Please select the module that you wish to export. Current names that overlap with the script names will be automatically skipped.",
  FE_42_B_SCRIPT_TIPS10: "Automatically select all and run",
  FE_42_B_SCRIPT_TIPS2: "Contains custom component names and custom attribute names.",
  FE_42_B_SCRIPT_TIPS3: "Contains custom enum names and custom enum attribute names.",
  FE_42_B_SCRIPT_TIPS4: "Contains custom event names.",
  FE_42_B_SCRIPT_TIPS5: "Contains ECA file names, variable names, function names, and function return values.",
  FE_42_B_SCRIPT_TIPS6: "Quick script naming completed for {0} script(s) and failed for {1} script(s). Check the error message for details.",
  FE_42_B_SCRIPT_TIPS7: "Script naming: {0} does not meet standards. Naming failed.",
  FE_42_B_SCRIPT_TIPS8: "Script naming: {0} repeated a name. Naming failed.",
  FE_42_B_SCRIPT_TIPS9: "Script naming: {0} repeated an internal keyword. Naming failed.",
  FE_42_HJ_API_INTERNAL: "Internal Blocks",
  FE_42_HJ_API_TEST: "Test Blocks",
  FE_42_HJ_BLOCKDESCINTERNAL: "Internal Block",
  FE_42_HJ_BLOCKDESCTEST: "Test Block",
  FE_42_HJ_DEBUG_ENTITYNUM: "Entity Amount",
  FE_42_HJ_DEBUG_ENTITYPROPNUM: "Entity Sync Amount",
  FE_42_HJ_DEBUG_LOGICDEBUG: "Logic Debug",
  FE_42_HJ_DEBUG_NETWORKDOWNLOAD: "Network Data (Download)",
  FE_42_HJ_DEBUG_NETWORKUPLOAD: "Network Data (Upload)",
  FE_42_HJ_DEBUG_SCENERYDEBUG: "Scenery Debug",
  FE_42_HJ_DEBUG_WATCHLIST: "Watch List",
  FE_42_HJ_VFX_BLACKHOLE: "Blackhole",
  FE_42_HJ_VFX_BLACKHOLEEXPLOSION: "Exploding Blackhole",
  FE_42_HJ_VFX_CRYSTALBALL: "Crystal Ball",
  FE_42_HJ_VFX_INK: "Ink",
  FE_42_HJ_VFX_SPLASH: "Splash",
  FE_42_HZY_SEARCH_BLOCK: "Global block search",
  FE_42_HZY_SEARCH_BLOCKNAME: "Search by this block name",
  FE_42_HZY_SEARCH_GLOBAL: "Find Reference In Global",
  FE_42_HZY_SEARCH_TIPS: "Input and press Enter to search",
  FE_42_HZY_TERRAIN_DELETE_TIPS: `Select plant brush to begin shading.
Brush + Shift: Erase all plants within range.
Brush + Ctrl: Erase only the selected plants.`,
  FE_42_HZY_TIP_DELETE_SLOT: "Unable to publish since the map in this slot has expired. Please head to Free Fire Craftland to delete the map.",
  FE_42_JH_AIEDITOR_ACTIONFUNCNAME: "Run Action",
  FE_42_JH_AIEDITOR_TICKFUNCNAME: "Tick",
  FE_42_JH_AI_ADDTONEWNODE: "Copy As New Node",
  FE_42_JH_AI_CLEAREDITOR: "Clear",
  FE_42_JH_AI_DELETEINPUT: "Delete Node Input",
  FE_42_JH_AI_DELETENODE: "Delete Custom Node",
  FE_42_JH_AI_DELETEOUTPUT: "Delete Node Output",
  FE_42_JH_AI_DRWAERROR: "Background not initialized",
  FE_42_JH_AI_FILELOADER: "File loading error",
  FE_42_JH_AI_NODEID: "Node ID",
  FE_42_JH_AI_NOROOTNODE: "Please first create a root node",
  FE_42_JH_AI_SETUP: "Node Basic Info",
  FE_42_JH_ECANAME1: "Behavior Tree - Execution Behavior",
  FE_42_JH_ECANAME2: "Behavior Tree - Condition Judgement",
  FE_42_JH_SCODE_ERROR1: "The length of this short map code does not satisfy requirements",
  FE_42_JH_SCODE_ERROR2: "The length of the short map code here must be 6 characters made of only capital letters and numbers.",
  FE_42_JH_SCODE_ERROR3: "This short map code already exists.",
  FE_42_JH_SCODE_ERROR5: "You can input 6 characters made up of numbers or capital letters to generate a short map code, which will replace the previous map code.",
  FE_42_JH_SCODE_ERROR6: "This map already has a short map code. Unable to modify.",
  FE_42_JH_SCODE_RANDOMSCODE: "Randomly Generate",
  FE_42_JH_SCODE_SCODENAME: "Short Map Code",
  FE_42_JH_WS_CUSTOMNODEDESC: "Node Description",
  FE_42_JH_WS_DELETECUSTOMNODE: "Delete Node",
  FE_42_JH_WS_DELETENODEPANEL: "Confirm to clear the canvas",
  FE_42_JH_WS_EXSEQUENCE: "Execute all child nodes in chronological order. When all child nodes return true, this node will return true; or else it will return false.",
  FE_42_JH_WS_EXWAIT: "Wait for the designated time. You may set the time such that the next action will execute after that time.",
  FE_42_JH_WS_INVERTER: "Get the opposite value of the execution result of the child nodes.",
  FE_42_JH_WS_MAXS: "Set the max. execution duration of the child nodes.",
  FE_42_JH_WS_MENPRIORITY: "Works just like the priority node, except it will store the execution status of child nodes so that it will execute from the saved progress of this node.",
  FE_42_JH_WS_MENSEQUENCE: "Works just like the sequence node, except it will store the execution status of child nodes so that it will execute from the saved progress of this node.",
  FE_42_JH_WS_PRIORITY: "Execute all child nodes in chronological order. When any child node returns true, this node will return true; or else it will return false.",
  FE_42_JH_WS_REPEATX: "Repeatedly execute the child nodes until it reaches designated execution times.",
  FE_42_JH_WS_REPETFAIL: "Repeatedly execute the child nodes until false is returned.",
  FE_42_JH_WS_REPETSUCC: "Repeatedly execute the child nodes until true is returned.",
  FE_42_M_BOMBER: "Bombarded",
  FE_42_M_ShutdownDelay: "Delay time of server shutdown",
  FE_42_M_StartTimeout: "Delay time of server opening",
  FE_42_SD_FCG_VSIX_INSTALL: "Missing IDE development environment. Install VSCode as IDE?",
  FE_42_V_ACTION_ABOARD: "Enter Vehicle",
  FE_42_V_ACTION_ABOARD_DRIVER: "Enter as Driver",
  FE_42_V_ACTION_ABOARD_OFF: "Enter/Exit Vehicle",
  FE_42_V_ACTION_ABOARD_PASSENGER: "Enter as Passenger",
  FE_42_V_ACTION_BACK: "Move Backward",
  FE_42_V_ACTION_CROUCH: "Crouch",
  FE_42_V_ACTION_DIVE: "Dive",
  FE_42_V_ACTION_FIRE: "Fire",
  FE_42_V_ACTION_FORWARD: "Move Forward",
  FE_42_V_ACTION_GRENADE: "Grenade",
  FE_42_V_ACTION_HUD_HIDE: "Hide UI",
  FE_42_V_ACTION_INTERACT: "Interact",
  FE_42_V_ACTION_JUMP: "Jump",
  FE_42_V_ACTION_LEFT: "Move Left",
  FE_42_V_ACTION_MOUSE_LOCKED: "Lock Mouse",
  FE_42_V_ACTION_MOVE: "Move",
  FE_42_V_ACTION_OFF: "Exit Vehicle",
  FE_42_V_ACTION_PICKUP: "Pick Up",
  FE_42_V_ACTION_PRONE: "Prone",
  FE_42_V_ACTION_QUICK_SWITCH: "Quick Weapon Switch",
  FE_42_V_ACTION_RELOAD: "Reload",
  FE_42_V_ACTION_RIGHT: "Move Right",
  FE_42_V_ACTION_RUN: "Run",
  FE_42_V_ACTION_SKILL: "Skill",
  FE_42_V_ACTION_SWITCH: "Weapon Switch",
  FE_42_V_ACTION_ZOOM: "Scope In",
  FE_42_V_INPUT_ACTION: "Map Action",
  FE_42_V_INPUT_CLICK: "Click",
  FE_42_V_INPUT_DOUBLE_CLICK: "Double Click",
  FE_42_V_INPUT_DOWN: "Press",
  FE_42_V_INPUT_KEY: "Input Key",
  FE_42_V_INPUT_KEYBOARD: "Keyboard",
  FE_42_V_INPUT_LIST: "Mapping List",
  FE_42_V_INPUT_MODE: "Input Gesture",
  FE_42_V_INPUT_MOUSE: "Mouse",
  FE_42_V_INPUT_NUM: "Mapping Amount",
  FE_42_V_INPUT_PRESS: "Press",
  FE_42_V_INPUT_RELEASE: "Release",
  FE_42_V_INPUT_SYSTEM: "Input Setting",
  FE_42_V_INPUT_SYSTEM_TIPS: "Before configuring mapping, please first save the current content in the deck as a UI file.",
  FE_42_XXJ_FILEMISSING: "Missing file asset",
  FE_42_XXJ_INVAR: "Input Value",
  FE_42_XXJ_NORETURN: "Error: no return value",
  FE_42_XXJ_OUTVAR: "Output Value",
  FE_42_ZQ_ANIM_ADDANIMEVENT: "Add Animation Event",
  FE_42_ZQ_ANIM_ANIMEVENT: "Animation Event",
  FE_42_ZQ_ANIM_ANIMTIPS: "Open by double-clicking or dragging an animation file.",
  FE_42_ZQ_ANIM_CANNOTEDIT: "This event type cannot be changed.",
  FE_42_ZQ_ANIM_COPYANIMEVENT: "Copy Animation Event",
  FE_42_ZQ_ANIM_DELETEANIMEVENT: "Delete Animation Event",
  FE_42_ZQ_ANIM_DURATION: "Duration",
  FE_42_ZQ_ANIM_EFRAME: "Event Frame",
  FE_42_ZQ_ANIM_EVENTNUM: "Animation Event {0}",
  FE_42_ZQ_ANIM_EVENTSELECT: "Event Selection",
  FE_42_ZQ_ANIM_FRAME: "Frame",
  FE_42_ZQ_ANIM_MODELTIPS: "No models that can be previewed. Please drag a model into this space.",
  FE_42_ZQ_ANIM_NOANIMEVENT: "No Animation Event",
  FE_42_ZQ_ANIM_PARANUM: "Parameter {0}",
  FE_42_ZQ_ANIM_PASTEANIMEVENT: "Paste Animation Event",
  FE_42_ZQ_ANIM_TIME: "Time",
  FE_42_ZQ_ASSET_CANNOTEDIT: "Unable to edit a reference asset",
  FE_42_ZQ_BATCH_DYNAMICBATCH: "Dynamic Batching",
  FE_42_ZQ_BATCH_DYNAMICTIPS: "Creating, destroying, and modifying properties (such as position movement, rotation, and texture zoom) are still supported under dynamic batching.",
  FE_42_ZQ_ECA_TIP_BONE_EDITOR_DIS_SELECT: "The current scene is for editing appearance. Unable to select objects.",
  FE_42_ZQ_EVENT_NOTIPICALEVENT: "No designated event type",
  FE_42_ZQ_IMPORT_CANCEL: "Cancel",
  FE_42_ZQ_IMPORT_TARGETFILE: "Target File",
  FE_42_ZQ_LOGIN_GOLOGIN: "Please first log in.",
  FE_42_ZQ_MIPMAP: "Enable Mipmap",
  FE_42_ZQ_MIPMAP_TIP: "Enabling Mipmaps may slightly increase the file size and cost of rendering but will improve the smoothness of textures and details display.",
  FE_42_ZQ_OPAQUE: "Remove Alpha",
  FE_42_ZQ_OPAQUE_TIP: "Selecting this option will prevent the Alpha channel from being read (atlases not affected).",
  FE_42_ZQ_SK_APPEARENCE: "Appearance",
  FE_42_ZQ_SK_APPEARENCEGROUP: "Appearance Group",
  FE_42_ZQ_SK_BINDMETHOD: "Bind Method",
  FE_42_ZQ_SK_BONESELECT: "Select Bone",
  FE_42_ZQ_SK_CONNECT: "Connect",
  FE_42_ZQ_SK_ENABLE: "Enable",
  FE_42_ZQ_SK_GROUP: "Mutually Exclusive Group",
  FE_42_ZQ_SK_GROUPCONTROL: "Manage Mutually Exclusive Group",
  FE_42_ZQ_SK_MUTUALTIPS: "Under the same Mutually Exclusive Group, modifying the designated appearance group will render the other appearance groups invalid.",
  FE_42_ZQ_SK_NEWAPPEARENCE: "New Appearance",
  FE_42_ZQ_SK_NEWAPPEARENCEGROUP: "New Appearance Group",
  FE_42_ZQ_SK_NOBONE: "Unable to find corresponding bone",
  FE_42_ZQ_SK_NORMALMESH: "Regular Mesh",
  FE_42_ZQ_SK_PARENTSK: "Parent Skeleton",
  FE_42_ZQ_SK_SK: "Skeleton",
  FE_42_ZQ_SK_SKINFO: "Bone Details",
  FE_42_ZQ_SK_SKINNED: "Skinned",
  FE_42_ZQ_SK_SKINNEDMESH: "Skinned Mesh",
  FE_42_ZQ_SK_SKSELECT: "Select Skeleton",
  FE_42_ZQ_SK_WARNING: "{1} not found in {0}",
  FE_42_ZQ_STORE_ADDED: "Added to Assets",
  FE_42_ZQ_STORE_ADDFILE: "Please add a file",
  FE_42_ZQ_STORE_ASSETS: "Assets",
  FE_42_ZQ_STORE_AUTHOR: "Creator",
  FE_42_ZQ_STORE_BUILDFAIL: "Export failed",
  FE_42_ZQ_STORE_BUILDPCK: "Publish Asset Pack",
  FE_42_ZQ_STORE_BUILDPLACE: "Publishing asset... You can view details via My Assets > Published.",
  FE_42_ZQ_STORE_BUILDSUC: "Operation successful!",
  FE_42_ZQ_STORE_BUILDTIPS: "Asset successfully generated! Publish now?",
  FE_42_ZQ_STORE_CHANGEFILE: "Switch File",
  FE_42_ZQ_STORE_CHOOSEPCK: "Select Asset Type to Download",
  FE_42_ZQ_STORE_CLOSE: "This project is occupied by another task. Please end that task and try again. If the task has already been ended, please try again later.",
  FE_42_ZQ_STORE_CURRENT_PROJECT_ONLY: "You can only import the current project.",
  FE_42_ZQ_STORE_DESCRIPTION: "Description",
  FE_42_ZQ_STORE_DOWNLOAD: "Download Asset",
  FE_42_ZQ_STORE_DOWNLOADED: "Downloaded",
  FE_42_ZQ_STORE_FREE: "Free",
  FE_42_ZQ_STORE_FULLPCK: "Full Pack",
  FE_42_ZQ_STORE_FULLPCKSUC: "Successfully notified the project to import the entire pack.",
  FE_42_ZQ_STORE_FULLPCKTIPS: "Supports editing. Bigger file size.",
  FE_42_ZQ_STORE_GET: "Get",
  FE_42_ZQ_STORE_IMPORT: "Import",
  FE_42_ZQ_STORE_MYASSET: "My Assets",
  FE_42_ZQ_STORE_MYUPLOAD: "Published",
  FE_42_ZQ_STORE_NAME: "Title",
  FE_42_ZQ_STORE_NOASSET: "No asset obtained",
  FE_42_ZQ_STORE_NORESULT: "No related results. Please try another keyword.",
  FE_42_ZQ_STORE_NOTDOWNLOAD: "Not downloaded",
  FE_42_ZQ_STORE_NOTUPLOADED: "Unpublished",
  FE_42_ZQ_STORE_NOUPLOAD: "No asset uploaded",
  FE_42_ZQ_STORE_OPENPROJECT: "Import the entire pack by opening a new project.",
  FE_42_ZQ_STORE_OWNED: "Obtained",
  FE_42_ZQ_STORE_PICTIPS: "Recommended size: {0}px. Size must be within {1}.",
  FE_42_ZQ_STORE_PICWARNING: "File size has exceeded {0}.",
  FE_42_ZQ_STORE_PRICE: "Price",
  FE_42_ZQ_STORE_REDOWNLOAD: "Redownload",
  FE_42_ZQ_STORE_RELOAD: "Replacing the reference pack. You will need to reload the project.",
  FE_42_ZQ_STORE_RENEWAL: "Recently Updated",
  FE_42_ZQ_STORE_RESNAME: "Nickname must be within {0} to {1} characters.",
  FE_42_ZQ_STORE_RESPCK: "Reference Pack",
  FE_42_ZQ_STORE_RESPCKSUC: "Successfully imported the reference pack",
  FE_42_ZQ_STORE_RESPCKTIPS: "Does not support editing. Smaller and faster file size.",
  FE_42_ZQ_STORE_SELECTFILE: "Select a file",
  FE_42_ZQ_STORE_SELECTIMPORT: "Select Asset",
  FE_42_ZQ_STORE_UPDATE: "Tap here to update the asset.",
  FE_42_ZQ_STORE_UPDATEANDUPLOAD: "Publish",
  FE_42_ZQ_STORE_UPDATECONFIRM: "Update the asset packs? Once confirmed, other users will be required to update assets.",
  FE_42_ZQ_STORE_UPDATEDOWNLOAD: "Update Download",
  FE_42_ZQ_STORE_UPLOAD: "Upload",
  FE_42_ZQ_STORE_UPLOADCANCEL: "Content filled will not be saved. Confirm to cancel the upload?",
  FE_42_ZQ_STORE_UPLOADED: "Published",
  FE_42_ZQ_STORE_UPLOADING: "Publishing...",
  FE_43A_HZY_ACCOUNT_BOUNDTIP: "A logged-in Free Fire account has been detected. If you quit the binding process now, the detected account information will be cleared.",
  FE_43A_HZY_ACCOUNT_UNBOUND: "Unbound",
  FE_43A_HZY_ERROR_TIP1: "may not be converted to",
  FE_43A_HZY_ERROR_TIP2: "Did not find",
  FE_43A_HZY_PROJECT_SCREEN: "Filters",
  FE_43A_HZY_PROJECT_SCREENRESET: "Reset Filters",
  FE_43A_HZY_SCENE_ALIGNMENT: "Alignment",
  FE_43A_HZY_SCENE_ALIGNMENTSET: "Alignment Settings",
  FE_43A_HZY_SCENE_ALIGNMENTTIP: "Hold the Ctrl key to quickly enable/disable this feature",
  FE_43A_HZY_SCENE_CAMERASPEED: "Adjust Camera Movespeed in Scene",
  FE_43A_HZY_SCENE_OPERATETIP: "Tooltips",
  FE_43A_HZY_SCENE_OPERATE_TIP1: "Select/Marquee",
  FE_43A_HZY_SCENE_OPERATE_TIP10: "Cancel Terrain",
  FE_43A_HZY_SCENE_OPERATE_TIP11: "Cancel",
  FE_43A_HZY_SCENE_OPERATE_TIP12: "Erase Selected Vegetation",
  FE_43A_HZY_SCENE_OPERATE_TIP13: "Erase All Vegetation",
  FE_43A_HZY_SCENE_OPERATE_TIP2: "Rotate",
  FE_43A_HZY_SCENE_OPERATE_TIP3: "Move/Zoom",
  FE_43A_HZY_SCENE_OPERATE_TIP4: "Quick Drag",
  FE_43A_HZY_SCENE_OPERATE_TIP5: "Move",
  FE_43A_HZY_SCENE_OPERATE_TIP6: "Up/Down",
  FE_43A_HZY_SCENE_OPERATE_TIP7: "Accelerate",
  FE_43A_HZY_SCENE_OPERATE_TIP8: "Place",
  FE_43A_HZY_SCENE_OPERATE_TIP9: "Exit",
  FE_43A_M_TASKS: "Craftland Mission Settings",
  FE_43A_M_TASKS2: "Mission Settings",
  FE_43A_M_TASKS3: "Progress",
  FE_43A_SD_CLOTH_RES: "Clothes",
  FE_43A_SD_CSV_RES: "CSV",
  FE_43A_SD_ECAC_RES: "ECAC",
  FE_43A_SD_ECA_RES: "ECA",
  FE_43A_SD_EFFECT_RES: "Effect",
  FE_43A_SD_EMOTE_RES: "Emote",
  FE_43A_SD_FCGC_RES: "FCGC",
  FE_43A_SD_INTERNALHUD_RES: "InternalHUD",
  FE_43A_SD_ITEM_RES: "Item",
  FE_43A_SD_MOD_RES: "LevelObject",
  FE_43A_SD_OTHER_RES: "Other",
  FE_43A_SD_QUIT_INFOR: "You have not saved the following file(s) yet. Save now?",
  FE_43A_SD_SOUND_RES: "Sound",
  FE_43A_SD_TABM_CLOSE: "Close",
  FE_43A_SD_TABM_CLOSEOTHER: "Close Other Tabs",
  FE_43A_SD_TABM_CLOSERIGHT: "Close Right Tab",
  FE_43A_SD_TABM_LOCATIONOPEN: "Open Local File Location",
  FE_43A_SD_TABM_LOCATIONVIEW: "View File Location",
  FE_43A_SD_TABM_SAVEALL: "Save All Tabs",
  FE_43A_SD_TABM_SAVECURRENT: "Save Current File",
  FE_43A_SD_TEXTURE_RES: "Texture",
  FE_43A_SD_VEHICLESKIN_RES: "VehicleSkin",
  FE_43A_SD_WEAPONSKIN_RES: "WeaponSkin",
  FE_43_HJ_NFPP_3CRESOURCE: "3C Resources Download",
  FE_43_HJ_NFPP_SWITCH: "Use the latest FPP resources",
  FE_43_HZY_COMPLIANT_TIP: `Incompatible version found (Editor version: {0}, asset version: {1})
Some features may be missing. Continue?`,
  FE_43_HZY_UPDATE: "Version Update",
  FE_43_HZY_UPDATE_CANCEL: "Update Later",
  FE_43_HZY_UPDATE_CONFIRM: "Update Now",
  FE_43_HZY_UPDATE_MENU_TEST: "Check Updates",
  FE_43_HZY_UPDATE_NETWORKERROR: "Network error. Please try again later.",
  FE_43_HZY_UPDATE_RETRY_TIP: "This will clear the current progress. Try redownload if progress stalls despite a stable connection.",
  FE_43_HZY_UPDATE_SAVE: "Save and Update",
  FE_43_HZY_UPDATE_TEST: "Check Version",
  FE_43_HZY_UPDATE_TIP: "The current Editor version is outdated. Please save your files first and update the Editor to use the Publish feature.",
  FE_43_HZY_UPDATE_TIP1: "Editor already up to date",
  FE_43_HZY_UPDATE_TIP2: `Version verification failed.
Not connected to the server. Please check your network and try again.`,
  FE_43_HZY_UPDATE_W_CLOSETIP: "Downloading Craftland Sudio {0}. Are you sure you want to quit?",
  FE_43_HZY_UPDATE_W_DEFAULT: `1. Fixed some of the known bugs.
2. Optimized some of the details for a better experience.`,
  FE_43_HZY_UPDATE_W_DETAIL: "Updates on {0}",
  FE_43_HZY_UPDATE_W_LOAD: "Downloading...",
  FE_43_HZY_UPDATE_W_RECONNECT: "Reconnecting...",
  FE_43_HZY_UPDATE_W_RETRY: "Redownload",
  FE_43_HZY_UPDATE_W_TIP1: "Notice: New version found. It is recommended to update the current version {0} to the latest one.",
  FE_43_HZY_UPDATE_W_TIP2: "Notice: Your current version {0} is outdated. Please update to continue using.",
  FE_43_HZY_UPDATE_W_WEB: "View Website",
  FE_43_M_BOMBERSCRIPT: "Bombarded (Script)",
  FE_43_SD_ASSETS: "Assets",
  FE_43_SD_ASSETS_IMPACK: "Import Package",
  FE_43_SD_ASSETS_IMPORT: "Import",
  FE_43_SD_ASSETS_OUTPACK: "Export as Package",
  FE_43_SD_ASSETS_PACKSHOP: "Asset Store",
  FE_43_SD_ASSETS_UPLOADPACK: "Build & Upload Package",
  FE_43_SD_EDIT: "Edit",
  FE_43_SD_EDIT_COPY: "Copy",
  FE_43_SD_EDIT_DELETE: "Delete",
  FE_43_SD_EDIT_DUPLICATE: "Duplicate",
  FE_43_SD_EDIT_FOCUS: "Focus",
  FE_43_SD_EDIT_PASTE: "Paste",
  FE_43_SD_EDIT_REDO: "Redo",
  FE_43_SD_EDIT_RENAME: "Rename",
  FE_43_SD_EDIT_SAVE: "Save",
  FE_43_SD_EDIT_UNDO: "Undo",
  FE_43_SD_ERROR_DIVISOR: "The divisor cannot be 0",
  FE_43_SD_ERROR_KEY_NOTINMAP: "The key does not exist in the map: {0}",
  FE_43_SD_ERROR_LIST_OUTRANGE: "List index out of range: {0}",
  FE_43_SD_FCG_ASSETLOST: "File lost. Sub-register content invalid.",
  FE_43_SD_FCG_ASS_RES: "Register Asset",
  FE_43_SD_FCG_DELETE_TEXT_B: "Delete the asset registration?",
  FE_43_SD_FCG_DELETE_TEXT_F: "You have already registered the asset child node. The node registration will be invalid if you delete the asset registration.",
  FE_43_SD_FCG_DELETE_WIN: "Notice",
  FE_43_SD_FCG_ENTITYSELETE: "Entity Selection",
  FE_43_SD_FCG_FCG_RES: "FCG",
  FE_43_SD_FCG_FILESELETE: "File Selection",
  FE_43_SD_FCG_KEY_NAMEINL: "Illegal key name",
  FE_43_SD_FCG_N_DICT: "Script Variable Name",
  FE_43_SD_FCG_N_ENUM: "Enum Name",
  FE_43_SD_FCG_N_GRAPH: "Graph Name",
  FE_43_SD_FCG_OBJ_RES: "Register Scene Object",
  FE_43_SD_FCG_PREFAB_RES: "Prefab",
  FE_43_SD_FCG_SCE_RES: "Scene",
  FE_43_SD_FCG_SCE_WAITRESIST: "Please register the scene file first",
  FE_43_SD_FCG_SYN_DES: "Reference Syntax",
  FE_43_SD_FCG_UI_RES: "UI",
  FE_43_SD_FCG_UI_WAITRESIST: "Please register the UI file first",
  FE_43_SD_FCG_UI_WID_RES: "Register UI Control",
  FE_43_SD_FCG_WINDOWNAME: "Register Script Asset",
  FE_43_SD_FILE: "File",
  FE_43_SD_FILE_BUILD: "Build",
  FE_43_SD_FILE_EXIT: "Exit",
  FE_43_SD_FILE_MODULE: "System Settings",
  FE_43_SD_FILE_NEW: "New Project",
  FE_43_SD_FILE_OPEN: "Open Project",
  FE_43_SD_FILE_PUBLISH: "Publish Project",
  FE_43_SD_FILE_QUITRUN: "Quit",
  FE_43_SD_FILE_RUN: "Run",
  FE_43_SD_FILE_SAVE: "Save Project",
  FE_43_SD_HELP: "Help",
  FE_43_SD_HELP_ABOUT: "About",
  FE_43_SD_HELP_ACCOUNT: "Manage Account",
  FE_43_SD_HELP_APIMANUAL: "API Reference",
  FE_43_SD_HELP_CONTACT: "Contact Us",
  FE_43_SD_HELP_SUGGEST: "Feedback & Suggestions",
  FE_43_SD_HELP_UPDATE: "Version Update",
  FE_43_SD_HELP_UPDATELOG: "Update Log",
  FE_43_SD_HELP_USERMANUAL: "User Manual",
  FE_43_SD_MODULE_ENTRY: "System Settings",
  FE_43_SD_SINGLEFILE_SAVE: "Save",
  FE_43_SD_TOOLS: "Tools",
  FE_43_SD_TOOLS_COMPONENT: "Component Manager",
  FE_43_SD_TOOLS_DEBUG: "Debug Settings",
  FE_43_SD_TOOLS_DEVELOPER: "Developer Tools",
  FE_43_SD_TOOLS_ENUM: "Enum Manager",
  FE_43_SD_TOOLS_FCG: "Script Tools",
  FE_43_SD_TOOLS_FCG_NAME: "Quick Script Naming",
  FE_43_SD_TOOLS_FCG_REGISTER: "Register Script Assets",
  FE_43_SD_TOOLS_LOC: "Local Settings",
  FE_43_SD_TOOLS_OPENLOG: "Open Log",
  FE_43_SD_TOOLS_PREFER: "Preferences",
  FE_43_SD_TOOLS_SEARCH: "Search All",
  FE_43_SD_TOOLS_WORDFILTER: "Profanity Filter",
  FE_43_SD_WINDOW: "Window",
  FE_43_SD_WINDOW_DECK: "Deck",
  FE_43_SD_WINDOW_FULL: "Full Screen",
  FE_43_SD_WINDOW_LAYOUT: "Layout",
  FE_43_SD_WINDOW_LAYOUT_DEF: "Default",
  FE_43_SD_WINDOW_LAYOUT_DEL: "Delete Layout",
  FE_43_SD_WINDOW_LAYOUT_SAVE: "Save Layout",
  FE_43_TYC_ENABLE_UGC_SPECTATOR: "Enable Spectator Mode",
  FE_43_TYC_FREE_PERSPECTIVE: "Free Look",
  FE_43_TYC_FREE_PERSPECTIVE_WITH_REBOUND: "Free Look with View Reset",
  FE_43_TYC_KEEP_TARGET_PERSPECTIVE: "Lock on Target Player",
  FE_43_TYC_ONLY_ALLOW_SPECTATING_SELF: "Myself Only",
  FE_43_TYC_ONLY_SPECTATING_ALLIES: "Friendly Players Only",
  FE_43_TYC_ONLY_SPECTATING_SAME_FACTION: "Faction Members Only",
  FE_43_TYC_ONLY_SPECTATING_SAME_TEAM: "Teammates Only",
  FE_43_TYC_PHYSICS_DESC_ANG: "In degrees. If the angle of the slope exceeds this value, the character will not be able to walk up and the controller will slide down.",
  FE_43_TYC_PHYSICS_DESC_G: "The gravitational acceleration applied to the character controller",
  FE_43_TYC_PHYSICS_DESC_H: "The height of the capsule collider, which includes the height of the hemispheres.",
  FE_43_TYC_PHYSICS_DESC_MAX_V: "The absolute speed of the character controller cannot exceed this value",
  FE_43_TYC_PHYSICS_DESC_MIN_D: "If the movement distance is less than this value, the character will not move at all.",
  FE_43_TYC_PHYSICS_DESC_OFFSET: "The offset vector from the center of transformation to the center of the capsule collider",
  FE_43_TYC_PHYSICS_DESC_R: "The radius of the capsule collider. It cannot exceed half of the collider's height.",
  FE_43_TYC_PHYSICS_DESC_SKIN_W: "The depth of penetration into the capsule to prevent the character from getting stuck or jittering",
  FE_43_TYC_PHYSICS_DESC_VTD: "The offset distance allowed for the character while stepping up/down a stair without deviating from the plane or being blocked",
  FE_43_TYC_SHOW_LOBBY_BUTTON: "Show Lobby Button",
  FE_43_TYC_SPECTATING_ANY_TARGET: "Anyone",
  FE_43_TYC_SPECTATOR_CAMERA_CONTROL_SETTING: "Spectator Camera Controls",
  FE_43_TYC_SPECTATOR_SETTINGS: "Spectator Settings",
  FE_43_TYC_SPECTATOR_TARGET_SETTING: "Spectator Target",
  FE_43_TYC_UIED_TEXT_CLIPPING_SETTING: "Text Clipping",
  FE_43_TYC_UIED_TEXT_DIRECT_CLIPPING: "Clip Overflowed Text",
  FE_43_TYC_UIED_TEXT_NO_CLIPPING: "Do Not Clip",
  FE_43_TYC_UIED_TEXT_REDUCE_FONT_SIZE: "Reduce Font Size",
  FE_43_TYC_UIED_TEXT_SHADOW_COLOR: "Shadow Color",
  FE_43_TYC_UIED_TEXT_SHADOW_ENABLED: "Enable Shadow",
  FE_43_TYC_UIED_TEXT_SHADOW_OFFSET: "Shadow Offset",
  FE_43_TYC_UNEDITABEL_INTERNAL_TEXTURE: "This is a Free Fire asset. You cannot edit it.",
  FE_43_XXJ_COPYCOMPONENT: "Copy Component",
  FE_43_XXJ_GETVECTOR2COMPONENT: "Get Vector2 Component",
  FE_43_XXJ_GETVECTOR3COMPONENT: "Get Vector3 Component",
  FE_43_XXJ_MODULEUNOPENED: "Please enable the following modules and try again.",
  FE_43_XXJ_PASTECOMPNEW: "Paste Component as New",
  FE_43_XXJ_PASTECOMPVALUE: "Paste Component Values",
  FE_43_XXJ_PHYSICS_ISCONVEX: "Is Convex",
  FE_43_XXJ_REQUIRECOMP: "Require Component",
  FE_43_XXJ_SETVECTOR2COMPONENT: "Set Vector2 Component",
  FE_43_XXJ_SETVECTOR3COMPONENT: "Set Vector3 Component",
  FE_43_XXJ_VECTOR2OPERATIONS: "Vector2 Operation",
  FE_43_XXJ_VECTOR3OPERATIONS: "Vector3 Operation",
  FE_43_XYL_AUTORENDERING: "Auto Merge & Render Instances",
  FE_43_XYL_BATCHING: "Batching",
  FE_43_XYL_CLIENT: "Client",
  FE_43_XYL_CLIENTFCG: "Client FCG",
  FE_43_XYL_CLINETECA: "Client ECA",
  FE_43_XYL_CROSSEND: "Send across ends?",
  FE_43_XYL_CULLBACK: "Cull Back",
  FE_43_XYL_CULLMODE: "Cull Mode",
  FE_43_XYL_CULLOFF: "Cull Off",
  FE_43_XYL_ECACTEMPLATE: "ECAC Template",
  FE_43_XYL_EVENTTARGETSIDE: "Event Side",
  FE_43_XYL_INHERITRENDERINGOPT: "Inherit Parent Setting",
  FE_43_XYL_MASKCOLOR: "Mask Color",
  FE_43_XYL_MASKTEXTURE: "Mask Texture",
  FE_43_XYL_MERGEMODELS: "Auto Merge Models",
  FE_43_XYL_NOTIFYCLIENT: "Notify Client",
  FE_43_XYL_OFFLINECHILD: "Merge Child Node Models While Offline",
  FE_43_XYL_ONLINECHILD: "Merge Child Node Models at Runtime",
  FE_43_XYL_PREFORMANCEOPT: "Map Performance Optimization",
  FE_43_XYL_REDUCTION: "Mesh Decimation",
  FE_43_XYL_RENDERINGOPT: "Rendering Performance Optimization",
  FE_43_XYL_SERVER: "Server",
  FE_43_XYL_SERVERCLIENT: "Client & Server",
  FE_43_XYL_SERVERECA: "Server ECA",
  FE_43_XYL_SERVERFCG: "Server FCG",
  FE_43_XYL_STREAMINGDIST: "Streaming Distance",
  FE_43_XYL_STREAMINGDIVD: "Divided Area Size",
  FE_43_YU_WS_MODULEOPERATION: "You must load the module first to use this",
  FE_43_YU_WS_MODULE_ALL: "All",
  FE_43_YU_WS_MODULE_BELONGEDMODULEDISABLE: "The dependency modules are inactive",
  FE_43_YU_WS_MODULE_BELONGEDMODULEMISS: "The corresponding modules have not been enabled:",
  FE_43_YU_WS_MODULE_CANCEL: "Cancel",
  FE_43_YU_WS_MODULE_CANNOTINSTALLEDMODULES: "Cannot install the test module for the live version",
  FE_43_YU_WS_MODULE_CANNOTINSTALLINTERNALMODULE: "You do not have permission to install this module:",
  FE_43_YU_WS_MODULE_CONFIRMTHEUNINSTALL: "All used APIs, events, and assets of the module will become invalid. Confirm to uninstall?",
  FE_43_YU_WS_MODULE_CUSTOMCURRENCY: "Custom Currency",
  FE_43_YU_WS_MODULE_CUSTOMMINIMAP: "Custom Minimap",
  FE_43_YU_WS_MODULE_DEATHWATCH: "Spectator Mode",
  FE_43_YU_WS_MODULE_DEFAULTMINIMAP: "Default Minimap",
  FE_43_YU_WS_MODULE_DELETIONFAILED: "Failed to delete the module configuration",
  FE_43_YU_WS_MODULE_DESCRIPTION: "Description",
  FE_43_YU_WS_MODULE_DISABLE: "Disable",
  FE_43_YU_WS_MODULE_DISABLEMODULE: "The dependency modules are inactive. Please enable all of them to use the related features. The inactive dependencies include:",
  FE_43_YU_WS_MODULE_EXCLUSIVEMODULE: "The modules conflicting with the current one have been enabled. Please make sure all of them are disabled. These modules include:",
  FE_43_YU_WS_MODULE_EXITEXCLUSIVEMODULE: "There are conflicting modules",
  FE_43_YU_WS_MODULE_FUNCTIONSTATUS: "Enable Features",
  FE_43_YU_WS_MODULE_LOADED: "Loaded",
  FE_43_YU_WS_MODULE_LOADING: "Load",
  FE_43_YU_WS_MODULE_LOADINGTIPS: "Loading Notice",
  FE_43_YU_WS_MODULE_MARKEDDISCARD: "The module has been deprecated and will no longer be supported in the future versions. Please stop using it to avoid potential risks.",
  FE_43_YU_WS_MODULE_MINIMAPTYPE: "Minimap Type",
  FE_43_YU_WS_MODULE_MODMOVED: "The module has been deleted",
  FE_43_YU_WS_MODULE_MODULEMANAGEMENT: "Module Manager",
  FE_43_YU_WS_MODULE_NAME: "Module",
  FE_43_YU_WS_MODULE_NOTLOADED: "Unloaded",
  FE_43_YU_WS_MODULE_NUMBEROFPLAYERS: "Number of Players",
  FE_43_YU_WS_MODULE_ONECLICKLOADING: "Load All",
  FE_43_YU_WS_MODULE_ONLINEDATAMANAGEMENT: "Online Management",
  FE_43_YU_WS_MODULE_OPENTHEMOD: "Enable Module:",
  FE_43_YU_WS_MODULE_PRESETTYPE: "Preset Character Type",
  FE_43_YU_WS_MODULE_REGISTRATIONFAILED: "Registration failed",
  FE_43_YU_WS_MODULE_SCENE: "Scene",
  FE_43_YU_WS_MODULE_SETTINGS: "Settings",
  FE_43_YU_WS_MODULE_SPECIALSETTINGS: "Special Settings",
  FE_43_YU_WS_MODULE_TYPESELECTION: "Type Selection",
  FE_43_YU_WS_MODULE_UNINSTALL: "Uninstall",
  FE_43_YU_WS_MODULE_UNINSTALLED: "Module uninstalled successfully",
  FE_43_YU_WS_MODULE_UNINSTALLPROMPT: "Uninstalling Notice",
  FE_43_YU_WS_MODULE_UNLOADEDDEPENDENCYFEATURES: "This module contain dependencies that must be uploaded and enabled for you to use the related features. The unloaded dependencies include:",
  FE_43_YU_WS_MODULE_WARNING1: "The entry does not exist in the configuration table",
  FE_43_YU_WS_MODULE_WARNING2: "Configuration table error",
  FE_43_ZQ_PLAYER_ACTION: "Action",
  FE_43_ZQ_PLAYER_ADDACTION: "Add Character Action",
  FE_43_ZQ_PLAYER_ATTACK1FIST: "Left Attack",
  FE_43_ZQ_PLAYER_ATTACK2FIST: "Right Attack",
  FE_43_ZQ_PLAYER_ATTACK2GUN: "Fire (Rifle)",
  FE_43_ZQ_PLAYER_ATTACK2PISTOL: "Fire (Pistol)",
  FE_43_ZQ_PLAYER_BONETIPS: "Some skeletons do not match those of the characters in Free Fire. This may cause animations to play incorrectly.",
  FE_43_ZQ_PLAYER_CACTION: "Character Action",
  FE_43_ZQ_PLAYER_CHANGECLIPGUN: "Reload (Rifle)",
  FE_43_ZQ_PLAYER_CHANGECLIPPISTOL: "Reload (Pistol)",
  FE_43_ZQ_PLAYER_CHANGEWEAPON: "Switch Weapon",
  FE_43_ZQ_PLAYER_CMESH: "Character Mesh",
  FE_43_ZQ_PLAYER_CRAWIDLEFIST: "Prone",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPGUN: "Reload While Prone (Rifle)",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPPISTOL: "Reload While Prone (Pistol)",
  FE_43_ZQ_PLAYER_CRAWLCHANGEWEAPON: "Switch Weapon While Prone",
  FE_43_ZQ_PLAYER_CRAWLFFIST: "Move While Prone",
  FE_43_ZQ_PLAYER_CRAWLFGUN: "Move While Prone (Rifle)",
  FE_43_ZQ_PLAYER_CRAWLFIREGUN: "Aim While Prone (Rifle)",
  FE_43_ZQ_PLAYER_CRAWLFIREPISTOL: "Aim While Prone (Pistol)",
  FE_43_ZQ_PLAYER_CRAWLFIRINGGUN: "Fire While Prone (Rifle)",
  FE_43_ZQ_PLAYER_CRAWLFIRINGPISTOL: "Fire While Prone (Pistol)",
  FE_43_ZQ_PLAYER_CRAWLFPISTOL: "Move While Prone (Pistol)",
  FE_43_ZQ_PLAYER_CRAWLIDLEGUN: "Prone (Rifle)",
  FE_43_ZQ_PLAYER_CRAWLIDLEPISTOL: "Prone (Pistol)",
  FE_43_ZQ_PLAYER_CROUCHATTACK1FIST: "Left Attack While Crouching",
  FE_43_ZQ_PLAYER_CROUCHATTACK2FIST: "Right Attack While Crouching",
  FE_43_ZQ_PLAYER_CROUCHATTACK2GUN: "Fire While Crouching (Rifle)",
  FE_43_ZQ_PLAYER_CROUCHATTACK2PISTOL: "Fire While Crouching (Pistol)",
  FE_43_ZQ_PLAYER_CROUCHBGUN: "Crouch Walk Backward While Aiming (Rifle)",
  FE_43_ZQ_PLAYER_CROUCHBPISTOL: "Crouch Walk Backward While Aiming (Pistol)",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPGUN: "Reload While Crouching (Rifle)",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPPISTOL: "Reload While Crouching (Pistol)",
  FE_43_ZQ_PLAYER_CROUCHCHANGEWEAPON: "Switch Weapon While Crouching",
  FE_43_ZQ_PLAYER_CROUCHFFIST: "Move While Crouching",
  FE_43_ZQ_PLAYER_CROUCHFGUN: "Move While Crouching (Rifle)",
  FE_43_ZQ_PLAYER_CROUCHFPISTOL: "Move While Crouching (Pistol)",
  FE_43_ZQ_PLAYER_CROUCHIDLEFIST: "Crouch",
  FE_43_ZQ_PLAYER_CROUCHIDLEGUN: "Crouch (Rifle)",
  FE_43_ZQ_PLAYER_CROUCHIDLEPISTOL: "Crouch (Pistol)",
  FE_43_ZQ_PLAYER_CROUCHLGUN: "Crouch Walk Left While Aiming (Rifle)",
  FE_43_ZQ_PLAYER_CROUCHLPISTOL: "Crouch Walk Left While Aiming (Pistol)",
  FE_43_ZQ_PLAYER_CROUCHRGUN: "Crouch Walk Right While Aiming (Rifle)",
  FE_43_ZQ_PLAYER_CROUCHRPISTOL: "Crouch Walk Right While Aiming (Pistol)",
  FE_43_ZQ_PLAYER_CUSTOMP: "Player Data",
  FE_43_ZQ_PLAYER_DACTION: "Default Action",
  FE_43_ZQ_PLAYER_DASHRUNFFIST: "Sprint",
  FE_43_ZQ_PLAYER_DASHRUNFGUN: "Sprint (Rifle)",
  FE_43_ZQ_PLAYER_DASHRUNFPISTOL: "Sprint (Pistol)",
  FE_43_ZQ_PLAYER_DRIVERIDLE: "Set as Driver Idle",
  FE_43_ZQ_PLAYER_FEMALE: "Female",
  FE_43_ZQ_PLAYER_GENDER: "Gender",
  FE_43_ZQ_PLAYER_GETRIG: "Click here to get the default rig",
  FE_43_ZQ_PLAYER_HIT: "Hit",
  FE_43_ZQ_PLAYER_IDLE: "Idle",
  FE_43_ZQ_PLAYER_INCARIDLE: "Set as Passenger Idle",
  FE_43_ZQ_PLAYER_JUMPDOWNFIST: "Falling",
  FE_43_ZQ_PLAYER_JUMPDOWNGUN: "Falling (Rifle)",
  FE_43_ZQ_PLAYER_JUMPDOWNPISTOL: "Falling (Pistol)",
  FE_43_ZQ_PLAYER_JUMPLANDFIST: "Landing",
  FE_43_ZQ_PLAYER_JUMPLANDGUN: "Landing (Rifle)",
  FE_43_ZQ_PLAYER_JUMPLANDPISTOL: "Landing (Pistol)",
  FE_43_ZQ_PLAYER_JUMPUPFIST: "Jump Start",
  FE_43_ZQ_PLAYER_JUMPUPGUN: "Jump Start (Rifle)",
  FE_43_ZQ_PLAYER_JUMPUPPISTOL: "Jump Start (Pistol)",
  FE_43_ZQ_PLAYER_LINE: "Underline",
  FE_43_ZQ_PLAYER_MALE: "Male",
  FE_43_ZQ_PLAYER_MOVE: "Move",
  FE_43_ZQ_PLAYER_NEARDEATHIDLE: "Knocked Down",
  FE_43_ZQ_PLAYER_NEARDEATHMOVE: "Crawl Forward While Down",
  FE_43_ZQ_PLAYER_NEWCUSTOMP: "New Preset Character",
  FE_43_ZQ_PLAYER_NORMALDEAD: "Eliminated",
  FE_43_ZQ_PLAYER_ONLYADDEDANIM: "Play Added Actions Only",
  FE_43_ZQ_PLAYER_PLATFORM: "Free Fire Character",
  FE_43_ZQ_PLAYER_PREVIEWTIPS: "Please add a model first!",
  FE_43_ZQ_PLAYER_RIG: "Get Default Rig",
  FE_43_ZQ_PLAYER_RIGTIPS: "If you would like to modify the character mesh, it is recommended to use the official rigs and import them into other modeling software to ensure all default animations can play correctly.",
  FE_43_ZQ_PLAYER_RUNFFIST: "Move Forward",
  FE_43_ZQ_PLAYER_RUNFGUN: "Move Forward (Rifle)",
  FE_43_ZQ_PLAYER_RUNFPISTOL: "Move Forward (Pistol)",
  FE_43_ZQ_PLAYER_SHOOTIDLEGUN: "Aim While Standing (Rifle)",
  FE_43_ZQ_PLAYER_SHOOTIDLEPISTOL: "Aim While Standing (Pistol)",
  FE_43_ZQ_PLAYER_STANDIDLEFIST: "Stand",
  FE_43_ZQ_PLAYER_STANDIDLEGUN: "Stand (Rifle)",
  FE_43_ZQ_PLAYER_STANDIDLEPISTOL: "Stand (Pistol)",
  FE_43_ZQ_PLAYER_WALKBGUN: "Move Backward While Aiming (Rifle)",
  FE_43_ZQ_PLAYER_WALKBPISTOL: "Move Backward While Aiming (Pistol)",
  FE_43_ZQ_PLAYER_WALKFGUN: "Move Forward While Aiming (Rifle)",
  FE_43_ZQ_PLAYER_WALKFPISTOL: "Move Forward While Aiming (Pistol)",
  FE_43_ZQ_PLAYER_WALKLGUN: "Move Left While Aiming (Rifle)",
  FE_43_ZQ_PLAYER_WALKLPISTOL: "Move Left While Aiming (Pistol)",
  FE_43_ZQ_PLAYER_WALKRGUN: "Move Right While Aiming (Rifle)",
  FE_43_ZQ_PLAYER_WALKRPISTOL: "Move Right While Aiming (Pistol)",
  FE_43_ZQ_REMOVE_REMOVE: "Remove",
  FE_43_ZQ_REVIEW_LINEROW: "{3} has been detected as a sensitive word in Row {1}, Column {2} of {0}. Please revise and try again.",
  FE_43_ZQ_REVIEW_MEANNING: "Sensitive information detected in {0}. Please revise and try again.",
  FE_43_ZQ_STORE_BACK: "Back",
  FE_43_ZQ_STORE_CHANGEPROJECT: "This reference asset is from the current project. Please try another project.",
  FE_43_ZQ_STORE_CODE: "Asset Identification Code",
  FE_43_ZQ_STORE_CODECHANGE: "Asset Identification Code has been changed!",
  FE_43_ZQ_STORE_CREATE: "New Asset",
  FE_43_ZQ_STORE_DELETEPURCHASE: "Remove from Assets",
  FE_43_ZQ_STORE_DETAIL: "Details",
  FE_43_ZQ_STORE_DOWN: "Remove from Store",
  FE_43_ZQ_STORE_EDIT: "Edit",
  FE_43_ZQ_STORE_ESTSIZE: "Est. Size",
  FE_43_ZQ_STORE_FABCANNOT: "This asset cannot be packaged as a store asset",
  FE_43_ZQ_STORE_HIGHVERSION: "The store asset version is higher than the current version",
  FE_43_ZQ_STORE_NEEDLOGIN: "Please log in first to upload",
  FE_43_ZQ_STORE_NEWRES: "Publish New Asset",
  FE_43_ZQ_STORE_NEWRESTIPS: "Add Asset in Asset Store",
  FE_43_ZQ_STORE_NEXT: "Next",
  FE_43_ZQ_STORE_NOSEARCH: "No related asset found",
  FE_43_ZQ_STORE_OPENED: "Unable to quit Craftland Studio when the project is opened",
  FE_43_ZQ_STORE_PUBSET: "Publish Settings",
  FE_43_ZQ_STORE_QUOTECANNOT: "This asset cannot be packaged as a store asset because it or its reference contains assets from reference packs.",
  FE_43_ZQ_STORE_REMOVEMYASSET: "This asset will be removed from Assets, but the local files will not be deleted. Continue?",
  FE_43_ZQ_STORE_REMOVEMYUPLOAD: "This asset will be removed from Published. Continue?",
  FE_43_ZQ_STORE_RESDETAIL: "Asset Details",
  FE_43_ZQ_STORE_RESERRORTIPS: "Failed to save due to an operation error",
  FE_43_ZQ_STORE_RESSCENETIPS: "This is a reference asset and cannot be saved. It will be restored the next time you enter.",
  FE_43_ZQ_STORE_TRANSFERTIPS: "Transferring asset... The operation will be interrupted if you choose to quit. Continue?",
  FE_43_ZQ_STORE_TYPE: "Asset Type",
  FE_43_ZQ_STORE_UNPUB: "Removed from Store",
  FE_43_ZQ_STORE_UNPUBCONFIRM: "This asset will no longer be available to other users after you remove it from the store. Continue?",
  FE_43_ZQ_STORE_UPDATERES: "Update Asset",
  FE_43_ZQ_STORE_UPDATERESTIPS: "Replace the published assets in Asset Store.",
  FE_43_ZQ_STORE_UPDATETIME: "Update Time",
  FE_43_ZQ_STORE_UPLOAD: "Upload",
  FE_43_ZQ_STORE_UPTIME: "Upload Time",
  FE_43_ZQ_STORE_VERSION: "Editor Version",
  FE_44A_HJ_ERRORCODE1: "Custom event error",
  FE_44A_HJ_ERRORCODE2: "Custom type error",
  FE_44A_SD_SETTING_UNITTESTBUILD: "Use it to perform unit testing for QA purposes",
  FE_44A_SD_UNITTEST_BUILD: "Unit Test Build",
  FE_44A_XXJ_ACTION: "Action",
  FE_44A_XXJ_BASIC: "Basic",
  FE_44A_XXJ_COMPCONFLICK: "This component conflicts with other component(s): {0}.",
  FE_44A_XXJ_CONDITION: "Condition",
  FE_44A_XXJ_CSVDATA: "CSV Data",
  FE_44A_XXJ_DEPENDMISS: "Dependency component(s) not added yet: {0}",
  FE_44A_XXJ_SUPPLY: "Supply",
  FE_44A_XXJ_VARIABLE: "Variable",
  FE_44A_XXJ_WARNING_COMPCONFLICK: "{0}: The component {1} conflicts with {2}.",
  FE_44A_XXJ_WARNING_COMPDEPENDMISS: "{0}: The dependency component(s) {2} of {1} has or have not been added yet.",
  FE_44_HZY_BLADEBALL: "Blade Ball",
  FE_44_HZY_BLOCKINVALID_TIP1: "Block not supported on server",
  FE_44_HZY_BLOCKINVALID_TIP2: "Block not supported on client",
  FE_44_HZY_BLOCKPERMISSION_CONCSOLE: "You will not be able to publish this because you are using blocks for which you have no permissions",
  FE_44_HZY_BLOCKPERMISSION_WARNING: "You have no permission to use this block",
  FE_44_HZY_GUNKING: "Gun King",
  FE_44_HZY_HIERARCHY_MOUNTSCRIPT: "With scripts",
  FE_44_HZY_INSPECTOR_ADDCOMPONENT: "Add Component",
  FE_44_HZY_INSPECTOR_TEXTURE: "Texture",
  FE_44_HZY_INSPECTOR_TILLING: "Tiling",
  FE_44_HZY_INSPECTOR_TYPE: "Type",
  FE_44_HZY_MAPCOVER_PERMISIONTIP: "No permissions to use custom covers",
  FE_44_HZY_PERMISSIONTIPS1: "The project may contain assets you have no edit access to. This can cause errors during publishing.",
  FE_44_HZY_PERMISSIONTIPS2: "Unable to publish the project as it contains assets you have no edit access to",
  FE_44_HZY_PROJECT_BASICOBJECT: "Basic Object",
  FE_44_HZY_PROJECT_CREATIONTIME: "Sort by created time",
  FE_44_HZY_PROJECT_LASTEDITTIME: "Sort by last opened time",
  FE_44_HZY_PVE: "Zombie War",
  FE_44_HZY_REVIEW_BASE: "Basic Info",
  FE_44_HZY_REVIEW_ROOMPAR: "Custom Room Parameter",
  FE_44_HZY_SEARCH_FUNCTIONNAME: "Search by the Function Name",
  FE_44_HZY_SEARCH_VARIABLENAME: "Search by the Variable Name",
  FE_44_HZY_SNIPER: "Sniper",
  FE_44_M_WS_LOCALVAR: "Local Variable",
  FE_44_SD_CUSRESULT: "Upload Custom Match Result",
  FE_44_SD_EDIT_SELECT_ALL: "Select All",
  FE_44_SD_EDIT_SELECT_CHILD: "Select All Child",
  FE_44_SD_EDIT_SELECT_INV: "Inverse",
  FE_44_SD_EDIT_SELECT_PARENT: "Select Parent",
  FE_44_SD_FCG_COMPILE: "Compiling script",
  FE_44_SD_FCG_ENV: "Manually Deploy FCG Environment",
  FE_44_SD_TIPSFCG: "Script syntax",
  FE_44_TYC_ACTIVE: "Active Status",
  FE_44_TYC_ADD_ANIMATION_CLIP: "Please add animation",
  FE_44_TYC_ARROR: "Direction Arrow",
  FE_44_TYC_DRAG_RADIUS: "Drag Radius",
  FE_44_TYC_INACTIVE: "Inactive Status",
  FE_44_TYC_JOYSTICK: "Joystick",
  FE_44_TYC_JOYSTICK_BG: "Joystick Background",
  FE_44_TYC_JOYSTICK_CAP: "Joystick Cap",
  FE_44_TYC_KEEP_PRESSED_OUTSIDE: "Allow Drag Out of Range",
  FE_44_TYC_OFFSET: "Offset",
  FE_44_TYC_PLAYER_ANIMATION_NEED_SSS: "Please add animation for Stand, Stand (Rifle), and Stand (Pistol).",
  FE_44_TYC_RADIUS: "Radius",
  FE_44_TYC_TOGGLE: "Toggle Button",
  FE_44_TYC_TOUCHPAD: "Touchpad",
  FE_44_TYC_TRANSPARENCY: "Transparency",
  FE_44_TYC_WARNING_SERVER_DRIVEN_DISABLED: 'The attribute "IsServerDriven" of the Craftland character controller {0} has been disabled, so the related server API cannot take effect.',
  FE_44_XXJ_ASSETTYPE: "Asset Type",
  FE_44_XXJ_COMPOBSOLETE: "This component has been deprecated. Please remove it to avoid related issues.",
  FE_44_XXJ_EDITCCTSHAPE: "Edit CCT Shape",
  FE_44_XXJ_GAMERESULT: "Game Result",
  FE_44_XXJ_GETRIGISTERASSETBYKEY: "Get Registered Asset by Key",
  FE_44_XXJ_MODULEERROR: "Export failed due to conflicting modules. Please check module management settings and try again later.",
  FE_44_XXJ_PREPARING: "Coming soon",
  FE_44_XXJ_ROUNFPHASEINDEX: "Round & Phase Index",
  FE_44_XXJ_TIPCONTENTHIDE: "Number of item(s) hidden: {0}. Not all the lists contain these items.",
  FE_44_XXJ_WOWEMPTY: "Hmm... nothing to show here",
  FE_44_XXJ_WS_RIGISTERRESNAME: "Key",
  FE_44_XYL_AUTOLOD0: "Do not auto-generate LOD",
  FE_44_XYL_AUTOLOD1: "Model size > 15m",
  FE_44_XYL_AUTOLOD2: "2m < model size < 15m",
  FE_44_XYL_AUTOLOD3: "Model size < 2m",
  FE_44_XYL_AUTOREDUCTION: "Auto LOD Simplification",
  FE_44_XYL_DYNAMICNAVBLOCK: "Dynamic NavMesh Block",
  FE_44_XYL_DYNAMICNAVBLOCKDESC: "Generate or remove the block that hinders the mesh pathfinding based on the dynamic addition or removal status of the object. The global Dynamic NavMesh setting must be enabled first to use this feature.",
  FE_44_XYL_PREVIEWANIM: "Please select an animation file that can be previewed",
  FE_44_XYL_REDUCTIONLIST: "Mesh Decimation List",
  FE_44_XYL_SERVERSLOADAREA: "Server Loading Area",
  FE_44_XYL_SERVERSLOADAREACHILD: "Area",
  FE_44_XYL_SERVERSLOADCHOOSE: "Enable in-scene server loading area",
  FE_44_XYL_SERVERSLOADDESC: "Check this to allow for editing of the server loading area in Hierarchy and in the scene (feature currently not supported for large maps such as Bermuda, Kalahari, NeXTerra, and Solara)",
  FE_44_XYL_SERVERSLOADSETTING: "Server Loading Settings",
  FE_44_XYL_SERVERTOCLIENT: "Sync to Client",
  FE_44_XYL_SERVERTOCLIENTDESC: "Sync the server logic of the object to the client",
  FE_44_XYL_STREAMING0: "Always Stream",
  FE_44_ZQ_IMPORT_PCKWARNING: "The project already contains this resource pack. Importing it again may cause some of the assets to be replaced or references be disrupted. Continue anyway?",
  FE_44_ZQ_PREVIEW_RUNGAME: "This asset does not support preview. Please run the game to check it.",
  FE_44_ZQ_PREVIEW_SELECT: "Please select the model to preview",
  FE_44_ZQ_RES_LOST: "The reference asset {0} is lost",
  FE_44_ZQ_RES_NOEDIT: "From the reference asset: {0}. Cannot be edited.",
  FE_44_ZQ_RES_PHASETIPS: "Blocks with phase indices cannot be exported into reference packs",
  FE_44_ZQ_RES_PREECA: "Preset Script",
  FE_44_ZQ_RES_PRESFROM: "Referenced from {0}",
  FE_44_ZQ_RES_RESENUM: "Enum from Reference Pack",
  FE_45A_M_MODIFICATION: "Confirm to modify the data?",
  FE_45A_M_SAVEFAILED: "Error in modified data. Failed to save.",
  FE_45A_SD_ISSTATIC: "Is Static",
  FE_45A_SD_NAME_ECA: "Block Script",
  FE_45A_SD_NAME_ECAC: "Client Block Script",
  FE_45A_SD_NAME_FCC: "Custom Library",
  FE_45A_SD_NAME_FCG: "Code Script",
  FE_45A_SD_NAME_FCGC: "Client Code Script",
  FE_45A_SD_NAME_OTHER: "Other Script",
  FE_45A_SD_SCRIPTNAME_CURRENT: "Current Name",
  FE_45A_SD_SCRIPTNAME_HOLDER: "Enter name here",
  FE_45A_SD_SCRIPTNAME_TYPE: "Type",
  FE_45A_SD_STATICTIPS: "Static scripts will be automatically added to the Global entity and executed at runtime.",
  FE_45A_SD_STATIC_FILE: "Static Script",
  FE_45A_XXJ_ERRORCODE: "State Code",
  FE_45A_XXJ_OVERLIMIT: "Over Limit",
  FE_45A_XXJ_PARAMERROR: "Parameter Error",
  FE_45A_XXJ_TIMEOUT: "Time Out",
  FE_45A_XYL_FEBRUSHGRASS: "Max grass quantity",
  FE_45A_XYL_FEBRUSHROCK: "Max stone quantity",
  FE_45A_XYL_FEBRUSHSHRUB: "Max bush quantity",
  FE_45A_XYL_FEBRUSHTREE: "Max tree quantity",
  FE_45A_XYL_FEBRUSHWARN: "Unable to edit the terrains at the same time as they reference the same asset(s)",
  FE_45A_XYL_FETIPS1: "Exit Sculpt",
  FE_45A_XYL_FETIPS2: "Size Down",
  FE_45A_XYL_FETIPS3: "Size Up",
  FE_45A_XYL_FETIPS4: "Plant brush",
  FE_45A_XYL_FETIPS5: "Plant brush limit reached. Please reduce the quantity.",
  FE_45A_XYL_FETIPS6: "Terrain File",
  FE_45_HJ_PLATFORM_ADDFRIEND: "Add Friend Button",
  FE_45_HJ_PLATFORM_BRIGHT: "Button Style 1",
  FE_45_HJ_PLATFORM_DARK: "Button Style 2",
  FE_45_HJ_PLATFORM_PERMISSIONTIPS1: "You will not be able to publish the project, as your account does not have permissions for some of the UI widgets used.",
  FE_45_HJ_PLATFORM_REPORT: "Report Button",
  FE_45_HJ_PLATFORM_SEETING: "Friend Request Notification Type",
  FE_45_HJ_PLATFORM_SEETINGMESSAGE: "Message Notification",
  FE_45_HJ_PLATFORM_SEETINGTYPE: "Enable Friend Request Pop-Up",
  FE_45_HJ_PLATFORM_SEETINGWINDOW: "In-Match Pop-Up Notification",
  FE_45_HJ_PLATFORM_WIDGET: "Free Fire Function Widget",
  FE_45_HZY_FOURFRIENDS: "Four Friends",
  FE_45_HZY_FOURFRIENDS_D: "Explore this immersive puzzle gameplay in first-person perspective!",
  FE_45_HZY_SCENE_OPERATE_TIP14: "Rotate Along X/Y/Z Axis",
  FE_45_HZY_SCENE_OPERATE_TIP15: "Paint",
  FE_45_SD_AIS_AI: "AI Search",
  FE_45_SD_AIS_BTN: "Search with AI",
  FE_45_SD_AIS_DEF: "Default Search",
  FE_45_SD_AIS_NORESULT: "AI search did not find any new results",
  FE_45_SD_BASICTEMPLATE: "Basic Template",
  FE_45_SD_BERMUDA: "Bermuda",
  FE_45_SD_CREATE: "Create",
  FE_45_SD_DESC_BERMUDA: "A project without APIs and with the default terrain: Bermuda.",
  FE_45_SD_DESC_BLADEBALL: "Unlock different abilities and win the game!",
  FE_45_SD_DESC_BOMBER: "Place bombs to attack enemies and be careful not to hurt yourself",
  FE_45_SD_DESC_BOMBERSCRIPT: "A sample scripting project. Place bombs to attack your enemies, but be careful not to hurt yourself.",
  FE_45_SD_DESC_EMPTYMAP: "A project without APIs and with the default terrain: empty map.",
  FE_45_SD_DESC_GUNKING: "Use different weapons to eliminate as many enemies as you can",
  FE_45_SD_DESC_ISLANDL: "A project without APIs and with the default terrain: Isle of Champs (50*50).",
  FE_45_SD_DESC_ISLANDS: "A project without APIs and with the default terrain: Origin Island (100*100).",
  FE_45_SD_DESC_PVE: "Get powerful effects and eliminate the final boss!",
  FE_45_SD_DESC_SNIPER: "Make it out alive and become the master sniper!",
  FE_45_SD_EMPTYMAP: "Empty Map",
  FE_45_SD_GAMEPLAYTEMPLATE: "Gameplay Template",
  FE_45_SD_ISLAND_L: "Origin Land",
  FE_45_SD_ISLAND_S: "Isle of Champs",
  FE_45_SD_NEWPROJECT: "Project Management",
  FE_45_SD_PROJECTLOST: "The local file of the project does not exist",
  FE_45_SD_REGIST_DYNAMIC: "Dynamic Call",
  FE_45_SD_REGIST_LOST: "Unable to find the file (asset type: {1}, script name: {2}) in {0}",
  FE_45_SD_REGIST_STATIC: "Static Call",
  FE_45_SD_SPECIALTEMPLATE: "Special Template",
  FE_45_SD_SPRITE_RES: "Sprite File",
  FE_45_SD_TEXTURE_RES: "Texture File",
  FE_45_SD_TIMEOFMODIFY: "Modified Time",
  FE_45_SD_VERSION: "Version",
  FE_45_TYC_CCT_COLLISION_THRESHOLD: "Character Controller Collision Threshold",
  FE_45_TYC_CCT_COLLISION_THRESHOLD_ANNOT: "Set the collision threshold for the character controller when it touches a rigid body. If unmet, the controller will gently push the rigid body instead of causing a hard collision.",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH: "Enable Custom Push Force",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH_ANNOT: "Customize the push force exerted by the character controller on the rigid body",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY: "Orientation Follows Gravity",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY_ANNOT: "Allow the character controller to automatically adjust its orientation to match the direction of gravity",
  FE_45_TYC_CCT_PUSH_FORCE: "Custom Push Force",
  FE_45_TYC_CCT_PUSH_FORCE_ANNOT: "The push force exerted by the character controller on the rigid body",
  FE_45_TYC_COLLIDER_CONVEX: "Is Convex",
  FE_45_TYC_COLLIDER_CONVEX_ANNOT: "Treat this mesh as a convex in calculations for collision",
  FE_45_TYC_COLLIDER_GEN: "Generate Collider",
  FE_45_TYC_COLLIDER_GEN_ANNOT: "Automatically add and configure the collider component when dragging a mesh into the scene to create an object",
  FE_45_TYC_COLLIDER_OPTIMIZATION: "Collider Optimization",
  FE_45_TYC_COLLIDER_OPTIMIZATION_ANNOT: "Optimize the mesh performance for collision by streamlining the mesh data",
  FE_45_TYC_MESH_SCALE_FACTOR: "Scale Factor",
  FE_45_TYC_MESH_SCALE_FACTOR_ANNOT: "Scale the size of the mesh in this file according to the set parameter",
  FE_45_TYC_MIDAIR_MOVE: "Move in Midair",
  FE_45_TYC_MIDAIR_MOVE_ANNOT: "Allow changes of the player's speed and direction of movement in midair",
  FE_45_TYC_MULTI_JUMP_HEIGHT: "Jump Height",
  FE_45_TYC_MULTI_JUMP_HEIGHT_ANNOT: "The height of multi-jumps in midair",
  FE_45_TYC_MULTI_JUMP_MAX: "Max. Jump Count",
  FE_45_TYC_MULTI_JUMP_MAX_ANNOT: "The max number of continuous jumps allowed in midair",
  FE_45_TYC_OPTIMIZATION_NONE: "None",
  FE_45_XXJ_DELETECUSTOMEVENT: "Delete signal {0}",
  FE_45_XXJ_EDITCUSTOMEVENT: "Edit signal {0}",
  FE_45_XXJ_WARNING_EDITVARTYPE: "Changing the type may result in errors for blocks and APIs in use",
  FE_45_XXJ_WORKFLOWLOGIC: "In-Procedure Predefined Logic",
  FE_45_XXJ_WORKFLOWLOGICENABLE: "Enable In-Procedure Predefined Logic",
  FE_45_XXJ_WORKFLOWLOGICENABLE_D: "Enable the predefined logic at the start of a round, such as the invulnerability effect for players and the sound effect for round start.",
  FE_45_XYL_STOREBAN_1: "Feature not yet available. Please stay tuned!",
  FE_45_XYL_STOREBAN_2: "An error has occurred. Feature not yet available.",
  FE_46A_HZY_PROJECT_EMCTIP: "This is an online project. Please save it locally before use.",
  FE_46A_HZY_REVIEW_PUBLISH: "Sensitive word(s) detected. Check the error message for details.",
  FE_46_ERRORCODE_UNKONW_PROP: "{1} has unknown property: {0}",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE: "Errors in custom type {0}",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE_LOOP: "Loops are required for custom type: {0}",
  FE_46_HJ_ERRORCODE_FUNCTION_SIGNATURE: "Function signature mismatch: {0}",
  FE_46_HJ_ERRORCODE_GFILEE: "GFile for {1} is invalid: {0}",
  FE_46_HJ_ERRORCODE_IMAGE: "Image file is reverted back to texture because the type is unknown: {0}",
  FE_46_HJ_ERRORCODE_MISSGRAPH: "Block Script is missing",
  FE_46_HJ_ERRORCODE_NOTENTITY: "Cannot convert {0} type to entity",
  FE_46_HJ_ERRORCODE_NOTENUM: "Cannot covert {0} type to Enum",
  FE_46_HJ_ERRORCODE_NOTFIND_FILE: "Cannot find the file: {0}",
  FE_46_HJ_ERRORCODE_NOTFIND_GRAPH: "Cannot find Block Script {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE: "Value is not {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE_P: "Value of {1} is not {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE_RANGE: "Value ({0}) is not in range [{1}, {2}), type {3}",
  FE_46_HJ_ERRORCODE_NULLPARAM: "Parameter is null",
  FE_46_HJ_ERRORCODE_REFEREDFILE: "Referenced file is not a valid byte file: {0}",
  FE_46_HJ_ERRORCODE_TYPEABSTRACT: "Type {0} is abstract",
  FE_46_HJ_ERRORCODE_TYPE_ERROR: "Cannot convert {0} type to unknown type",
  FE_46_HJ_ERRORCODE_TYPE_ERROR_P: "Cannot convert '{1}' type to '{0}' type",
  FE_46_HJ_ERRORCODE_UNKNOW_API1: "API is not defined in configuration: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_API2: "API is not defined: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_APIID: "API ID is not defined: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_ENTITY_P: "{1} has unknown entity: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENT: "Custom event is not defined",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENTID: "Custom event {0} is not defined",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE: "Unknown type: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPEASSIGNING: "Property is not defined",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE_P: "Unknown {1} type: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_VALUE_P: "{1} has unknown value: {0}",
  FE_46_HJ_ERRORCODE_UNKONW_ACTION: "Block {0} is not defined",
  FE_46_HJ_ERRORCODE_UNKONW_ENTITY: "Parameter has unknown type",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM: "Enum item {0} is not defined in enum type {1}",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM_P: "Enum item {0} is invalid in enum type {1}",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION: "Block {0} is unknown",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION2: "Unknown definition for the custom function/action: {0}",
  FE_46_HJ_ERRORCODE_UNKONW_PROP: "Property {0} is not defined in {1} type",
  FE_46_HJ_ERRORCODE_UNKONW_PROPID: "Property {0} is invalid in {1} type",
  FE_46_HJ_ERRORCODE_UNKONW_PROP_P: "Property {0} is not defined",
  FE_46_HJ_ERRORCODE_UNKONW_VAR: "Variable {0} is not defined",
  FE_46_HJ_ERRORCODE_UNKONW_VARLOCAL: "Local variable {0} is not defined",
  FE_46_HJ_ERRORCODE_UNSPPPORTFILE: "File export not supported, type {1}: {0}",
  FE_46_HJ_ERRORCODE_UPSUPPORTTYPE: "{1} has unsupported value type: {0}",
  FE_46_HZY_SHOW_INASSETS: "Show in Assets",
  FE_46_HZY_SOUNDTYPE_CUSTOM: "Custom",
  FE_46_LJY_NUMTOSTRING5: "Decimal Separator",
  FE_46_SD_BUTTON_DOUBLECLICK: "Double Click",
  FE_46_SD_NODELETE_WHEN_OPENED: "The target file is open and will automatically close once deleted",
  FE_46_SD_NODELETE_WHEN_OPENED_2: "The target file is open and will automatically close once deleted. This action is irreversible.",
  FE_46_SD_NODELETE_WHEN_OPENED_CONSOLE: "The file you are about to delete is open: {0}.",
  FE_46_SD_RESTORE_FILE_MISS: "Cannot restore {0} because it does not exist",
  "FE_46_SD_RESTORE_FILE_NO_PERMISSION ": "{0} cannot be written to",
  "FE_46_SD_RESTORE_FILE_OVERRIDE ": "{0} already exists and will be replaced by this file",
  "FE_46_SD_RESTORE_FILE_PATH_ERROR ": "Unable to restore {0} because the asset file does not belong to the current project",
  FE_46_SD_UNDOREDOING: "Executing operations...",
  "FE_46_SD_UNREDO_RENAME_NOT_FIND ": "{0} is not found. Cannot move or rename this file.",
  FE_46_SD_UNSELECTCALLBACK: "Select Callback",
  FE_46_TYC_CUSTOM_UI_DEPTH: "Render Depth",
  FE_46_TYC_CUSTOM_UI_DEPTH_DESC: "This property determines the rendering order for this custom UI and the rendering order of its widgets. Conflicts with other rendering depth may result in rendering order interference. We recommend reserving a reasonable depth interval for possible interfering custom UI.",
  FE_46_TYC_ENABLEAOIFILTER: "AOI Filter On",
  FE_46_TYC_ENABLEAOIFILTER_DESC: "If OFF, all objects will be in sync; if ON, faraway objects will be ignored to optimize data usage.",
  FE_46_TYC_NO_COLLIDERS_TIPS: "Collider has not been added",
  FE_46_TYC_PANEL_DEPTH: "Render Depth",
  FE_46_TYC_PANEL_DEPTH_CONFLICT: "Render depth conflicts with:",
  FE_46_TYC_PANEL_DEPTH_DESC: "This property determines the rendering order for this custom UI. Conflicts with other rendering depth may result in rendering order interference. You may not directly change this property because it is based on the rendering depth of the custom UI.",
  FE_46_TYC_PANEL_DEPTH_TOTAL: "Total Render Depths",
  FE_46_TYC_PANEL_DEPTH_TOTAL_DESC: "The render depth of this custom UI and its widgets, if in conflict with other render depths, may result in render order interference",
  FE_46_XXJ_ADDOERSONA: "Add Persona",
  FE_46_XXJ_DYNAMICRES: "Dynamic Resource Loading",
  FE_46_XXJ_FORMAT: "Format",
  FE_46_XXJ_FORMATVALUE: "Digit",
  FE_46_XXJ_MUSTRES: "Required Resources",
  FE_46_XXJ_NOFOUND: "No corresponding persona found",
  FE_46_XXJ_NOPERMISSIONTOUSE: "You don't have permission to use this",
  FE_46_XXJ_NUMTOFLOAT: "Number to String",
  FE_46_XXJ_NUMTOFLOAT1: "Keep Decimal Places",
  FE_46_XXJ_NUMTOFLOAT2: "Regular",
  FE_46_XXJ_NUMTOFLOAT3: "Scientific Notation",
  FE_46_XXJ_NUMTOFLOAT4: "Percentage",
  FE_46_XXJ_PERSONALIMIT: "Max persona limit reached. Unable to add more.",
  FE_46_XXJ_PLAYERDIAMOND: "Diamonds owned by player(s)",
  FE_46_XXJ_PLAYERPREMIUM: "Activate Membership for player(s)",
  FE_46_XXJ_PLEASEENTER: "Enter persona ID",
  FE_46_XXJ_PREMIUMSETTING: "Membership Settings",
  FE_46_XXJ_RESCOLLECT: "Resource Collection",
  FE_46_XXJ_SEARCH: "Search",
  FE_46_XXJ_WARNINGMATCHRESULT: "Match Result Warning: the previous match result logic is no longer available. It is recommended that you enable Custom Match Result, which will send players directly back to the lobby after the match ends. You can customize this interface or use related templates if needed.",
  FE_46_XYL_FINDINCLASSIFICATION: "Show in Category",
  FE_46_XYL_FINDUGCDOCS: "View Manual",
  FE_46_XYL_NAVMESHSHOW: "Show In-Scene Preview",
  FE_47A_HZY_BOMBERSCRIPT_LEVEL: "Intermediate - Bombarded (Script)",
  FE_47A_HZY_BOMBER_LEVEL: "Intermediate - Bombarded",
  FE_47A_HZY_SNIPER_LEVEL: "Advanced - Sniper",
  FE_47A_MX_CUSTOMEVENT_TIP: "The corresponding block will be invalid. Are you sure?",
  FE_47_GT_USERMANUAL: "User Manual",
  FE_47_HJ_FOG_DENSITY: "Fog Density",
  FE_47_HJ_FOG_ENABLEFOG: "Enable Fog",
  FE_47_HJ_FOG_ENDDISTANCE: "Fog End Distance",
  FE_47_HJ_FOG_EXPONENTIAL: "Exponential",
  FE_47_HJ_FOG_EXPONENTIALSQUARED: "Exponential Squared",
  FE_47_HJ_FOG_FOGMODE: "Fog Mode",
  FE_47_HJ_FOG_LINEAR: "Linear",
  FE_47_HJ_FOG_STARTDISTANCE: "Fog Start Distance",
  FE_47_HL_FREE_VIEW: "Player View/Free View",
  FE_47_HZY_BLOCK_CATEGORY: "Category",
  FE_47_HZY_BLOCK_CUSTOMVARIABLE: "Custom Variable",
  FE_47_HZY_BLOCK_DESC: "Description",
  FE_47_HZY_BLOCK_ID: "Block ID",
  FE_47_HZY_BLOCK_INPUT: "Input",
  FE_47_HZY_BLOCK_MODULE: "Module",
  FE_47_HZY_BLOCK_NAME: "Block Name",
  FE_47_HZY_BLOCK_OUTPUT: "Output",
  FE_47_HZY_BLOCK_OWNERTYPE: "Triggerable",
  FE_47_HZY_BLOCK_PARADESC: "Parameter Info",
  FE_47_HZY_BLOCK_RETURNDESC: "Return Value Description",
  FE_47_HZY_BLOCK_RETURNTYPE: "Return Type",
  FE_47_HZY_CLIENTNUM_D: "Set the number of clients",
  FE_47_HZY_CUSTOMSTORE: "Custom Shop",
  FE_47_HZY_CUSTOMSTORE_ADDCUSTOM: "Add Custom Item",
  FE_47_HZY_CUSTOMSTORE_ADDITEM: "Drag here to add an item",
  FE_47_HZY_CUSTOMSTORE_ADDSHELVE: "Create Shelf",
  FE_47_HZY_CUSTOMSTORE_COVER: "Cover Image",
  FE_47_HZY_CUSTOMSTORE_CURRENCY: "Currency Type",
  FE_47_HZY_CUSTOMSTORE_DELETETIP1: "Delete this custom store permanently?",
  FE_47_HZY_CUSTOMSTORE_DELETETIP2: "Clear items and delete the shelf?",
  FE_47_HZY_CUSTOMSTORE_DELETETIP3: "Once deleted, the custom shop cannot be restored. Are you sure?",
  FE_47_HZY_CUSTOMSTORE_DOWN: "Move Down",
  FE_47_HZY_CUSTOMSTORE_EDIT: "Edit Custom Shop",
  FE_47_HZY_CUSTOMSTORE_ENTITY: "Shop",
  FE_47_HZY_CUSTOMSTORE_FFITEM: "Default Items",
  FE_47_HZY_CUSTOMSTORE_INFO: "Item Info",
  FE_47_HZY_CUSTOMSTORE_LIMIT: "Limited",
  FE_47_HZY_CUSTOMSTORE_LIMITNUM: "Purchase Limit",
  FE_47_HZY_CUSTOMSTORE_PRODUCTCONTENT: "Item Content",
  FE_47_HZY_CUSTOMSTORE_PRODUCTNAME: "Item Name",
  FE_47_HZY_CUSTOMSTORE_PROP: "Item Property",
  FE_47_HZY_CUSTOMSTORE_SHELVES: "Shelf",
  FE_47_HZY_CUSTOMSTORE_UP: "Move Up",
  FE_47_HZY_MODULE_CUSTOMRESULT_D: "Check this so that the default match result page will not show",
  FE_47_HZY_MODULE_D: "Manage modules and set their parameters",
  FE_47_HZY_MODULE_LOGICFRAME_D: "Check this to use Low Logic Frame Mode (30 > 15)",
  FE_47_HZY_MODULE_LOOTSWITCH_D: "Check this to enable classic mode ground loot for large maps such as Bermuda, Kalahari, NeXTerra, and Solara.",
  FE_47_HZY_MODULE_NAVMESH_D: "Check this and enable Dynamic NavMesh to generate pathfinding obstacles similar to colliders. These obstacles will be created or deleted simultaneously with the object.",
  FE_47_HZY_MODULE_NFPP_D: "Check this to use the new first-person resources",
  FE_47_HZY_SCENESWITCH_TIP: "In-scene server loading area not supported in this map",
  FE_47_HZY_SCENE_ALIGNMENTLOCK_D: "When unlocked, set the fixed move distance on x/y/z axis",
  FE_47_HZY_SCENE_ALIGNMENTRESET_D: "Reset to default",
  FE_47_HZY_SCENE_ALIGNMENTSET_D: "Use the alignment feature to rotate, scale or move scene objects at a fixed distance",
  FE_47_HZY_SERVERSLOAD_BERMUDA: "Enable in-scene server loading area not supported for this map",
  FE_47_HZY_TERRAIN_DOWN_D: "Decrease terrain height of this area",
  FE_47_HZY_TERRAIN_FLAT_D: "Use the same terrain height for this area",
  FE_47_HZY_TERRAIN_SMOOTH_D: "Average out nearby areas, softens the landscape and reduces the appearance of abrupt changes.",
  FE_47_HZY_TERRAIN_TEXTURE_CHANGE_D: "Replace the selected texture with the new texture",
  FE_47_HZY_TERRAIN_TEXTURE_COVERALL_D: "Check to paint the selected texture to cover the entire terrain",
  FE_47_HZY_TERRAIN_TEXTURE_DEL_D: "Delete the selected texture",
  FE_47_HZY_TERRAIN_TEXTURE_INPUT_D: "Import a new texture",
  FE_47_HZY_TERRAIN_TEXTURE_TIP: "Select the texture to paint",
  FE_47_HZY_TERRAIN_UP_D: "Increase terrain height of this area",
  FE_47_HZY_UI_3D_D: "A widget for displaying 3D content such as Prefab",
  FE_47_HZY_UI_AVATAR_D: "A widget for displaying a player's avatar",
  FE_47_HZY_UI_BUTTON_D: "A widget that triggers event logic when pressed",
  FE_47_HZY_UI_EMPTY_D: "An invisible widget for organizing child/parent widgets",
  FE_47_HZY_UI_JOYSTICK_D: "A widget that simulates a joystick and reacts to drag input (client only)",
  FE_47_HZY_UI_LAYOUT_D: "A widget that automatically arranges its child widgets",
  FE_47_HZY_UI_PANEL_D: "A panel that contains other child widgets",
  FE_47_HZY_UI_PICTURE_D: "A widget for displaying images",
  FE_47_HZY_UI_PLATFORM_D: "A panel that supports the Add Friend and Report features",
  FE_47_HZY_UI_SCROLLVIEW_D: "Child widgets in this panel can be scrolled",
  FE_47_HZY_UI_TEXTBOX_D: "A widget to get text input from user",
  FE_47_HZY_UI_TEXTURE_D: "A widget for displaying textures",
  FE_47_HZY_UI_TEXT_D: "A widget for displaying plain texts",
  FE_47_HZY_UI_TOGGLE_D: "A button-like widget that switches between two statuses when pressed",
  FE_47_HZY_UI_TOUCHPAD_D: "A widget that reacts to touch/drag input (client only)",
  FE_47_JH_WS_ROOMMINPLAYERCNT: "Min. Players",
  FE_47_TYC_ANIM_BLEND_TIME: "Blend Fade Length",
  FE_47_TYC_AOI_FILTER_ALWAYS: "Always",
  FE_47_TYC_AOI_FILTER_AUTO: "Auto",
  FE_47_TYC_AOI_FILTER_D: "Determines the filter settings of the object. Auto: turns on or off the filter based on whether the object is static or not. Never: The object will always be synced. Always: The object will always be filtered, which means it will not be synced when distant.",
  FE_47_TYC_AOI_FILTER_NEVER: "Never",
  FE_47_TYC_AOI_FILTER_T: "AOI Filter",
  FE_47_TYC_CCT_ENABLED_D: "Disabled: Use the default player character controller. This may result in errors when the player and rigid body interact; Enabled: Use Craftland character controller.",
  FE_47_TYC_CCT_HEIGHT_D: "The height of the capsule for this Character Controller. Please note that the height must be larger than twice of the capsule's radius.",
  FE_47_TYC_CCT_RADIUS_D: "The radius of the capsule for this Character Controller. Please note that  the height of the capsule must be larger than twice of the capsule's radius.",
  FE_47_TYC_GLOBAL_GRAVITY_D: "The gravity that applies to all rigid bodies",
  FE_47_TYC_HINT_COLOR_TEXTURE_RESTRICTION: "Internal textures or textures exceeding 256*256 px are not supported",
  FE_47_TYC_PHYSICS_DEFAULT_MAT: "The default physical texture if none is set for collision and the rigid body",
  FE_47_TYC_PHYSICS_SLEEP_THRESHOLD_D: "If the kinetic energy or gravity of the rigid body is lower than this value, it will automatically go to sleep (to reduce performance cost).",
  FE_47_TYC_PLAYER_PHYSICS_LAYER_D: "The physical layer that the player character is on",
  FE_47_TYC_PTC: "Particle Emitter",
  FE_47_TYC_PTC_A_ACCELERATION: "Acceleration",
  FE_47_TYC_PTC_A_ACCELERATION_D: "This property determines the acceleration of particles over time",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS: "Acceleration Randomness",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS_D: "The random value added to the acceleration of a particle. (The final acceleration is randomly selected within a range from [Base Value] to [Base Value + Acceleration Randomness].)",
  FE_47_TYC_PTC_A_ANGLE: "Angle",
  FE_47_TYC_PTC_A_ANGLE_D: "The initial rotation angle for particles (along a random axis)",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS: "Angle Randomness",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS_D: "The random value added to the initial rotation angle of a particle. (The final angle is randomly selected within a range from [Base Value] to [Base Value + Angle Randomness].)",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY: "Angular Velocity",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_D: "Particles will rotate over time (along a random axis)",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS: "Angular Velocity Randomness",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS_D: "The random value added to the angular velocity of a particle. (The final velocity is randomly selected within a range from [Base Value] to [Base Value + Angular Velocity Randomness].)",
  FE_47_TYC_PTC_A_BOX: "Cube",
  FE_47_TYC_PTC_A_BOX_D: "Emit particles upwards from the bottom of the box",
  FE_47_TYC_PTC_A_CIRCLE: "Circle",
  FE_47_TYC_PTC_A_CIRCLE_D: "Emit particles outwards from the center of the circle",
  FE_47_TYC_PTC_A_COLOR: "Particle Color",
  FE_47_TYC_PTC_A_COLOR_D: "This property affects the color of particles",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME: "Color over Lifetime",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME_D: "The color of particles will change over time",
  FE_47_TYC_PTC_A_CONE: "Cone",
  FE_47_TYC_PTC_A_CONE_D: "Emit particles outwards from the bottom of the cone (instead of from the inside)",
  FE_47_TYC_PTC_A_DAMPING: "Damping",
  FE_47_TYC_PTC_A_DAMPING_D: "Damping for the velocity of particles. A higher damping value means larger friction.",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS: "Damping Randomness",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS_D: "The random value added to the damping of a particle. (The final damping is randomly selected within a range from [Base Value] to [Base Value + Damping Randomness].)",
  FE_47_TYC_PTC_A_DURATION: "Duration",
  FE_47_TYC_PTC_A_DURATION_D: "The amount of time the emitter runs through a cycle",
  FE_47_TYC_PTC_A_FINAL_VALUE: "Final Value",
  FE_47_TYC_PTC_A_HEMISPHERE: "Hemisphere",
  FE_47_TYC_PTC_A_HEMISPHERE_D: "Emit particles outwards from the inside and the surface of this hemisphere",
  FE_47_TYC_PTC_A_INITIAL_VALUE: "Initial Value",
  FE_47_TYC_PTC_A_LIFETIME: "Lifetime",
  FE_47_TYC_PTC_A_LIFETIME_D: "The amount of time a particle will exist",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS: "Lifetime Randomness",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS_D: "The random value added to the lifetime of a particle. (The final lifetime is randomly selected within a range from [Base Value] to [Base Value + Lifetime Randomness].)",
  FE_47_TYC_PTC_A_LOOP: "Loop",
  FE_47_TYC_PTC_A_LOOP_D: "Enabling this property allows the emitter to auto-replay after emission",
  FE_47_TYC_PTC_A_MATERIAL: "Particle Material",
  FE_47_TYC_PTC_A_MATERIAL_D: "Rendering material that applies to particles",
  FE_47_TYC_PTC_A_MAX_PARTICLES: "Max. Particles",
  FE_47_TYC_PTC_A_MAX_PARTICLES_D: "Max. quantity of particles allowed to exist at the same time. If the limit is reached, no more particles will be generated.",
  FE_47_TYC_PTC_A_MESH: "Custom Mesh",
  FE_47_TYC_PTC_A_MESH_D: "Emit particles outwards from the top of any given mesh",
  FE_47_TYC_PTC_A_MODE: "Emission Mode",
  FE_47_TYC_PTC_A_MODE_D: "This property determines the order of particle emission",
  FE_47_TYC_PTC_A_RATE_OVER_TIME: "Emission Speed",
  FE_47_TYC_PTC_A_RATE_OVER_TIME_D: "The number of particles the emitter emits per second",
  FE_47_TYC_PTC_A_RENDER_MODE: "Render Mode",
  FE_47_TYC_PTC_A_RENDER_MODE_D: "Determines which rendering mode the particles use",
  FE_47_TYC_PTC_A_SHAPE: "Emission Shape",
  FE_47_TYC_PTC_A_SHAPE_D: "This property determines the start position and direction of emission. Each shape may contain different options.",
  FE_47_TYC_PTC_A_SIMULATION_SPACE: "Simulation Coords",
  FE_47_TYC_PTC_A_SIMULATION_SPACE_D: "This property determines the coordinate system that the particles use when moving",
  FE_47_TYC_PTC_A_SIMULATION_SPEED: "Simulation Speed",
  FE_47_TYC_PTC_A_SIMULATION_SPEED_D: "Adjust the overall velocity for  the emitter and particles",
  FE_47_TYC_PTC_A_SIZE: "Size",
  FE_47_TYC_PTC_A_SIZE_D: "Initial scaling for particles",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS: "Size Randomness",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS_D: "The random value added to the initial size of a particle. (The final size is randomly selected within a range from [Base Value] to [Base Value + Size Randomness].)",
  FE_47_TYC_PTC_A_SORT_MODE: "Sort Type",
  FE_47_TYC_PTC_A_SORT_MODE_D: "This property determines how the rendering order of particles is calculated",
  FE_47_TYC_PTC_A_SPHERE: "Sphere",
  FE_47_TYC_PTC_A_SPHERE_D: "Emit particles outwards from the inside and the surface of this sphere",
  FE_47_TYC_PTC_A_START_SPEED: "Start Speed",
  FE_47_TYC_PTC_A_START_SPEED_D: "The initial speed at which the particles are emitted towards the set direction",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS: "Start Speed Randomness",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS_D: "The random value added to the initial speed of a particle. (The final speed is randomly selected within a range from [Base Value] to [Base Value + Speed Randomness].)",
  FE_47_TYC_PTC_A_TEXTURE: "Color Texture",
  FE_47_TYC_PTC_A_TEXTURE_D: "This texture determines the color of the emitted particles from the corresponding position",
  FE_47_TYC_PTC_A_TRANSFORM: "Emission Shape Transform",
  FE_47_TYC_PTC_A_TRANSFORM_D: "This property only applies to the emission shape and will not affect particles",
  FE_47_TYC_PTC_A_VELOCITY: "Velocity",
  FE_47_TYC_PTC_A_VELOCITY_D: "Initial Velocity",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS: "Velocity Randomness",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS_D: "The random value added to the initial velocity of a particle. (The final value is randomly selected within a range from [Base Value] to [Base Value + Velocity Randomness].)",
  FE_47_TYC_PTC_BASIC: "Basic",
  FE_47_TYC_PTC_ENUM_BILLBOARD: "Face Billboard",
  FE_47_TYC_PTC_ENUM_BY_DIST: "By Distance",
  FE_47_TYC_PTC_ENUM_GLOBAL: "World Space",
  FE_47_TYC_PTC_ENUM_LOCAL: "Local Space",
  FE_47_TYC_PTC_ENUM_LOOP: "Loop",
  FE_47_TYC_PTC_ENUM_OLDEST_IN_FRONT: "From Oldest",
  FE_47_TYC_PTC_ENUM_PING_PONG: "Ping Pong",
  FE_47_TYC_PTC_ENUM_RANDOM: "Random",
  FE_47_TYC_PTC_ENUM_YOUNGEST_IN_FRONT: "From Newest",
  FE_47_TYC_PTC_PARA: "Particle Parameter",
  FE_47_TYC_PTC_PROPERTY_FILE: "Particles Properties",
  FE_47_TYC_PTC_PROPERTY_FILE_D: "The particles property file describes the behavior of particles and the emitter. You cannot change the properties when the file is running but can switch to different property files.",
  FE_47_TYC_PTC_RENDERING: "Render",
  FE_47_TYC_PTC_SHAPE: "Shape",
  FE_47_TYC_SHD_BLENDMODE: "Blend Mode",
  FE_47_TYC_SHD_COLOR_CORRECTION: "Color Correction",
  FE_47_TYC_SHD_CULL_BACK: "Back",
  FE_47_TYC_SHD_CULL_FRONT: "Front",
  FE_47_TYC_SHD_MAIN_ROTATION: "Main Rotation",
  FE_47_TYC_SHD_MASK: "Mask",
  FE_47_TYC_SHD_ON: "On",
  FE_47_TYC_SHD_Z_TEST: "Z Test",
  FE_47_TYC_SHD_Z_WRITE: "Z Write",
  FE_47_XXJ_ACCOUNTNOPERMISSION: "Your account is not allowed to use personas",
  FE_47_XXJ_AUTOCLEAR: "Auto clear after match ends",
  FE_47_XXJ_IMPORTED: "This persona already exists",
  FE_47_XXJ_LOGINTIMEOUT: "Session expired, please log in again",
  FE_47_XXJ_MEMORYTYPE: "Memory Type",
  FE_47_XXJ_NOCONECT: "Network error",
  FE_47_XXJ_NOPERMISSION: "Not allowed to use this persona",
  FE_47_XXJ_NOTAUTOCLEAR: "Auto clear off",
  FE_47_XXJ_PERSONAIDSEARCH: "Enter persona ID to search",
  FE_47_XXJ_PERSONAOFFLINE: "This persona is no longer available",
  FE_47_XXJ_PERSONATOOTIP: "Copy the Persona ID created in Persona Center and paste it here to import the persona",
  FE_47_XXJ_SELECTOBSERVOR: "Select observer",
  FE_47_XYL_ASSETSTORE_TYPE: "Asset Store Type",
  FE_47_XYL_IMAPGEUPDATEFAIL: "This image file type is not supported",
  FE_47_XYL_PROJECTTEMPLATE: "Project Template",
  FE_47_XYL_SHOPSEARCHCOUNT: "{0} result(s) found",
  FE_47_XYL_SHOPSELECTTYPE: "Choose Type",
  FE_47_XYL_SHOPTAGS: "Tags",
  FE_47_XYL_SHOPTYPENONEERROR: "Shop type cannot be empty",
  FE_47_XYL_SHOP_CLASSNEWEST: "From Newest",
  FE_47_XYL_SHOP_CLASSOLDEST: "From Oldest",
  FE_47_XYL_SHOP_ENTERTOADD: "Press ENTER to create a tag",
  FE_47_XYL_SHOP_TAGLIMITED: "Tag Limit",
  FE_47_XYL_SHOP_TAGRECOMMEND: "Recommended Tags",
  FE_47_XYL_STORE2DASSET: "2D Asset",
  FE_47_XYL_STORE3ASSET: "3D Asset",
  FE_47_ZCS_EDITOR_EXIT_REMINDER: "Project unsaved",
  FE_47_ZCS_EDITOR_FILTER_NOTICE: "Unable to paste while searching",
  FE_48A_HZY_CUSTOMRES_ADDTIP: "You do not have permission to use the custom asset. Using this asset may result in publish failure",
  FE_48A_HZY_CUSTOMRES_CONSOLETIP: "You do not have permission to use this custom asset. Please replace or delete it.",
  FE_48A_HZY_SAVEFAIL_TIP1: "Failed to save",
  FE_48A_HZY_SAVEFAIL_TIP2: "The following file(s) may be read-only. Please modify the file properties and save again.",
  FE_48A_HZY_SAVEFAIL_TIP3: "This file may be read-only. Please modify the file properties and save again.",
  FE_48A_XXJ_LOOPWARNIG: "This clip will not take effect because the previous clip's type is set to loop forever",
  FE_48A_XXJ_UNSELECT: "Deselect",
  FE_48A_XYL_NAVMESHSWITCH: "Enable offline Static NavMesh",
  FE_48A_ZCS_EDITOR_SELECTED_NOTICE: "Selected",
  FE_48_HL_REVIEW_MEANNING: "Sensitive information detected in {0}: {1}",
  FE_48_HZY_COSTLIMIT_CONSOLETIPS: "Max. {0} assets exceeded. Please delete some.",
  FE_48_HZY_COSTLIMIT_TIPS1: "Too many scene assets may result in publish failure, please add appropriately.",
  FE_48_HZY_COSTLIMIT_TIPS2: "Failed to publish due to excessive assets in scene(s): {0}. Please check the error details and delete some assets.",
  FE_48_HZY_DEFINEDPATH: "Define Path",
  FE_48_HZY_ECA_TIP_ONLY_SCENE_SELECT: "Only objects in the scene can be selected",
  FE_48_HZY_EDITCUSTOMEVENT: "Edit Signal",
  FE_48_HZY_FUNCTIONNAME: "Function Name",
  FE_48_HZY_GETEXFUNCTION: "Get External Function",
  FE_48_HZY_GETEXVARIABLE: "Get External Variable",
  FE_48_HZY_GETVARIABLE: "Get Variable",
  FE_48_HZY_RECEIVEEVENT: "Receive Signal",
  FE_48_HZY_SELECTENTITY: "Send Entity",
  FE_48_HZY_SENDEVENT: "Emit Signal",
  FE_48_HZY_SETEXVARIABLE: "Set External Variable",
  FE_48_SD_ASSET_REGIST: "Register Asset",
  FE_48_SD_QUICKREGIST: "Quick Register",
  FE_48_TYC_CONVEX_WARNING_RIGIDBODY: "This collider shape contains a non-convex mesh, so it cannot be used as a dynamic or kinematic rigidbody. Use a convex mesh or split it into multiple simpler colliders.",
  FE_48_TYC_CONVEX_WARNING_TRIGGER: "This collider shape contains a non-convex mesh, so it cannot be set as a trigger. Use a convex mesh or another collider shape type instead.",
  FE_48_TYC_SPECTATOR_FF: "Free Fire",
  FE_48_TYC_SPECTATOR_FF_RULE: "Same with Free Fire",
  FE_48_TYC_SPECTATOR_TYPE: "Spectate Type",
  FE_48_TYC_SPECTATOR_UGC: "Craftland Studio",
  "FE_48_TYC_UI_ADAPT_SCREEN ": "Fit Screen",
  FE_48_TYC_UI_PENETRATABLE: "Passthrough",
  FE_48_TYC_UI_PENETRATABLE_D: "If enabled, this widget will not block trigger event for the underlying widget.",
  FE_48_XXJ_ADDBEHINDWAYPOINT: "Insert waypoint after",
  FE_48_XXJ_ADDBODYPARTTRACK: "Add Body Part Track",
  FE_48_XXJ_ADDEVENT: "Add Event",
  FE_48_XXJ_ADDFRONTWAYPOINT: "Add waypoint before",
  FE_48_XXJ_ADDITIVE: "Additive",
  FE_48_XXJ_ADDWAYPOINT: "Add Waypoint",
  FE_48_XXJ_BASETRAK: "Base Track",
  FE_48_XXJ_BETA: "This is the beta version and may contain bugs",
  FE_48_XXJ_BODY: "Body",
  FE_48_XXJ_BODYPART: "Body Part",
  FE_48_XXJ_BODYPARTCONFIG: "Body Part Config",
  FE_48_XXJ_BODYPARTTRACK: "Body Part Track",
  FE_48_XXJ_BONESELECTOR: "Bone Selector",
  FE_48_XXJ_COLLAPSEALL: "Collapse All",
  FE_48_XXJ_CREATECLIP: "Create Clip",
  FE_48_XXJ_DELETECURRENTWAYPOINT: "Delete waypoint",
  FE_48_XXJ_DELETEEVENT: "Delete Event",
  FE_48_XXJ_ENDTIME: "End Time",
  FE_48_XXJ_EVENTTRACK: "Event Track",
  FE_48_XXJ_EXPANDALL: "Expand All",
  FE_48_XXJ_HOLD: "Hold",
  FE_48_XXJ_LOCK: "Lock",
  FE_48_XXJ_LOOP: "Loop",
  FE_48_XXJ_LOOPFOREVER: "Loop Forever",
  FE_48_XXJ_MASK: "Mask",
  FE_48_XXJ_MUTE: "Mute",
  FE_48_XXJ_NONE: "None",
  FE_48_XXJ_OVERRIDE: "Override",
  FE_48_XXJ_PAUSE: "Pause",
  FE_48_XXJ_PINGPONG: "Ping-Pong",
  FE_48_XXJ_PLAY: "Play",
  FE_48_XXJ_PLAYBACKLENGHT: "Playback length",
  FE_48_XXJ_POSTEXTRA: "Post-Extrapolation",
  FE_48_XXJ_PREAXTRA: "Pre-Extrapolation",
  FE_48_XXJ_PREGERTANGENTDRAG: "Prefer Tangent Drag",
  FE_48_XXJ_REPLAY: "Replay",
  FE_48_XXJ_SELECTBONES: "Select Bones",
  FE_48_XXJ_SELECTEDBONES: "{0} bone(s) selected",
  FE_48_XXJ_SELECTEDWAYPOINT: "Selected Waypoint(s)",
  FE_48_XXJ_SETGAPEXTRA: "Set Gap Extrapolation",
  FE_48_XXJ_SETTOCAMERA: "Set to Current Scene Camera Position",
  FE_48_XXJ_STARTTIME: "Start Time",
  FE_48_XXJ_TOGGLEALL: "Toggle All",
  FE_48_XXJ_UNLOCK: "Unlock",
  FE_48_XXJ_UNMUTE: "Unmute",
  FE_48_XXJ_WAYPOINTS: "Waypoint",
  FE_48_XXJ_WEIGHT: "Weight",
  FE_48_XYL_CUTOFF: "Cutoff",
  FE_48_ZCS_EDITOR_CHECK_UPDATES: "Checking for updates...",
  FE_48_ZCS_EDITOR_COMPILER_VERSION: "Compiler Version",
  FE_48_ZCS_EDITOR_COPY_PATH: "Copy Path Info",
  FE_48_ZCS_EDITOR_DELETE_INVALID_PROJECT: "Delete invalid project(s)",
  FE_48_ZCS_EDITOR_MANAGEMENT: "Manage",
  FE_48_ZCS_EDITOR_OFFICIAL_WEBSITE: "Official Website",
  FE_48_ZCS_EDITOR_PRIVACY_POLICY: "Privacy Policy",
  FE_48_ZCS_EDITOR_REFRESH_PROJECTLIST: "Refresh project list",
  FE_48_ZCS_EDITOR_TERMS_OF_SERVICE: "Terms of Service",
  FE_48_ZCS_EDITOR_UPDATES_ABOUT: "Updates and About",
  FE_49A_HJ_OPENDATAFILE: "Open data storage file",
  FE_49A_HZY_COLLIDER_LIMITTIP1: "The collision mesh of this file still exceeds 4000 faces after performance optimization. Using the file may cause publishing to fail.",
  FE_49A_HZY_COLLIDER_LIMITTIP2: "The collision mesh(es) for {0} exceed(s) the limit. Please optimize the physical collision(s) or replace the file(s).",
  FE_49A_HZY_COLLIDER_LIMITTIP3: "Publishing failed because the project contains files with collision meshes exceeding the face count limit. Please check the console for detailed error information.",
  FE_49A_HZY_SHADER_ALPHABC_D: "A translucent material that supports color overlay and transparency control, ideal for simple effects, glass, UI elements, or other semi-transparent material effects.",
  FE_49A_HZY_SHADER_BUILDCARTOON_D: "A cartoon-style material that supports gradient lighting, normal maps, specular highlights, and Matcap effects. It is ideal for stylized buildings.",
  FE_49A_HZY_SHADER_BUMPDIFFUSE_D: "A diffuse material that supports normal mapping, ideal for objects requiring basic lighting and normal map details, such as buildings, props, and more.",
  FE_49A_HZY_SHADER_BUMPSPECULAR_D: "A specular reflection material based on the Blinn-Phong lighting model, supporting normal maps and specular maps. It is ideal for objects like metal, plastic, or other surfaces that require a glossy appearance.",
  FE_49A_HZY_SHADER_DIFFUSECOLORMULTI_D: "A multi-light diffuse material that builds upon the standard diffuse material and supports multiple light sources, ideal for simple objects requiring multi-light source rendering effects.",
  FE_49A_HZY_SHADER_DIFFUSECOLOR_D: "A standard diffuse material that supports basic lighting and color overlay, ideal for scene objects, props, or characters requiring only simple textures.",
  FE_49A_HZY_SHADER_DIFFUSECWE_D: "A diffuse material with glowing lights effects on its surface, supporting mask textures and UV scrolling animations. It is ideal for objects that require visual enhancement and dynamic effects.",
  FE_49A_HZY_SHADER_PARTICLE_D: "A standard effects material that supports color overlay, brightness adjustment, texture rotation, and mask blending. It provides three basic blending modes: Opaque, Alpha Blend, and Additive, ideal for creating simple particle effects or UI visuals.",
  FE_49A_HZY_SHADER_REFLECTIONBM_D: "A multi-light specular reflection material that supports normal maps, specular highlights, environmental reflections, and Fresnel effects. It also provides various blending modes, which is ideal for scene objects, props, or characters requiring high-quality visuals and multi-light source effects.",
  FE_49A_HZY_SHADER_SKYBOXPRO_D: "A procedural skybox material that supports gradient colors and sun flares, ideal for creating simple or cartoon-style sky effects.",
  FE_49A_HZY_SHADER_SKYBOX_D: "A skybox material that supports six-sided textures, texture rotation, and exposure adjustment, ideal for skybox rendering.",
  FE_49A_MX_ACTUAL_HEIGHT: "Actual Height",
  FE_49A_MX_ACTUAL_WIDTH: "Actual Width",
  FE_49A_MX_TEXTURE_MAX_SIZE: "Maximum Size",
  FE_49A_XYL_STORE_BANNED: "Asset banned",
  FE_49A_XYL_STORE_REVIEW_FAILED: "Review failed",
  FE_49_HJ_DEBUG_ERROR: "Failed to connect to the server, please try again later",
  FE_49_HJ_DEBUG_GAMEOVER: "Match has ended",
  FE_49_HJ_PLAYER_SlowMove_FIST: "Slow Movement",
  FE_49_HJ_PLAYER_SlowMove_GUN: "Slow Movement (Holding Rifle)",
  FE_49_HJ_PLAYER_SlowMove_PISTOL: "Slow Movement (Holding Pistol)",
  FE_49_HZY_CONTROLLER: "Playable Controller",
  FE_49_HZY_CONTROLLERATTACH: "Entity component that can attach a playable controller",
  FE_49_HZY_CONTROLLER_DELETETIP: "Object unfound",
  FE_49_HZY_CONTROLLER_FRAMEMOVE: "By frame",
  FE_49_HZY_CONTROLLER_FRAMEMOVETIP: "Set whether the motion is by frame. If true: by-frame motion; if false: accumulated motion.",
  FE_49_HZY_CONTROLLER_LIFETIME: "Lifetime (ms)",
  FE_49_HZY_CONTROLLER_OVERRIDETIP: "Conflicts with other motion(s): playable entity {0}",
  FE_49_HZY_CONTROLLER_PLAYABLE: "Playable {0}",
  FE_49_HZY_CONTROLLER_STARTTIME: "Start Delay Time (ms)",
  FE_49_HZY_FFA: "FFA",
  FE_49_HZY_FFA_D: "A Free-for-All (FFA) mode where players compete individually, with a random area in the Bermuda map selected as the battlefield each round. Players can purchase weapons and eliminate enemies to earn higher scores. The game features a real-time scoreboard that displays player scores and rankings.",
  FE_49_HZY_PARKOUR: "Parkour",
  FE_49_HZY_PARKOUR_D: "A classic parkour map, with basic checkpoints and a finish line in the scene. Be creative about the scene layout and create a fun parkour experience!",
  FE_49_HZY_TEMPLATE_COMPLEXITY_1: "Low",
  FE_49_HZY_TEMPLATE_COMPLEXITY_2: "Medium",
  FE_49_HZY_TEMPLATE_COMPLEXITY_3: "High",
  FE_49_HZY_TEMPLATE_ECACOMPLEXITY: "ECA Complexity",
  FE_49_HZY_TEMPLATE_LEVEL1: "Easy",
  FE_49_HZY_TEMPLATE_LEVEL2: "Advanced",
  FE_49_HZY_TEMPLATE_LEVEL3: "Professional",
  FE_49_HZY_TEMPLATE_SCENECOMPLEXITY: "Scene Complexity",
  FE_49_HZY_TEMPLATE_TUTORIAL: "View Tutorial",
  FE_49_HZY_TEMPLATE_UICOMPLEXITY: "UI Complexity",
  FE_49_TYC_PHYS_FREEZE_POS_X: "Lock position - x",
  FE_49_TYC_PHYS_FREEZE_POS_Y: "Lock position - y",
  FE_49_TYC_PHYS_FREEZE_POS_Z: "Lock position - z",
  FE_49_TYC_PHYS_FREEZE_ROT_X: "Lock rotation - x",
  FE_49_TYC_PHYS_FREEZE_ROT_Y: "Lock rotation - y",
  FE_49_TYC_PHYS_FREEZE_ROT_Z: "Lock rotation - z",
  FE_49_TYC_PHYS_HINT_ANGULAR_DRAG: "Apply a torque to the object that is proportional to its current angular velocity and in the opposite direction, causing the object to gradually stop rotating",
  FE_49_TYC_PHYS_HINT_DRAG: "Apply a force to the object that is proportional to its current linear velocity and in the opposite direction, causing the object to gradually slow down in the absence of external forces",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS: "The bounciness of an object in physics simulation.",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS_COMBINATION: `This property determines how bounciness is calculated when two objects collide in a physics simulation: 
Average: Uses the average of two values.
Minimum: Uses the smaller of the two values
Multiply: Multiplies the two bounciness values
Maximum: Uses the larger of the two values

When two objects have different settings, the priority order is: Average < Minimum < Multiple < Maximum.`,
  FE_49_TYC_PHYS_MAT_HINT_DYNAMIC_FRICTION: "The kinetic friction value of an object in a physics simulation",
  FE_49_TYC_PHYS_MAT_HINT_FRICTION_COMBINATION: `This property determines how friction is calculated when two objects collide in a physics simulation: 
Average: Uses the average of two friction values.
Minimum: Uses the smaller of the two friction values
Multiply: Multiplies the two friction values
Maximum: Uses the larger of the two friction values

When two objects have different settings, the priority order is: Average < Minimum < Multiple < Maximum. For example, if one object is set to "Average" and the other "Maximum", the collision will use the Maximum method and apply the larger friction value, resulting in stronger friction effects.`,
  FE_49_TYC_PHYS_MAT_HINT_STATIC_FRICTION: "The static friction value of an object in a physics simulation",
  FE_49_TYC_PHYS_OPTIMIZATION_MAX: "Max. Optimization",
  FE_49_TYC_PHYS_OPTIMIZATION_MEDIUM: "Medium Optimization",
  FE_49_TYC_PHYS_OPTIMIZATION_MIN: "Slight Optimization",
  FE_49_TYC_PHYS_OPTIMIZATION_NONE: "None",
  FE_49_TYC_SHADER_SKYBOX_ENUM_MAIN_COLOR: "Use light source color of the scene",
  FE_49_TYC_SHADER_SKYBOX_ENUM_SUN_COLOR: "Use color of the sun",
  FE_49_TYC_SHADER_SKYBOX_EXPOSURE: "Exposure",
  FE_49_TYC_SHADER_SKYBOX_GROUND_COLOR: "Ground Color",
  FE_49_TYC_SHADER_SKYBOX_GROUND_GRADIENT: "Ground Gradient",
  FE_49_TYC_SHADER_SKYBOX_GROUND_HORIZON_COLOR: "Ground Horizon Color",
  FE_49_TYC_SHADER_SKYBOX_ROTATION: "Rotation",
  FE_49_TYC_SHADER_SKYBOX_SKY_COLOR: "Sky Color",
  FE_49_TYC_SHADER_SKYBOX_SKY_GRADIENT: "Sky Gradient",
  FE_49_TYC_SHADER_SKYBOX_SKY_HORIZON_COLOR: "Sky Horizon Color",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR: "Sun Color",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR_MODE: "Sun Color Mode",
  FE_49_TYC_SHADER_SKYBOX_SUN_SIZE: "Sun Size",
  FE_49_TYC_SHADER_SKYBOX_TEX_BACK: "Back Shader",
  FE_49_TYC_SHADER_SKYBOX_TEX_DOWN: "Bottom Shader",
  FE_49_TYC_SHADER_SKYBOX_TEX_FRONT: "Front Shader",
  FE_49_TYC_SHADER_SKYBOX_TEX_LEFT: "Left Shader",
  FE_49_TYC_SHADER_SKYBOX_TEX_RIGHT: "Right Shader",
  FE_49_TYC_SHADER_SKYBOX_TEX_UP: "Top Shader",
  FE_49_TYC_SHADER_SKYBOX_TINT_COLOR: "Color",
  FE_49_TYC_SKY_CUSTOM_MATERIAL: "Skybox Material",
  FE_49_TYC_SKY_MAT_TYPE_WARNING: "Materials and shaders compatible with the Skybox are recommended",
  FE_49_XXJ_CUSTOMEVENT: "Custom Event",
  FE_49_XXJ_EVENT: "Code-Defined Events",
  FE_49_XXJ_EVENTMGR: "Event Manager",
  FE_49_XXJ_EVENTPRAM: "Send Event Parameters",
  FE_49_XXJ_EVENTPRAM_D: "When sending a custom event, you can choose to pass some data through parameters. Here are the pre-configured parameter names and types.",
  FE_49_XXJ_NOEVENT: "No custom event",
  FE_49_XXJ_PERFORMANCE_1: "Choose a Performance asset to start editing",
  FE_49_XXJ_PERFORMANCE_10: "Pause",
  FE_49_XXJ_PERFORMANCE_11: "Jump to start",
  FE_49_XXJ_PERFORMANCE_12: "Jump to finish",
  FE_49_XXJ_PERFORMANCE_13: "Move forward 1 frame",
  FE_49_XXJ_PERFORMANCE_14: "Move back 1 frame",
  FE_49_XXJ_PERFORMANCE_15: "Play Range",
  FE_49_XXJ_PERFORMANCE_16: "Manage sub-tracks",
  FE_49_XXJ_PERFORMANCE_17: "Locked",
  FE_49_XXJ_PERFORMANCE_18: "Muted",
  FE_49_XXJ_PERFORMANCE_19: "Receiver",
  FE_49_XXJ_PERFORMANCE_2: "Open Asset Selector",
  FE_49_XXJ_PERFORMANCE_20: "Previewing",
  FE_49_XXJ_PERFORMANCE_21: "Unable to edit because bound actor track and unbound actor track are selected at the same time",
  FE_49_XXJ_PERFORMANCE_3: "Group Track",
  FE_49_XXJ_PERFORMANCE_4: "Length calculation method",
  FE_49_XXJ_PERFORMANCE_5: "Fixed",
  FE_49_XXJ_PERFORMANCE_6: "Auto-Calculate",
  FE_49_XXJ_PERFORMANCE_7: "Start recording",
  FE_49_XXJ_PERFORMANCE_8: "Stop recording",
  FE_49_XXJ_PERFORMANCE_9: "Start playing",
  FE_49_XXJ_RECEIVEEVENT: "On Receive Event {0}",
  FE_49_XXJ_RECEIVERTYPE: "Receiver Type",
  FE_49_XXJ_RECEIVERTYPE_D: `When sending a custom event, the entity receiving the event must be specified as a parameter. This is a preconfigured setting for the receiver's entity type. Choose the specific type, and the editor will also assist with checking the entity type. If the type is uncertain, select "Entity" as the receiver's type.`,
  FE_49_XXJ_SENDEVENT: "Send event {0}",
  FE_49_XYL_GAMEPLAYOBJECTTIPDESC: "Objects that have gameplay features",
  FE_49_ZCS_FEASSETSTORENOT_SUPPORT_ITEM: "No item to select",
  FE_49_ZCS_FEASSETSTORE_CLPACKAGE: "Asset Type",
  FE_49_ZCS_FEASSETSTORE_CLSETTING: "Craftland Upload Setting",
  FE_49_ZCS_FEASSETSTORE_COMMON_CANTUPLOAD_ITEMBYTES: "Your project cannot be uploaded as a streaming asset",
  FE_49_ZCS_FEASSETSTORE_COST: "Cost",
  FE_49_ZCS_FEASSETSTORE_CUSTOM_SELECTION: "Custom Selection",
  FE_49_ZCS_FEASSETSTORE_DEFAULTTEXT_UI: "Provide information about the object {0}",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_CATAGORY: "Default Category",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_VALUE: "Default Value",
  FE_49_ZCS_FEASSETSTORE_ENTITYTYPE: "Entity Type",
  FE_49_ZCS_FEASSETSTORE_ERROR_ASSET_SELECT: "You may only select under the asset category to package",
  FE_49_ZCS_FEASSETSTORE_ERROR_CANTBUILD: "No asset selected for package yet",
  FE_49_ZCS_FEASSETSTORE_ERROR_NOASSET: "No asset found",
  FE_49_ZCS_FEASSETSTORE_EXPAND_DETAIL: "Expand",
  FE_49_ZCS_FEASSETSTORE_EXPORT_ALL: "Export All",
  FE_49_ZCS_FEASSETSTORE_FESETTING: "Craftland Studio Upload Settings",
  FE_49_ZCS_FEASSETSTORE_HIDE_SOURCEFILE: "Hide Source File",
  FE_49_ZCS_FEASSETSTORE_ITEMBYTES_ADVANCED: 'You may edit "manifest" and "description.ecad" manually for more advanced features',
  FE_49_ZCS_FEASSETSTORE_ITEM_CATAGORY: "Item Category",
  FE_49_ZCS_FEASSETSTORE_ITEM_DESC: "Description",
  FE_49_ZCS_FEASSETSTORE_ITEM_NAME: "Item Name",
  FE_49_ZCS_FEASSETSTORE_MAX_VALUE: "Max. Value",
  FE_49_ZCS_FEASSETSTORE_MIN_VALUE: "Min. Value",
  FE_49_ZCS_FEASSETSTORE_NOTSELECT_PREFEB: "No prefab selected",
  FE_49_ZCS_FEASSETSTORE_SCALE: "Scale",
  FE_49_ZCS_FEASSETSTORE_SCALING_RANGEERROR: "Range error. Value should be between {0} - {1}",
  FE_49_ZCS_FEASSETSTORE_SCALING_SIZEERROR: "Size error. Please make sure the min. value is smaller than the max. value",
  FE_49_ZCS_FEASSETSTORE_SELECTION_SIZE: "Selection Size",
  FE_49_ZCS_FEASSETSTORE_SELECTION_TIP: "Select one item from the package to use",
  FE_49_ZCS_FEASSETSTORE_SELECT_PLATFORMS: "Choose the publishing platform",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_ANNO: "No selectable item",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_COST: "Total Cost",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO: "Small Item Info",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO_TIPS: "This asset is from the original asset pack. You may use it alone or in combination with other assets",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_SELECTALL: "Select All",
  FE_49_ZCS_FEASSETSTORE_STEP_VALUE: "Step Value",
  FE_49_ZCS_FEASSETSTORE_TAG_NOTICE: "Enter text to create custom tag",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_ALL: "All",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_CL: "Craftland",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_DUAL: "Dual Platform",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_FE: "Craftland Studio",
  FE_49_ZCS_PREFABCHANGE_WARNING: "Your actions will modify the structure of the prefab, but the prefabs in the scene will remain unchanged. Please replace them manually.",
  FE_50A_M_UNPUBLISH: "Unpublish",
  FE_50A_M_UNPUBLISH2: "Unpublishing the project... Please wait",
  FE_50A_SJZ_MANAGE_ASAVESC: "Autosave successful",
  FE_50A_SJZ_MANAGE_ASAVETIME: "Autosave Interval",
  FE_50A_SJZ_MANAGE_HOUR: "{0}h",
  FE_50A_SJZ_MANAGE_MIN: "{0}m",
  FE_50A_SJZ_MANAGE_NEVER: "Never",
  FE_50A_SJZ_MANAGE_SAVEAS: "Save as",
  FE_50A_SJZ_MANAGE_SAVEASSC: "Successfully saved",
  FE_50A_SJZ_MANAGE_SEC: "{0}s",
  FE_50A_SJZ_SEL_ACT: "Inactive",
  FE_50A_SJZ_SEL_HID: "Hidden",
  FE_50A_SJZ_SEL_LOC: "Locked",
  FE_50A_SJZ_SEL_VIS: "Invisible",
  FE_50A_XXJ_PREVIEW_PREFAB: "Prefab preview is not currently supported.",
  FE_50A_XYL_PREFABSCREENSHOTSGEN: "Generate prefab screenshots",
  FE_50_HJ_COL_ALLCOL: "Set column info",
  FE_50_HJ_COL_COLNUMWARNING: "Max. columns reached",
  FE_50_HJ_COL_ISUID: "UID as Key",
  FE_50_HJ_COL_ISUID_TIP: "Use player's UID as Key",
  FE_50_HJ_COL_KEYNAME: "KEY",
  FE_50_HJ_COL_TABLENAME: "Multi-column Data Table",
  FE_50_MX_Action_Enumeration: "Persona {0}'s action enum",
  FE_50_MX_Persona_Action_ID_Check: "Persona {0} action {1} does not exist, please check",
  FE_50_MX_Persona_ID_Check: "Persona {0} does not exist, please check",
  FE_50_M_CANCELPUBLISH: "Publishing canceled, you may republish if needed.",
  FE_50_M_PUBLISHING: "Publishing",
  FE_50_TYC_PTC_ACCELERATION_OVER_LIFETIME: "Particle Acceleration Curve",
  FE_50_TYC_PTC_ACCELERATION_OVER_LIFETIME_DESC: "This property determines how the acceleration of the particles changes over lifetime",
  FE_50_TYC_PTC_ANGLE_OVER_LIFETIME: "Particle Angle Curve",
  FE_50_TYC_PTC_ANGLE_OVER_LIFETIME_DESC: "This property determines how the angle of the particles changes over lifetime",
  FE_50_TYC_PTC_ENUM_HORIZONAL_BILLBOARD: "Horizontal Billboard",
  FE_50_TYC_PTC_ENUM_HORIZONAL_BILLBOARD_DESC: "The generated particles are rendered as quad(s) with a direction facing World Y+. When particles rotate, they will spin along the Y+ axis.",
  FE_50_TYC_PTC_ENUM_VERTICAL_BILLBOARD: "Vertical Billboard",
  FE_50_TYC_PTC_ENUM_VERTICAL_BILLBOARD_DESC: "The generated particles are rendered as quad(s) and consistently face the camera along the horizontal plane; when rotating, the rotation axis is aligned with the sheet's normal.",
  FE_50_TYC_PTC_SIZE_OVER_LIFETIME: "Particle Size Curve",
  FE_50_TYC_PTC_SIZE_OVER_LIFETIME_DESC: "This property determines how the size of the particles changes over lifetime",
  FE_50_TYC_PTC_VELOCITY_OVER_LIFETIME: "Particle Velocity Curve",
  FE_50_TYC_PTC_VELOCITY_OVER_LIFETIME_DESC: "This property determines how the velocity of the particles changes over lifetime",
  FE_50_TYC_TRS: "Interpolate",
  FE_50_TYC_TRS_BLEND_RATIO: "Applied Ratio",
  FE_50_TYC_TRS_BLEND_RATIO_DESC: "Adjust the proportion of predicted values applied. For example, 0.8 means using 20% of the current data and 80% of the predicted data as the final result.",
  FE_50_TYC_TRS_ENUM_EXTRAPOLATION: "Extrapolation",
  FE_50_TYC_TRS_ENUM_INTRAPOLATION: "Interpolation",
  FE_50_TYC_TRS_INTERPOLATION_METHOD: "Method",
  FE_50_TYC_TRS_INTERPOLATION_METHOD_DESC: `Extrapolation: The object's position is slightly ahead of its actual position, which may cause brief penetration.
Interpolation: The object's position is slightly delayed compared to its actual position, which may reduce some collision jitter.`,
  FE_50_TYC_TRS_MAX_ERROR: "Max. Error",
  FE_50_TYC_TRS_MAX_ERROR_DESC: "If the error exceeds this value, it will be corrected immediately (occasionally resulting in an effect similar to teleportation).",
  FE_50_TYC_TRS_MAX_ERROR_TIME: "Error Correction Time",
  FE_50_TYC_TRS_MAX_ERROR_TIME_DESC: "When the error exceeds this value, a timer will start based on this value, and the error will be forcibly corrected (resulting in an effect similar to teleportation).",
  FE_50_TYC_TRS_MIN_ERROR: "Error Threshold",
  FE_50_TYC_TRS_MIN_ERROR_DESC: "When the error exceeds this value, a timer starts, and the error is then forcibly corrected (resulting in an effect similar to teleportation).",
  FE_50_TYC_TRS_PREDICT_RATIO: "Predict Ratio",
  FE_50_TYC_TRS_PREDICT_RATIO_DESC: `Adjust the extrapolation predict ratio. A value of 1.2, for example, will increase the result by 20%.
If an object's speed changes frequently, this value should be appropriately reduced.`,
  FE_50_XXJ_ACONCE: "Once",
  FE_50_XXJ_ACPOSTEXTRA: "Post-Extrapolate",
  FE_50_XXJ_ACWRAPMODE: "Wrap Mode",
  FE_50_XXJ_PERFORMANCE_BETA: "Performance (beta)",
  FE_50_XXJ_RESLENGTH: "Resource Length",
  FE_50_XXJ_TIMELINE_TRACK_ID: "Track ID",
  FE_50_XXJ_TL_CLIP_RESET_ALL: "Reset all",
  FE_50_XXJ_TL_CLIP_RESET_DURATION: "Reset duration",
  FE_50_XXJ_TL_CLIP_RESET_SPEED: "Reset speed",
  FE_50_XXJ_TL_MISSING_ENTITY: "The selected receiver lacks the {0} component required by this event",
  FE_50_XXJ_TL_PROP_MANAGER: "Manage Property Track",
  FE_51_HJ_FIRE: "Throw grenade",
  FE_51_HJ_FIRE_CRAWL: "Throw grenade while prone",
  FE_51_HJ_FIRE_CROUCH: "Throw grenade while crouching",
  FE_51_HJ_GRENADE_CRAWL: "Prone (with grenade)",
  FE_51_HJ_GRENADE_CROUCH: "Crouch (with grenade)",
  FE_51_HJ_GRENADE_IDLE: "Stand (with grenade)",
  FE_51_HZY_CUSTOMSTORE_BUNDLE: "Bundle",
  FE_51_HZY_CUSTOMSTORE_CUSTOMITEM: "Custom Item",
  FE_51_HZY_FILTER_CUSTOMPROP: "Include custom property",
  FE_51_HZY_GSEARCH: "Search All",
  FE_51_HZY_GSEARCH_SHORTCUT: "Search All Ctrl+K",
  FE_51_HZY_KALAHARI: "Kalahari",
  FE_51_HZY_KALAHARI_D: "This project contains no code. Kalahari is set as the default terrain.",
  FE_51_HZY_NEXTERRA: "NeXTerra",
  FE_51_HZY_NEXTERRA_D: "This project contains no code. NexTerra is set as the default terrain.",
  FE_51_HZY_SEARCH_BLOCK: "Block",
  FE_51_HZY_SEARCH_COMPONENTS: "Components",
  FE_51_HZY_SEARCH_MENU: "Menu",
  FE_51_HZY_SEARCH_NULL: "No results found in {0}",
  FE_51_HZY_SEARCH_UICONTROL: "UI Widget",
  FE_51_HZY_SHADER_APECULARINTENSITY: "Specular Intensity",
  FE_51_HZY_SHADER_CLIPPING: "Clipping",
  FE_51_HZY_SHADER_CONTRAST: "Contrast",
  FE_51_HZY_SHADER_DEST: "Dest",
  FE_51_HZY_SHADER_EMISSIONCOLOR: "Emission Color",
  FE_51_HZY_SHADER_EMISSIONINTENSITY: "Emission Intensity",
  FE_51_HZY_SHADER_EXPRESSIONTEX: "Expression Texture",
  FE_51_HZY_SHADER_EXPRESSIONTEXTO: "Expression Tiling/Offset",
  FE_51_HZY_SHADER_GLOSS: "Gloss",
  FE_51_HZY_SHADER_HAIR1: "Hair Color 1",
  FE_51_HZY_SHADER_HAIR2: "Hair Color 2",
  FE_51_HZY_SHADER_HAIR3: "Hair Color 3",
  FE_51_HZY_SHADER_HAIR4: "Hair Color 4",
  FE_51_HZY_SHADER_HAIRSHIFT: "Hair Shift",
  FE_51_HZY_SHADER_MAKEUPTEX: "Makeup Texture",
  FE_51_HZY_SHADER_MAKEUPTEXTO: "Facepaint Tiling/Offset",
  FE_51_HZY_SHADER_MINIAVATARHAIR: "Hair material for mini characters in Craftland. Supports adjustable parameters like hair texture, normal, lighting, rim lighting, emission, anisotropic highlighting, and more for greater hair customization such as global, highlight, and dip dye.",
  FE_51_HZY_SHADER_MINIAVATARSKIN: "Skin material for mini characters in Craftland. Supports base color gradients, layered expression and facepaint textures. Adjustable parameters include skin tone,  ambient lighting, specular, normal, rim, and more.",
  FE_51_HZY_SHADER_MINIAVATARSTANDARD: "Standard material for mini characters' outfits and props in Craftland. Supports opaque, translucent and Cutoff modes. Adjustable  parameters include custom texture overlays, basic color texture, normal/shine, specular, reflection (MatCap),  emission, and rim.",
  FE_51_HZY_SHADER_MINLIGHTINTENSITY: "Main Light Intensity",
  FE_51_HZY_SHADER_NORMALINTENSITY: "Normal Intensity",
  FE_51_HZY_SHADER_PREMULTIPLAY: "Premultiplay Alpha",
  FE_51_HZY_SHADER_REFELECTION: "Reflection CubeMap",
  FE_51_HZY_SHADER_REFELECTIONTEX: "Reflection MatCap",
  FE_51_HZY_SHADER_RIMCOLOR: "Rim Color",
  FE_51_HZY_SHADER_RIMINTENSITY: "Rim Intensity",
  FE_51_HZY_SHADER_RIMPOWER: "Rim Power",
  FE_51_HZY_SHADER_SER: "R: Specular Mask, G: Emission Mask, B: Reflection Mask",
  FE_51_HZY_SHADER_SHADOWINTENSITY: "Shadow Intensity",
  FE_51_HZY_SHADER_SHADOWSPECULARINTENSITY: "Shadow Specular Intensity",
  FE_51_HZY_SHADER_SHINECOLOR: "Shine Color",
  FE_51_HZY_SHADER_SHINEINTENSITY: "Shine Intensity",
  FE_51_HZY_SHADER_SHINEVALUE: "Shine Value",
  FE_51_HZY_SHADER_SHINEVALUE_D: "Pos(x): Shine's position, Range(y): Shine's range, Length(z): Shine's length",
  FE_51_HZY_SHADER_SKINCOLOR: "Skin Tone",
  FE_51_HZY_SHADER_SOURCE: "Source",
  FE_51_HZY_SHADER_SPECULARCOLOR: "Specular Color",
  FE_51_HZY_SHADER_SPECULARMAP: "Specular Map",
  FE_51_HZY_SHADER_SPECULARVALUE_D: `Pos(x): Specular's Position,
Rnage(y): Specular's Range,
Length(z) Specular's Length`,
  FE_51_HZY_SHADER_TINTCOLOR: "Tint Color",
  FE_51_HZY_SHADER_TOPSPECULARCOLOR: "Specular Color",
  FE_51_HZY_SHADER_TOPSPECULARINTENSITY: "Specular Intensity",
  FE_51_HZY_SHADER_TOPSPECULARVALUE: "Specular Value",
  FE_51_HZY_SOLARA: "Solara",
  FE_51_HZY_SOLARA_D: "This project contains no code. Solara is set as the default terrain.",
  FE_51_MX_IMAGE_READ_WRITE: "Read/Write",
  FE_51_MX_IMAGE_READ_WRITE_TIP: 'Enable "Read/Write" only when script or runtime modification of particle meshes/textures are needed. Disable it otherwise to improve performance.',
  FE_51_MX_PERSONA_NAME: "Character Name",
  FE_51_MX_PERSONA_OBSERVER: "Observer",
  FE_51_MX_PERSONA_UPDATETIME: "Update Time",
  FE_51_MX_VOICE_TIP: "Voice ID: {0} requires block logic to activate",
  FE_51_MX_VOICE_VOICEID: "Voice ID",
  FE_51_MX_VOICE_VOICETITLE: "Voice",
  FE_51_TYC_PHYS_MAT_AVERAGE: "Average",
  FE_51_TYC_PHYS_MAT_DYNAMIC_FRICTION: "Dynamic Friction",
  FE_51_TYC_PHYS_MAT_HINT_DYNAMIC_FRICTION: "The friction coefficient when a rigid body is sliding on a surface.",
  FE_51_TYC_PHYS_MAT_HINT_STATIC_FRICTION: "The friction coefficient when a rigid body is resting",
  FE_51_TYC_PHYS_MAT_MAX: "Max",
  FE_51_TYC_PHYS_MAT_MIN: "Min",
  FE_51_TYC_PHYS_MAT_MULTIPLY: "Multiply",
  FE_51_TYC_PHYS_MAT_STATIC_FRICTION: "Static Friction",
  FE_51_XXJ_ANIMATIONTARGET: "Parent track entity lacks component {0}",
  FE_51_XXJ_ONPROPERTYCHANGE_TIPS: "When enabled, changes to this custom property will send corresponding events to block scripts or code scripts. Note: if the custom property is modified on the server, the event is sent to both server and client; if a local entity's custom property is modified on the client, the event is sent only locally.",
  FE_51_XXJ_PREVIEW_FPV1: "If enabled, the Switch Camera Track will control the preview view, which is the final player view",
  FE_51_XXJ_PREVIEW_FPV2: "Lock Player View",
  FE_51_XYL_CLASSETNOVERSION: "Publishing multiple versions of Craftland assets is currently not supported.",
  FE_51_XYL_PREFAB_NOT_IDENTITY: "Prefab root position offset detected, please check.",
  FE_51_XYL_WRONGACCOUNT: "Account Error",
  FE_OB43_TYC_HIERARCHY_HIDE_SHOW: "Hide/Show",
  FF_47A_HZY_QUICKMESSAGE_LEVEL: "Advanced - Clash Squad",
  OB40A_UP_DB1: "Debugging Feature Update",
  OB40A_UP_DB2: "Added debugging for mid-project, mid-game quitting and, under poor Internet connection.",
  OB40A_UP_T1: "Various user experience enhancements and bug fixes.",
  OB40A_UP_W1: "Weapon Generator",
  OB40A_UP_W2: "Enables refreshing weapon skin designs in scenes when configuring weapon skins in Inspector.",
  OB40_UP_DB1: "Data Storage Function Update",
  OB40_UP_DB2: `1. In the "Data Management" section of the "Data Center", we added new features such as search, sort, and edit.

2. Increased read/write frequency:

- Write frequency per minute: 30 → 40

- Read frequency per minute: 50 → 60`,
  OB40_UP_O1: "Others",
  OB40_UP_O2: `1. Custom collision boxes can be used as triggers.

2. Supports importing and using audio files in Assetbundle format.

3. Added a switch for reconnecting after disconnection, a switch for enable rejoining a match after quitting it, and a switch for AFK detection.

4. Added a new batch of blocks. Please refer to the UGC WIKI for details.`,
  OB40_UP_S1: "Multi-Scene Editing Update",
  OB40_UP_S2: `1. Supports player teleporting to different scenes during a match.

2. Recommended use:

- For projects utilizing the multi-scene feature, it is advised to use empty scenes rather than templates.

- Enabling custom minimap functionality is recommended for customizing minimaps in scenes.

- It is advised not to have overlapping object coordinates in different scenes (.scene files). (Craftland Studio's multi-scene 2.0 version is implemented such that multiple .scene files are combined into one large world map by the server, and each client loads only one .scene file. Having overlapping coordinates can cause issues with the server-side processing logic.)`,
  OB40_UP_T1: "Terrain Editing Function",
  OB40_UP_T2: `1. Introducing the new "Terrain" feature, allowing users to perform terrain-related editing operations.

2. Added plant brush styles.

3. Expanded the editable terrain area to 150*150, now supporting multiple terrain blocks.`,
  OB40_UP_UI1: "UI Editor Update",
  OB40_UP_UI2: `1. Organized the original Panel and Layout components in the "UI Editor" while preserving their original dimensions and anchor point properties. Additionally, new features such as background filling and clipping have been added.

2. The existing Layout functionality has been migrated and reorganized and is now available for use.

3. A new ScrollView component has been introduced with corresponding properties. Use it to create screen scrolling effects and more.

4. All component properties are now accessible and callable within the blocks.`,
  OB41A_UP_1: "Added a feedback channel",
  OB41A_UP_1_D: "1. Tap the question mark icon on the top right corner to leave your feedback.",
  OB41A_UP_2: "Multiple user interaction optimizations.",
  OB41_UP_1: "New Animation State Machine 1.0",
  OB41_UP_1_D: `1. Added an animation state machine function that can add state machines for zombies and prefabs imported from assetbundle.
2. The state machine is a control for purely animations. The states can be switched through writing ECA blocks logic.
3. When there is no state switch to or other states have finished playing, the state will return to idle.`,
  OB41_UP_2: "UI Editor Update",
  OB41_UP_2_D: `1. Interpolation setting blocks now support UI controls.
2. Added 3DContainer, which can be used to add prefabs, such as 3D objects and special effects, to Container and display them on the HUD.
3. Select and replace 3D resources using the resource management function.
4. Enables angle rotation and zoom settings on individual clipped resources.
5. New Texture control and 9-display methods such as 9-grid, tiles, and fill.
6. New fill method for Image (same as those of Texture).
7. New avatar control to help creators obtain and display player information for functions like leaderboards.
8. There are 2 designs for creators to choose from. Creators can also select which player information to display, including nickname, pin, banner, and rank.`,
  OB41_UP_3: "Supports Editing With Scripts",
  OB41_UP_3_D: `1. Updated the plug-in function.
-Error messages
-Text highlighting
-Floating messages
-Definition redirection.
2.Updated the engine support.
3. Added script names. You can now modify script names for the features below by right clicking or using the shortcut key.
-Custom control
-Custom property
-Custom enum
-Enum content
-Custom event
-Block variable
-Custom function
-ECA file`,
  OB41_UP_4: "Data Storage Function Update",
  OB41_UP_4_D: `1. Added a data calculation table.
2. Added the periodically clear leaderboard feature, which can be accessed through Data Management > Manage Archive > Periodic Leaderboard Clearing.
-The cleared setting is linked to a map code.`,
  OB41_UP_5: "Dynamic NavMesh",
  OB41_UP_5_D: `1. Enable this feature by ticking the Dynamic Navmesh box in the procedure settings.
2. When on, the dynamic adding, subtracting, displaying, and shadows of objects without static Navmesh properties and objects that are dymanically generated will affect the NPCs' route search.
3. You can use the debug column to export the running Navmesh file from the current server for viewing purposes.`,
  OB42A_UP_1_D: `1. Optimized the basic features of the Editor.
2. Updated the functions of systems such as the animation state machine and the script system.`,
  OB42_UP_1: "New Asset Store",
  OB42_UP_1_D: `1. The Reference Pack structure: A creator's reference pack is available as a public resource for other users to download.
2. Added reference pack file type to the package import process and enabled root log selection.
3. Login access to the Asset Store and storage.
4. Enabled the main process of "Create > Upload > Download > Import".`,
  OB42_UP_2: "Supports Importing of Skeleton Models and Animations & Other Related Applications",
  OB42_UP_2_D: `1. Supports the import of skeleton models and animation files.
2. Preview animation files and add custom events on the timeline.`,
  OB42_UP_3: "Terrain Editing Optimizations",
  OB42_UP_3_D: `1. New vegetation brush: Trees and Stones.
2. Added shortcuts for quick vegetation erasing. Brush + Shift: Erase all vegetation within range. Brush + Ctrl: Erase only the selected vegetation.
3. Added brush range indication.
4. Optimized the terrain smoothener's sculpting logic and added a brush size adjuster for the terrain flattener.`,
  OB42_UP_4: "New Debug Visualizer Tool",
  OB42_UP_4_D: `1. During debugging, entity properties inside the server can now be viewed and entity location can be modified.
2. View the number of entities in the server and the required storage.`,
  OB42_UP_5: "Physics Optimizations",
  OB42_UP_5_D: `1. You can now create and edit physical materials to add bounce and friction effects to RigidBody.
2. You can now edit the global gravity.
3. You can now put a RigidBody to sleep or awaken it.`,
  OB42_UP_6: "Other Optimizations",
  OB42_UP_6_D: `1. Blocks already in use now support global (cross-script files) searching.
2. Clip references for ECA files now support global searching.`,
  OB43A_UP_1: "Basic Optimizations",
  OB43A_UP_1_D: `1. Optimized display-related features in Project.
2. Added tooltips in Scenery.
3. Addressed the previous issues related to the structural adjustments of Craftland Studio.
4. Fixed other bugs.`,
  OB43_UP_1: "Client Logics",
  OB43_UP_1_D: `1. Added ECAC and FCGC files for creating client-related blocks and script logics.
2. Interoperable blocks will show in both ECA and ECAC files, while those that are not interoperable and are unique to one side will only show in their respective files.
3. Communication between server and client scripts is now supported through custom events.`,
  OB43_UP_2: "Structural Optimizations",
  OB43_UP_2_D: `1. Updated the structures of Craftland Studio.
2. Changed file management from the editor level to the file level.
3. Updated and expanded the menu bar.
4. Changed the locations of the toolbar/debug features/debug settings.
5. Removed survey feedback and account management.
6. Disabled the template feature.`,
  OB43_UP_3: "New Camera Feature",
  OB43_UP_3_D: '1. Added the new First Person Model feature. Must select "Use the latest FPP resources" to use it. Currently only available for the SCAR.',
  OB43_UP_4: "New Physics Feature",
  OB43_UP_4_D: "1. Added the character controller feature",
  OB43_UP_5: "Update & Editor Optimizations",
  OB43_UP_5_D: `1. Allows for auto-update. When Craftland Studio starts, it will automatically check for version updates and notify the users if there is a new version available.
2. Added Check  Updates to the menu. Use it to check for new versions.
3. Enhanced the performance of the block editor and reduced stutters when working with a large number of blocks.
4. Optimized the performance of Scenery and the movement logic of multiple selected objects.
5. Added the debug UI to Scenery.`,
  OB43_UP_6: "Custom Characters",
  OB43_UP_6_D: `1. Supports entering the game with the selected Free Fire Character/Preset Character (file).
2. Creates a new file type to store all the configuration information of Preset Characters.
3. Preset Character allows for configuration of character models and most of the character motions required.
4. Provides Free Fire rig files for users.`,
  OB43_UP_7: "Map Optimizations",
  OB43_UP_7_D: `1. Added the Static feature, which allows for local rendering of objects without logic processing to optimize performance.
2. Allows for customization of streaming scene objects to control their loading logic on the client (which requires Static to be enabled).
3. Upgraded the previous Batching feature to Rendering Performance Optimization, which provides options such as batching and model merging. See details in the official documents of Craftland Studio.
4. Reduced the download size of custom assets.`,
  OB43_UP_8: "New Scripting Features",
  OB43_UP_8_D: `1. Added the script asset registration feature.
2. Added the quick access to function definitions in script plug-ins.`,
  OB44_UP_1: "Client Logic",
  OB44_UP_1_D: `1. More APIs supporting client logic will be available.
2. You can opt in or out for data sync for scene objects in their property settings.`,
  OB44_UP_2: "Performance-Related Optimizations",
  OB44_UP_2_D: `1. Added the scene loading range settings for the game server to lower memory consumption.
2. Allows scene objects to have the static pathfinding feature disabled.\\3. Added automatic mesh decimation based on different sizes and distances for models.`,
  OB44_UP_3: "Other Optimizations",
  OB44_UP_3_D: `1. Scripting now supports unit testing, automatic plug-in updates, and direct definition of custom content.
2. Added the classic Free Fire first-person perspective camera.
3. Enhanced the physics system for greater robustness, allowing more in-game objects to be governed by physics.
4. Optimized the overall user experience.`,
  T_0_B_BotCanRevive: "Bot Revival",
  T_0_B_ReviveCDTime: "Revival Cooldown",
  T_37_M_WS_CONTENTERROR: "Content error. Please change.",
  T_37_M_WS_PARANULL: "Property value cannot be empty. Please input a property.",
  T_37_WT_M_PARACHANGE: "Setting failed. Max. room parameters reached.",
  T_38_M_WS_CONFIG: "Parameter Configuration",
  T_38_M_WS_CREATECONFIG: "Room Parameter Configuration",
  T_38_M_WS_CREATEDEL: "Remove From Room Parameter",
  T_38_M_WS_CREATENAME: "Room Parameter Name",
  T_38_M_WS_DELATT: "Delete Property",
  T_38_M_WS_DELATTTIPS: "This property has been converted to the Room Parameter type. Confirm to delete this property?",
  T_38_M_WS_DISPLAYMODE: "Parameter Display",
  T_38_M_WS_DOWN: "Shift Down",
  T_38_M_WS_EDIT: "Edit Parameter",
  T_38_M_WS_MODIFY: "Change To Room Parameter",
  T_38_M_WS_MUTIPLE: "Multiple-Choice List",
  T_38_M_WS_RANGE: "Range",
  T_38_M_WS_ROOMPAR: "Custom Room Parameter",
  T_38_M_WS_SINGLE: "Single-Choice List",
  T_38_M_WS_UP: "Shift Up",
  T_46_TYC_ADD_SP_ERROR: "AOI setup error: failed to add to watchlist. Observee = {0}, observer = {1}.",
  T_46_TYC_AOI_SP_PARAMS_ERROR: "AOI setup error: parameter error. Observee = {0}, observer = {1}.",
  T_46_TYC_AOI_SUPO_INVALID_OBSERVER_ERROR: "AOI setup error: the observee is not a valid player or Transform entity while switching the observer. Observee = {0}, observer = {1}.",
  T_46_TYC_AOI_SUPO_INVALID_USER_ERROR: "AOI setup error: the player is not a valid user while switching the observer. Observee = {0}, observer = {1}.",
  T_46_TYC_AOI_SUPO_PARAMS_ERROR: "AOI setup error: observer proxy parameter switching error. Observee = {0}, observer = {1}.",
  T_46_TYC_CLEAN_SP_ERROR: "AOI setup error: failed to clear watchlist. Observee = {0}.",
  T_46_TYC_REMOVE_SP_ERROR: "AOI setup error: failed to remove from watchlist. Observee = {0}, observer = {1}.",
  T_46_TYC_SP_INVALID_USER_ERROR: "AOI setup error: illegal observer. Observee = {0}, observer = {1}.",
  T_47_HL_CL_RECOMMEND_MORE: "View More",
  T_ACTIVATE_LOGIN_ACCOUNT: "Logged in account:",
  T_ACTIVATE_TITLE: "Craftland Studio Activation",
  T_CONFIRMBOX_ACTIVATE_SUCCESS: "Account is activated",
  T_CONFIRMBOX_QUIT_CONTENT: "Doing so will quit Craftland Studio. Confirm operation?",
  T_CONFIRMBOX_TITLE: "Notification",
  T_DIALOG_CONFIRM: "Activate",
  T_ENTER_ACTIVATE_CODE: "Craftland Studio is in the testing. Please enter the activation code provided by the official.",
  UI_DES: "Table layout is often used to build backpack systems, as it makes organizing child elements faster",
  UI_DES_1: "Fill layout can be used to quickly add child elements evenly under a parent element",
  UI_NAME: "Table layout sample",
  UI_NAME_1: "Fill layout sample"
};
export {
  _ as default
};
